import React, { useEffect, useMemo, useState, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import $ from 'jquery';
import dayjs from 'dayjs';
import './css/index.css';
import RefreshContext from './RefreshContext';
import ReactApexChart from 'react-apexcharts';
import DataTable from 'react-data-table-component';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  LineChart,Line,
  PieChart,
  Pie,
  Cell,LabelList,
  Legend,
  AreaChart,
  Area,
  XAxis,BarChart, Bar,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  ScatterChart,
  Scatter,
  ZAxis,
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis
} from 'recharts';
import MtdDashboard from './MtdDashboard';

// Dashboard cards ko number-wise order dena ho to bas yahan value change karo.
const DASHBOARD_CARD_ORDER = {
  requirements: 1,
  campaignPerformance: 2,
  lineUp: 3,
  onboarding: 4,
  leadData: 5,
};
const DASHBOARD_STAT_COLOR_MAP = {
  "bg-teal-500": "#14b8a6",
  "bg-emerald-500": "#10b981",
  "bg-green-500": "#22c55e",
  "bg-blue-500": "#3b82f6",
  "bg-primary-blue": "#2563eb",
  "bg-yellow-500": "#f59e0b",
  "bg-amber-500": "#f59e0b",
  "bg-orange-500": "#f97316",
  "bg-red-500": "#ef4444",
  "bg-rose-500": "#f43f5e",
  "bg-purple-500": "#8b5cf6",
  "bg-indigo-500": "#6366f1",
  "bg-gray-500": "#6b7280",
  "bg-secondary": "#64748b",
};
const resolveDashboardStatColor = (raw, index = 0) => {
  const fallbackPalette = ["#2563eb", "#f59e0b", "#ef4444", "#10b981", "#6366f1"];
  if (!raw) return fallbackPalette[index % fallbackPalette.length];
  if (String(raw).startsWith("#")) return String(raw);
  return DASHBOARD_STAT_COLOR_MAP[String(raw)] || fallbackPalette[index % fallbackPalette.length];
};
const DashboardStatGlyph = ({ type = "briefcase", className = "" }) => {
  const iconClass = className || "h-5 w-5";
  const common = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  if (type === "clock") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <circle cx="12" cy="12" r="8" {...common} />
        <path d="M12 7.5v4.5l3 1.8" {...common} />
      </svg>
    );
  }
  if (type === "check") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <circle cx="12" cy="12" r="8" {...common} />
        <path d="m8.5 12.3 2.2 2.2 4.8-5.1" {...common} />
      </svg>
    );
  }
  if (type === "money") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <rect x="4" y="7" width="16" height="10" rx="2" {...common} />
        <circle cx="12" cy="12" r="2.2" {...common} />
        <path d="M7 10h.01M17 14h.01" {...common} />
      </svg>
    );
  }
  if (type === "user") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <circle cx="12" cy="9" r="3" {...common} />
        <path d="M6.5 18a6.5 6.5 0 0 1 11 0" {...common} />
      </svg>
    );
  }
  if (type === "file") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <path d="M8 4.5h5l3 3V19a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 7 19V6a1.5 1.5 0 0 1 1-1.5Z" {...common} />
        <path d="M13 4.5V8h3.5" {...common} />
        <path d="M9.5 12h5M9.5 15h5" {...common} />
      </svg>
    );
  }
  if (type === "bank") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <path d="M4 9.5 12 5l8 4.5" {...common} />
        <path d="M6.5 10.5V17M10 10.5V17M14 10.5V17M17.5 10.5V17M4.5 19h15" {...common} />
      </svg>
    );
  }
  if (type === "idcard") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <rect x="4" y="6.5" width="16" height="11" rx="2" {...common} />
        <circle cx="9" cy="11" r="1.5" {...common} />
        <path d="M7.2 14a2.8 2.8 0 0 1 3.6 0M13.5 10h3.5M13.5 13h3.5" {...common} />
      </svg>
    );
  }
  if (type === "selection") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <rect x="5" y="5.5" width="14" height="14" rx="2" {...common} />
        <path d="m8.5 12 2.2 2.2 4.8-5.2" {...common} />
      </svg>
    );
  }
  if (type === "join") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <path d="M10 7.5H6.5A1.5 1.5 0 0 0 5 9v6a1.5 1.5 0 0 0 1.5 1.5H10" {...common} />
        <path d="M13 8.5 17 12l-4 3.5M8 12h9" {...common} />
      </svg>
    );
  }
  if (type === "building") {
    return (
      <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
        <path d="M7 20V6.5A1.5 1.5 0 0 1 8.5 5h7A1.5 1.5 0 0 1 17 6.5V20" {...common} />
        <path d="M9.5 8.5h1M13.5 8.5h1M9.5 12h1M13.5 12h1M11 20v-3h2v3" {...common} />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
      <path d="M7 7.5h10v9H7z" {...common} />
      <path d="M9.5 5.5v2M14.5 5.5v2M9 11h6M9 14h4" {...common} />
    </svg>
  );
};
const resolveLineupGlyph = (label) => {
  const text = String(label || "").toLowerCase();
  if (text.includes("total")) return "list";
  if (text.includes("selection") || text.includes("selected")) return "selection";
  if (text.includes("joining") || text.includes("joined")) return "join";
  if (text.includes("onboard")) return "idcard";
  if (text.includes("payroll")) return "money";
  if (text.includes("hold") || text.includes("pending")) return "clock";
  return "briefcase";
};
const resolveOnboardingGlyph = (label) => {
  const text = String(label || "").toLowerCase();
  if (text.includes("complete") || text.includes("done")) return "check";
  if (text.includes("document") || text.includes("doc")) return "file";
  if (text.includes("bank")) return "bank";
  if (text.includes("joining")) return "join";
  if (text.includes("payroll")) return "money";
  if (text.includes("pending") || text.includes("hold")) return "clock";
  if (text.includes("active") || text.includes("onboard")) return "user";
  return "idcard";
};
const resolveVendorGlyph = (label) => {
  const text = String(label || "").toLowerCase();
  if (text.includes("approved") || text.includes("active") || text.includes("completed")) return "check";
  if (text.includes("pending") || text.includes("review") || text.includes("hold")) return "clock";
  if (text.includes("document") || text.includes("kyc") || text.includes("compliance")) return "file";
  if (text.includes("bank") || text.includes("payment") || text.includes("paid") || text.includes("pay")) return "money";
  if (text.includes("rejected") || text.includes("inactive") || text.includes("unpaid")) return "building";
  if (text.includes("new") || text.includes("onboard") || text.includes("total")) return "building";
  return "building";
};

function ExternalDashboard({ autoFetchOnMount = false }) {
  const normalizeAnchorMatchKey = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const buildAnchorCandidatesForUser = (user) => {
    const candidates = new Set();
    const displayName = user?.displayName || "";
    const username = user?.username || "";

    const push = (val) => {
      const norm = normalizeAnchorMatchKey(val);
      if (norm) candidates.add(norm);
    };

    push(displayName);
    push(username);

    const localPart = String(username || "").split("@")[0] || "";
    if (localPart) {
      push(localPart);
      push(localPart.replace(/[._-]+/g, " "));
    }

    return Array.from(candidates);
  };

  const applyBusinessManagerAnchorFilter = (dataObject, user) => {
    if (!dataObject || typeof dataObject !== "object") return dataObject;
    const role = String(user?.role || "").toLowerCase();
    if (role !== "business_manager") return dataObject;

    const candidates = buildAnchorCandidatesForUser(user);
    if (candidates.length === 0) return dataObject;

    const filterRows = (rows) => {
      const list = Array.isArray(rows) ? rows : [];
      return list.filter((row) => {
        const anchor = row?.clientAnchorName || "";
        const normAnchor = normalizeAnchorMatchKey(anchor);
        if (!normAnchor) return false;
        return candidates.includes(normAnchor);
      });
    };

    return {
      ...dataObject,
      tS_Details: filterRows(dataObject.tS_Details),
      prL_Details: filterRows(dataObject.prL_Details),
      invoice_Details: filterRows(dataObject.invoice_Details),
      invoiceOutStand_Details: filterRows(dataObject.invoiceOutStand_Details),
      draftInvoice_Details: filterRows(dataObject.draftInvoice_Details),
    };
  };

  const getLocalDateString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getLast7DaysRange = () => {
    const today = new Date();
    const from = new Date(today);
    from.setDate(today.getDate() - 6);
    return {
      from: getLocalDateString(from),
      to: getLocalDateString(today),
    };
  };

  const initialRange = getLast7DaysRange();
  const [fromDate, setFromDate] = useState(initialRange.from);
  const [toDate, setToDate] = useState(initialRange.to);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [dashboardData, setDashboardData] = useState(null);
  const [currentTab, setCurrentTab] = useState("timesheet");
  const [clientFilter, setClientFilter] = useState("all");
  const [claimLoadingRef, setClaimLoadingRef] = useState(null);
  const [statusSavingRef, setStatusSavingRef] = useState(null);
  const [openInvoiceStatusRef, setOpenInvoiceStatusRef] = useState(null);
  const [statusGuardRef, setStatusGuardRef] = useState(null);
  const [draftInvoiceStatusFilter, setDraftInvoiceStatusFilter] = useState("all");
  const [isDraftStatusMenuOpen, setIsDraftStatusMenuOpen] = useState(false);
  const [payrollTransactionFilter, setPayrollTransactionFilter] = useState("");
  const [showPayrollTransactionSearch, setShowPayrollTransactionSearch] = useState(false);
  const [payrollStatusFilter, setPayrollStatusFilter] = useState("");
  const [showPayrollStatusMenu, setShowPayrollStatusMenu] = useState(false);
  const [timesheetChartClientSearch, setTimesheetChartClientSearch] = useState("");
  const [timesheetChartTopN, setTimesheetChartTopN] = useState("10");
  const [payrollChartClientSearch, setPayrollChartClientSearch] = useState("");
  const [payrollChartTopN, setPayrollChartTopN] = useState("10");
  const [invoiceChartClientSearch, setInvoiceChartClientSearch] = useState("");
  const [invoiceChartTopN, setInvoiceChartTopN] = useState("10");
  const [outstandingInvoiceChartClientSearch, setOutstandingInvoiceChartClientSearch] = useState("");
  const [outstandingInvoiceChartTopN, setOutstandingInvoiceChartTopN] = useState("10");
  const [draftInvoiceChartClientSearch, setDraftInvoiceChartClientSearch] = useState("");
  const [draftInvoiceChartTopN, setDraftInvoiceChartTopN] = useState("10");
  const [tableSearchByTab, setTableSearchByTab] = useState({
    timesheet: "",
    payroll: "",
    invoice: "",
    outstandingInvoice: "",
    draftInvoice: "",
  });
  const [currentExternalUser, setCurrentExternalUser] = useState({ username: null, displayName: null, role: "" });
  const [accountsStaffOptions, setAccountsStaffOptions] = useState([]);
  const [accountsStaffLoading, setAccountsStaffLoading] = useState(false);
  const [reassignMenuRef, setReassignMenuRef] = useState(null);
  const [reassignLoadingRef, setReassignLoadingRef] = useState(null);
  
  const dashboardApiUrl =`${apiurl}externaldashboard.php`;
  const isAccountsHeadUser = (currentExternalUser?.role || "").toString().toLowerCase() === "accounts_head";
  const invoiceStatusOptions = useMemo(
    () => [
      { value: "pending", label: "Pending" },
      { value: "process", label: "Processed" },
      { value: "in_progress", label: "In Progress" },
      { value: "on_hold", label: "On Hold" },
    ],
    []
  );
  const draftInvoiceStatusFilterOptions = useMemo(
    () => [{ value: "all", label: "All Status" }, ...invoiceStatusOptions],
    [invoiceStatusOptions]
  );

  const clients = useMemo(() => {
    if (!dashboardData) return [];
    const clientSet = new Set();
    (dashboardData.tS_Details || []).forEach((item) => clientSet.add(item.clientName));
    (dashboardData.prL_Details || []).forEach((item) => clientSet.add(item.clientName));
    (dashboardData.invoice_Details || []).forEach((item) => clientSet.add(item.clientName));
    (dashboardData.invoiceOutStand_Details || []).forEach((item) => clientSet.add(item.clientName));
    (dashboardData.draftInvoice_Details || []).forEach((item) => clientSet.add(item.clientName));
    return Array.from(clientSet).sort();
  }, [dashboardData]);

  const clientOptions = useMemo(
    () => [
      { value: "all", label: "All Clients" },
      ...clients.map((client) => ({ value: client, label: client })),
    ],
    [clients]
  );

  const formatRupee = (value) =>
    `₹${Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

  const formatDateTime = (value) => {
    if (!value) return "-";
    const dt = new Date(value);
    if (Number.isNaN(dt.getTime())) return String(value);
    return dt.toLocaleString();
  };

  const formatDateOnly = (value) => {
    if (!value) return "N/A";
    const dt = new Date(value);
    if (!Number.isNaN(dt.getTime())) return dt.toLocaleDateString();
    const text = String(value).trim();
    if (text.includes(" ")) return text.split(" ")[0];
    if (text.includes("T")) return text.split("T")[0];
    return text;
  };

  const toTimestamp = (value) => {
    if (!value) return null;
    const dt = new Date(value);
    if (!Number.isNaN(dt.getTime())) return dt.getTime();
    return null;
  };

  const normalizeInvoiceStatus = (value) => {
    const normalized = String(value || "pending")
      .trim()
      .toLowerCase()
      .replace(/-/g, "_")
      .replace(/\s+/g, "_");
    if (normalized === "inprogress") return "in_progress";
    if (normalized === "processing") return "process";
    if (["pending", "process", "in_progress", "on_hold"].includes(normalized)) {
      return normalized;
    }
    return "pending";
  };

  const getInvoiceStatusValue = (value) => {
    const normalized = normalizeInvoiceStatus(value);
    return (
      invoiceStatusOptions.find((option) => option.value === normalized)?.value ||
      invoiceStatusOptions[0].value
    );
  };

  const getInvoiceStatusMeta = (value) => {
    const normalized = getInvoiceStatusValue(value);
    const base = {
      pending: {
        label: "Pending",
        dot: "bg-slate-400",
        chip: "bg-slate-100 text-slate-700 border-slate-200",
      },
      process: {
        label: "Processed",
        dot: "bg-blue-500",
        chip: "bg-blue-100 text-blue-700 border-blue-200",
      },
      in_progress: {
        label: "In Progress",
        dot: "bg-amber-500",
        chip: "bg-amber-100 text-amber-700 border-amber-200",
      },
      on_hold: {
        label: "On Hold",
        dot: "bg-rose-500",
        chip: "bg-rose-100 text-rose-700 border-rose-200",
      },
    };
    return base[normalized] || base.pending;
  };

  const chartPalette = ["#0f766e", "#0ea5e9", "#f59e0b", "#ef4444", "#6366f1", "#10b981", "#f97316"];

  const toNumber = (value) => {
    const num = Number((value ?? "").toString().replace(/[^0-9.\-]/g, ""));
    return Number.isFinite(num) ? num : 0;
  };

  const escapeRegExp = (value) => String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const extractTextFromNode = (node) => {
    if (node === null || node === undefined || typeof node === "boolean") return "";
    if (typeof node === "string" || typeof node === "number") return String(node);
    if (Array.isArray(node)) return node.map((item) => extractTextFromNode(item)).join(" ");
    if (React.isValidElement(node)) return extractTextFromNode(node.props?.children);
    return "";
  };

  const renderHighlightedText = (text, query) => {
    const source = String(text ?? "");
    const search = String(query || "").trim();
    if (!search) return source;
    const regex = new RegExp(`(${escapeRegExp(search)})`, "ig");
    const parts = source.split(regex);
    return (
      <>
        {parts.map((part, idx) =>
          part.toLowerCase() === search.toLowerCase() ? (
            <mark key={`${part}-${idx}`} className="bg-yellow-200 text-inherit px-0.5 rounded">
              {part}
            </mark>
          ) : (
            <React.Fragment key={`${part}-${idx}`}>{part}</React.Fragment>
          )
        )}
      </>
    );
  };

  const highlightNodeText = (node, query) => {
    const search = String(query || "").trim();
    if (!search) return node;
    if (node === null || node === undefined || typeof node === "boolean") return node;
    if (typeof node === "string" || typeof node === "number") {
      return renderHighlightedText(node, search);
    }
    if (Array.isArray(node)) {
      return node.map((item, idx) => <React.Fragment key={idx}>{highlightNodeText(item, search)}</React.Fragment>);
    }
    if (React.isValidElement(node)) {
      if (node.props?.children === undefined) return node;
      return React.cloneElement(node, {
        ...node.props,
        children: highlightNodeText(node.props.children, search),
      });
    }
    return node;
  };

  const pickValueFromKeys = (row, valueKey) => {
    if (!valueKey) return 1;
    if (Array.isArray(valueKey)) {
      for (const key of valueKey) {
        const value = row?.[key];
        if (value !== undefined && value !== null && `${value}`.trim() !== "") {
          return toNumber(value);
        }
      }
      return 0;
    }
    return toNumber(row?.[valueKey]);
  };

  const buildGroupedSeries = (rows, labelKey, valueKey = null, limit = 6, valueTransform = null) => {
    const map = new Map();
    (rows || []).forEach((row) => {
      const label = (row?.[labelKey] || "N/A").toString().trim() || "N/A";
      const raw = valueKey ? pickValueFromKeys(row, valueKey) : 1;
      const inc = typeof valueTransform === "function" ? valueTransform(raw) : raw;
      map.set(label, (map.get(label) || 0) + inc);
    });
    const result = Array.from(map.entries())
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value);
    if (typeof limit === "number") {
      return result.slice(0, limit);
    }
    return result;
  };

  const getScrollableChartHeight = (count, rowHeight = 28, minHeight = 240) => {
    const height = count * rowHeight;
    return Math.max(minHeight, height);
  };

  const renderBubbleChart = (data, valueFormatter, valueTitle) => {
    const safeData = (data || []).filter((item) => Number(item.value) !== 0);
    if (safeData.length === 0) {
      return <div className="text-sm text-gray-400 py-12 text-center">No data available</div>;
    }

    const bubbleData = safeData.map((item, idx) => ({
      x: idx + 1,
      y: Math.abs(Number(item.value) || 0),
      z: Math.abs(Number(item.value) || 0),
      label: item.label,
    }));

    const maxValue = bubbleData.reduce((max, item) => Math.max(max, item.y), 0);

    const bubbleTooltip = ({ active, payload }) => {
      if (!active || !payload || payload.length === 0) return null;
      const point = payload[0]?.payload;
      if (!point) return null;
      return (
        <div className="rounded-md border border-gray-200 bg-white px-3 py-2 text-xs shadow">
          <div className="font-semibold text-gray-800">{point.label}</div>
          <div className="text-gray-500">
            {valueTitle}: {valueFormatter(point.y)}
          </div>
        </div>
      );
    };

    return (
      <ResponsiveContainer width="100%" height={240}>
        <ScatterChart margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis type="number" dataKey="x" hide />
          <YAxis
            type="number"
            dataKey="y"
            tick={{ fontSize: 11 }}
            domain={[0, Math.max(1, Math.ceil(maxValue * 1.1))]}
          />
          <ZAxis type="number" dataKey="z" range={[40, 260]} />
          <Tooltip content={bubbleTooltip} />
          <Scatter data={bubbleData} fill="#3b82f6" />
        </ScatterChart>
      </ResponsiveContainer>
    );
  };

  const renderScrollableVerticalBar = (data) => {
    const safeData = (data || []).filter((item) => Number(item.value) !== 0);
    if (safeData.length === 0) {
      return <div className="text-sm text-gray-400 py-12 text-center">No data available</div>;
    }

    const barWidth = 26;
    const minWidth = 520;
    const chartWidth = Math.max(minWidth, safeData.length * barWidth);
    return (
      <div className="h-[240px] overflow-x-auto">
        <div style={{ width: chartWidth, height: 240 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={safeData} margin={{ top: 10, right: 12, left: 0, bottom: 40 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis
                dataKey="label"
                tick={{ fontSize: 10 }}
                interval={0}
                angle={-35}
                textAnchor="end"
                height={50}
              />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="value" radius={[6, 6, 0, 0]} barSize={18}>
                {safeData.map((_, idx) => (
                  <Cell key={`bar-${idx}`} fill={chartPalette[idx % chartPalette.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  };

  // Backward alias for hot-reload safety
  const renderScrollableHorizontalBar = renderScrollableVerticalBar;

  const normalizeStatusLabel = (value) => {
    const normalized = (value || "Unknown")
      .toString()
      .trim()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .toLowerCase();
    if (normalized === "process") return "Processed";
    return normalized.replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const buildStatusSeries = (rows, statusKey) => {
    const map = new Map();
    (rows || []).forEach((row) => {
      const label = normalizeStatusLabel(row?.[statusKey]);
      map.set(label, (map.get(label) || 0) + 1);
    });
    return Array.from(map.entries())
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value);
  };

  const applyClaimLocally = (claim, currentUser) => {
    if (!claim?.refID) return;
    const claimedByUser = claim.claimedByUser || null;
    const activeUser = currentUser?.username || currentExternalUser?.username || null;

    setDashboardData((prev) => {
      if (!prev || !Array.isArray(prev.draftInvoice_Details)) return prev;
      return {
        ...prev,
        draftInvoice_Details: prev.draftInvoice_Details.map((item) => {
          if (Number(item.refID) !== Number(claim.refID)) return item;
          return {
            ...item,
            workLocked: true,
            workByUser: claimedByUser,
            workByName: claim.claimedByName || claimedByUser,
            workAt: claim.claimedAt || new Date().toISOString().slice(0, 19).replace("T", " "),
            workByMe: !!activeUser && claimedByUser === activeUser,
            invoiceStatus: normalizeInvoiceStatus(claim.invoiceStatus || item.invoiceStatus),
          };
        }),
      };
    });
  };

  const applyInvoiceStatusLocally = (refID, invoiceStatus) => {
    const normalizedStatus = normalizeInvoiceStatus(invoiceStatus);
    setDashboardData((prev) => {
      if (!prev || !Array.isArray(prev.draftInvoice_Details)) return prev;
      return {
        ...prev,
        draftInvoice_Details: prev.draftInvoice_Details.map((item) =>
          Number(item.refID) === Number(refID)
            ? { ...item, invoiceStatus: normalizedStatus }
            : item
        ),
      };
    });
  };

  const handleClaimDraftInvoice = async (item) => {
    if (!item?.refID || claimLoadingRef) return;

    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to mark this payroll invoice as your active work item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, assign to me",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#2563eb",
    });
    if (!confirmation.isConfirmed) return;

    setClaimLoadingRef(Number(item.refID));
    try {
      const response = await fetch(dashboardApiUrl, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "claimDraftInvoice",
          refID: item.refID,
          invoiceNumber: item.invoiceNumber || "",
          clientName: item.clientName || "",
        }),
      });

      const result = await response.json();
      const claim = result?.dataObject?.[0]?.claim || null;
          if (result?.currentUser) {
            setCurrentExternalUser(result.currentUser);
          }
      if (claim) {
        applyClaimLocally(claim, result?.currentUser || null);
      }

      if (result.status) {
        setStatusGuardRef(null);
        Swal.fire({
          title: "Assigned",
          text: "This invoice is now assigned to you.",
          icon: "success",
          timer: 1200,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          title: "Already Assigned",
          text: result.message || "This invoice has already been assigned to another account user.",
          icon: "info",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message || "Unable to save assignment.",
        icon: "error",
      });
    } finally {
      setClaimLoadingRef(null);
    }
  };

  const handleFetch = async (overrideFromDate, overrideToDate) => {
    setLoading(true);
    setErrorMsg("");
    const payload = {
      FromDate: overrideFromDate ?? fromDate,
      ToDate: overrideToDate ?? toDate,
    };

    try {
      const response = await fetch(dashboardApiUrl, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.status && result.dataObject && result.dataObject.length > 0) {
        const nextUser = result.currentUser || { username: null, displayName: null, role: "" };
        const nextData = result.dataObject[0];
        setCurrentExternalUser(nextUser);
        setDashboardData(applyBusinessManagerAnchorFilter(nextData, nextUser));
        setCurrentTab("timesheet");
        setClientFilter("all");
        setDraftInvoiceStatusFilter("all");
        setIsDraftStatusMenuOpen(false);
        setOpenInvoiceStatusRef(null);
        setStatusGuardRef(null);
      } else {
        throw new Error(result.message || "No data returned from API");
      }
    } catch (error) {
      setErrorMsg(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!autoFetchOnMount) return;
    const range = getLast7DaysRange();
    setFromDate(range.from);
    setToDate(range.to);
    handleFetch(range.from, range.to);
  }, [autoFetchOnMount]);

  const chartInsights = useMemo(() => {
    if (!dashboardData) return null;

    const applyClientChartFilters = (series, searchText, topN) => {
      const safeSeries = Array.isArray(series) ? series : [];
      const query = String(searchText || "").trim().toLowerCase();
      const byClient = query
        ? safeSeries.filter((item) => String(item?.label || "").toLowerCase().includes(query))
        : safeSeries;
      if (topN === "all") return byClient;
      const limit = Number(topN || 0);
      if (!Number.isFinite(limit) || limit <= 0) return byClient;
      return byClient.slice(0, limit);
    };

    if (currentTab === "timesheet") {
      const approvedCountSeries = buildGroupedSeries(
        dashboardData.tS_Details || [],
        "clientName",
        "timesheet_Approved"
      );
      const approvedDistributionSeries = buildGroupedSeries(
        dashboardData.tS_Details || [],
        "clientName"
      );
      const filteredApprovedCountSeries = applyClientChartFilters(
        approvedCountSeries,
        timesheetChartClientSearch,
        timesheetChartTopN
      );
      const filteredApprovedDistributionSeries = applyClientChartFilters(
        approvedDistributionSeries,
        timesheetChartClientSearch,
        timesheetChartTopN
      );
      return {
        title: "Time Sheet Insights",
        filterMeta: {
          totalClients: approvedCountSeries.length,
          shownClients: filteredApprovedCountSeries.length,
          topN: timesheetChartTopN,
          query: timesheetChartClientSearch.trim(),
        },
        left: {
          label: "Approved Count by Client",
          data: filteredApprovedCountSeries,
        },
        right: {
          label: "Approved Distribution",
          data: filteredApprovedDistributionSeries,
        },
      };
    }

    if (currentTab === "payroll") {
      const payrollRows = dashboardData.prL_Details || [];
      const query = payrollChartClientSearch.trim().toLowerCase();
      const filteredPayrollRows = query
        ? payrollRows.filter((row) =>
            String(row?.clientName || "").toLowerCase().includes(query)
          )
        : payrollRows;
      const paidAmountSeries = buildGroupedSeries(filteredPayrollRows, "clientName", "paidAmount", null);
      const filteredPaidAmountSeries = applyClientChartFilters(
        paidAmountSeries,
        "",
        payrollChartTopN
      );
      return {
        title: "Payroll Insights",
        filterMeta: {
          totalClients: paidAmountSeries.length,
          shownClients: filteredPaidAmountSeries.length,
          topN: payrollChartTopN,
          query: payrollChartClientSearch.trim(),
        },
        left: {
          label: "Paid Amount by Client",
          data: filteredPaidAmountSeries,
        },
        right: {
          label: "Payment Status Mix",
          data: buildStatusSeries(filteredPayrollRows, "paymentStatus"),
        },
      };
    }

    if (currentTab === "invoice") {
      const amountSeries = buildGroupedSeries(
        dashboardData.invoice_Details || [],
        "clientName",
        [
          "invoiceTotalAmount",
          "invoice_total_amount",
          "invoiceAmount",
          "invoice_amount",
          "invoice_amt",
          "amount",
        ],
        null,
        (value) => Math.abs(Number(value) || 0)
      );
      const countSeries = buildGroupedSeries(dashboardData.invoice_Details || [], "clientName", null, null);
      const filteredAmountSeries = applyClientChartFilters(
        amountSeries,
        invoiceChartClientSearch,
        invoiceChartTopN
      );
      const filteredCountSeries = applyClientChartFilters(
        countSeries,
        invoiceChartClientSearch,
        invoiceChartTopN
      );
      return {
        title: "Invoice Insights",
        filterMeta: {
          totalClients: amountSeries.length,
          shownClients: filteredAmountSeries.length,
          topN: invoiceChartTopN,
          query: invoiceChartClientSearch.trim(),
        },
        left: {
          label: "Invoice Amount by Client",
          data: filteredAmountSeries,
        },
        right: {
          label: "Invoice Count by Client",
          data: filteredCountSeries,
        },
      };
    }

    if (currentTab === "outstandingInvoice") {
      const outstandingRows = dashboardData.invoiceOutStand_Details || [];
      const query = outstandingInvoiceChartClientSearch.trim().toLowerCase();
      const filteredOutstandingRows = query
        ? outstandingRows.filter((row) =>
            String(row?.clientName || "").toLowerCase().includes(query)
          )
        : outstandingRows;
      const outstandingBalanceSeries = buildGroupedSeries(
        filteredOutstandingRows,
        "clientName",
        "outstandingBalance",
        null,
        (value) => Math.abs(Number(value) || 0)
      );
      const outstandingCountSeries = buildGroupedSeries(
        filteredOutstandingRows,
        "clientName",
        null,
        null
      );
      const filteredBalanceSeries = applyClientChartFilters(
        outstandingBalanceSeries,
        "",
        outstandingInvoiceChartTopN
      );
      const filteredCountSeries = applyClientChartFilters(
        outstandingCountSeries,
        "",
        outstandingInvoiceChartTopN
      );
      return {
        title: "Outstanding Invoice Insights",
        filterMeta: {
          totalClients: buildGroupedSeries(outstandingRows, "clientName", null, null).length,
          shownClients: filteredBalanceSeries.length,
          topN: outstandingInvoiceChartTopN,
          query: outstandingInvoiceChartClientSearch.trim(),
        },
        left: {
          label: "Outstanding Balance by Client",
          data: filteredBalanceSeries,
        },
        right: {
          label: "Outstanding Invoice Count by Client",
          data: filteredCountSeries,
        },
      };
    }

    if (currentTab === "draftInvoice") {
      const draftInvoiceRows = dashboardData.draftInvoice_Details || [];
      const query = draftInvoiceChartClientSearch.trim().toLowerCase();
      const filteredDraftInvoiceRows = query
        ? draftInvoiceRows.filter((row) =>
            String(row?.clientName || "").toLowerCase().includes(query)
          )
        : draftInvoiceRows;
      const fullDraftInvoiceAmountSeries = buildGroupedSeries(
        filteredDraftInvoiceRows,
        "clientName",
        "invoiceAmount",
        null
      );
      const leftSeries = applyClientChartFilters(
        fullDraftInvoiceAmountSeries,
        "",
        draftInvoiceChartTopN
      );
      const statusSeries = buildStatusSeries(filteredDraftInvoiceRows, "invoiceStatus");
      const statusCountMap = new Map(
        statusSeries.map((item) => [String(item.label || "").trim().toLowerCase(), Number(item.value || 0)])
      );
      const draftStatusOrder = ["Pending", "Processed", "In Progress", "On Hold"];
      const statusSeriesWithDefaults = draftStatusOrder.map((label) => ({
        label,
        value: statusCountMap.get(label.toLowerCase()) || 0,
      }));
      return {
        title: "Payroll Invoice Insights",
        filterMeta: {
          totalClients: buildGroupedSeries(draftInvoiceRows, "clientName", "invoiceAmount", null).length,
          shownClients: leftSeries.length,
          topN: draftInvoiceChartTopN,
          query: draftInvoiceChartClientSearch.trim(),
        },
        left: {
          label: "Invoice Amount by Client",
          data: leftSeries,
        },
        right: {
          label: "Status Mix",
          data: statusSeriesWithDefaults,
        },
      };
    }

    return null;
  }, [
    dashboardData,
    currentTab,
    invoiceChartClientSearch,
    invoiceChartTopN,
    timesheetChartClientSearch,
    timesheetChartTopN,
    payrollChartClientSearch,
    payrollChartTopN,
    outstandingInvoiceChartClientSearch,
    outstandingInvoiceChartTopN,
    draftInvoiceChartClientSearch,
    draftInvoiceChartTopN,
  ]);

  const fetchAccountsStaff = async () => {
    try {
      setAccountsStaffLoading(true);
      const response = await fetch(dashboardApiUrl, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "listAccountsStaff" }),
      });
      const result = await response.json();
      if (result?.status) {
        const staff = result?.dataObject?.[0]?.staff || [];
        const options = [
          { value: "", label: "Unassigned" },
          ...staff
            .filter((s) => s?.username)
            .map((s) => ({
              value: String(s.username),
              label: String(s.name || s.username),
            })),
        ];
        setAccountsStaffOptions(options);
      } else {
        setAccountsStaffOptions([{ value: "", label: "Unassigned" }]);
      }
    } catch (error) {
      setAccountsStaffOptions([{ value: "", label: "Unassigned" }]);
    } finally {
      setAccountsStaffLoading(false);
    }
  };

  useEffect(() => {
    if (!isAccountsHeadUser) return;
    fetchAccountsStaff();
  }, [isAccountsHeadUser]);

  const applyReassignLocally = (refID, claim) => {
    setDashboardData((prev) => {
      if (!prev || !Array.isArray(prev.draftInvoice_Details)) return prev;
      const activeUser = currentExternalUser?.username || null;
      return {
        ...prev,
        draftInvoice_Details: prev.draftInvoice_Details.map((item) => {
          if (Number(item.refID) !== Number(refID)) return item;
          if (!claim) {
            return {
              ...item,
              workLocked: false,
              workByUser: null,
              workByName: null,
              workAt: null,
              workByMe: false,
              invoiceStatus: normalizeInvoiceStatus(item.invoiceStatus || "pending"),
            };
          }
          return {
            ...item,
            workLocked: true,
            workByUser: claim.claimedByUser,
            workByName: claim.claimedByName || claim.claimedByUser,
            workAt: claim.claimedAt || item.workAt,
            workByMe: !!activeUser && claim.claimedByUser === activeUser,
            invoiceStatus: normalizeInvoiceStatus(claim.invoiceStatus || item.invoiceStatus),
          };
        }),
      };
    });
  };

  const handleReassignDraftInvoice = async (item, targetUsername) => {
    if (!item?.refID || reassignLoadingRef) return;
    setReassignLoadingRef(Number(item.refID));
    try {
      const response = await fetch(dashboardApiUrl, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "reassignDraftInvoice",
          refID: item.refID,
          invoiceNumber: item.invoiceNumber || "",
          clientName: item.clientName || "",
          invoiceStatus: item.invoiceStatus || "pending",
          targetUsername: targetUsername || "",
        }),
      });
      const result = await response.json();
      if (!result?.status) {
        throw new Error(result?.message || "Unable to reassign.");
      }
      const claim = result?.dataObject?.[0]?.claim || null;
      applyReassignLocally(item.refID, claim);
      setReassignMenuRef(null);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message || "Unable to reassign.",
        icon: "error",
      });
    } finally {
      setReassignLoadingRef(null);
    }
  };

  useEffect(() => {
    if (currentTab !== "draftInvoice") setIsDraftStatusMenuOpen(false);
    if (currentTab !== "draftInvoice") setOpenInvoiceStatusRef(null);
    if (currentTab !== "draftInvoice") setStatusGuardRef(null);
    if (currentTab !== "draftInvoice") setReassignMenuRef(null);
  }, [currentTab]);

  useEffect(() => {
    if (openInvoiceStatusRef === null) return;
    const handleOutsideClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('[data-invoice-status-dropdown="true"]')) {
        setOpenInvoiceStatusRef(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [openInvoiceStatusRef]);

  useEffect(() => {
    if (reassignMenuRef === null) return;
    const handleOutsideClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (
        !target.closest('[data-reassign-menu="true"]') &&
        !target.closest('[data-reassign-toggle="true"]')
      ) {
        setReassignMenuRef(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [reassignMenuRef]);

  const handleNewRequest = () => {
    setDashboardData(null);
    setErrorMsg("");
    setCurrentTab("timesheet");
    setClientFilter("all");
    setDraftInvoiceStatusFilter("all");
    setIsDraftStatusMenuOpen(false);
    setOpenInvoiceStatusRef(null);
    setStatusGuardRef(null);
  };

  const filterByClient = (list) =>
    clientFilter === "all" ? list : list.filter((i) => i.clientName === clientFilter);

  const handleDraftInvoiceStatusChange = async (item, nextValue) => {
    if (!item?.refID || !nextValue) return;
    if (!item.workByMe) {
      setStatusGuardRef(Number(item.refID));
      setOpenInvoiceStatusRef(null);
      return;
    }
    const nextStatus = normalizeInvoiceStatus(nextValue);
    const currentStatus = normalizeInvoiceStatus(item.invoiceStatus);
    if (nextStatus === currentStatus) return;

    setStatusGuardRef(null);
    setStatusSavingRef(Number(item.refID));
    try {
      const response = await fetch(dashboardApiUrl, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "updateDraftInvoiceStatus",
          refID: item.refID,
          invoiceNumber: item.invoiceNumber || "",
          clientName: item.clientName || "",
          invoiceStatus: nextStatus,
        }),
      });

      const result = await response.json();
      if (!result.status) {
        if ((result.message || "").toLowerCase().includes("first assign it")) {
          setStatusGuardRef(Number(item.refID));
          setOpenInvoiceStatusRef(null);
        }
        throw new Error(result.message || "Unable to update invoice status.");
      }

      const savedStatus = normalizeInvoiceStatus(
        result?.dataObject?.[0]?.invoiceStatus || nextStatus
      );
      applyInvoiceStatusLocally(item.refID, savedStatus);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message || "Unable to update invoice status.",
        icon: "error",
      });
    } finally {
      setStatusSavingRef(null);
    }
  };

  const tabConfig = useMemo(() => {
    if (!dashboardData) {
      return { headers: [], rows: [], summary: null };
    }

    if (currentTab === "timesheet") {
      const data = filterByClient(dashboardData.tS_Details || []);
      const headers = [
        "Client Name",
        "Ref ID",
        "Anchor Name",
        "Anchor Email",
        "Cost Center",
        "Contract No",
        "Contract Code",
        "Location",
        "Approved User",
        "Approved Date",
        "Approved Count",
      ];

      const totalApproved = data.reduce(
        (sum, item) => sum + (item.timesheet_Approved || 0),
        0
      );

      return {
        headers,
        rows: data.map((item, idx) => ({
          key: item.refID || idx,
          cells: [
            item.clientName,
            item.refID,
            item.clientAnchorName || "N/A",
            item.clientAnchorEmailID || "N/A",
            item.clientConstCenter || "N/A",
            item.contractNo || "N/A",
            item.contractCode || "N/A",
            item.location,
            item.timesheet_Approved_User || "N/A",
            item.approvedDate || "N/A",
            item.timesheet_Approved,
          ],
        })),
        summary: (
          <div>
            <strong>Total Timesheets Approved:</strong>{" "}
            <span className="text-blue-700 text-lg ml-2">{totalApproved}</span>
          </div>
        ),
      };
    }

    if (currentTab === "payroll") {
      const transactionQuery = payrollTransactionFilter.trim().toLowerCase();
      const normalizePayrollStatus = (value) =>
        String(value || "")
          .toLowerCase()
          .replace(/[_-]+/g, " ")
          .replace(/\s+/g, " ")
          .trim();
      const statusQuery = normalizePayrollStatus(payrollStatusFilter);
      const data = filterByClient(dashboardData.prL_Details || [])
        .filter((item) => {
          if (!transactionQuery) return true;
          const transactionText = String(item.transactionNumber || "").toLowerCase();
          return transactionText.includes(transactionQuery);
        })
        .filter((item) => {
          if (!statusQuery) return true;
          const statusText = normalizePayrollStatus(item.paymentStatus);
          return statusText === statusQuery;
        });
      const headers = [
        "Client Name",
        "Ref ID",
        "Anchor Name",
        "Anchor Email",
        "Cost Center",
        "Contract No",
        "Contract Code",
        "Location",
        "Processed User",
        "Locked User",
        "Processed Date",
        "Expected Payroll Date",
        "Locked Date",
        "Status",
        "Transaction",
        "Processed Count",
        "Paid Amount",
      ];

      const totalProcessed = data.reduce(
        (sum, item) => sum + (item.payroll_Processed || 0),
        0
      );
      const totalPaid = data.reduce(
        (sum, item) => sum + Number(item.paidAmount || 0),
        0
      );
      const paymentStatusCount = data.reduce(
        (acc, item) => {
          const normalizedStatus = (item.paymentStatus || "")
            .toString()
            .trim()
            .toUpperCase();

          if (normalizedStatus === "PAID") {
            acc.paid += 1;
          } else if (normalizedStatus === "NOT PAID") {
            acc.notPaid += 1;
          } else if (normalizedStatus === "PARTIAL PAID") {
            acc.partialPaid += 1;
          }

          return acc;
        },
        { paid: 0, notPaid: 0, partialPaid: 0 }
      );

      return {
        headers,
        rows: data.map((item, idx) => ({
          key: item.refID || idx,
          cells: [
            item.clientName,
            item.refID,
            item.clientAnchorName || "N/A",
            item.clientAnchorEmailID || "N/A",
            item.clientConstCenter || "N/A",
            item.contractNo || "N/A",
            item.contractCode || "N/A",
            item.location,
            item.processedUser || "N/A",
            item.lockedUser || "N/A",
            item.processedDate || "N/A",
            formatDateOnly(item.lockedDate),
            item.lockedDate || "N/A",
            item.paymentStatus || "UNKNOWN",
            item.transactionNumber || "N/A",
            item.payroll_Processed,
            formatRupee(item.paidAmount),
          ],
          meta: {
            status: item.paymentStatus,
            processedDateRaw: item.processedDate || null,
            expectedPayrollDateRaw: item.lockedDate || null,
          },
        })),
        summary: (
          <>
            <div>
              <strong>Processed Count:</strong>{" "}
              <span className="text-blue-700 text-lg ml-2">{totalProcessed}</span>
            </div>
            <div>
              <strong>Total Paid Amount:</strong>{" "}
              <span className="text-blue-700 text-lg ml-2">{formatRupee(totalPaid)}</span>
            </div>
            <div>
              <strong>Paid Count:</strong>{" "}
              <span className="text-blue-700 text-lg ml-2">{paymentStatusCount.paid}</span>
            </div>
            <div>
              <strong>Not Paid Count:</strong>{" "}
              <span className="text-blue-700 text-lg ml-2">{paymentStatusCount.notPaid}</span>
            </div>
            <div>
              <strong>Partial Paid Count:</strong>{" "}
              <span className="text-blue-700 text-lg ml-2">{paymentStatusCount.partialPaid}</span>
            </div>
          </>
        ),
      };
    }

    if (currentTab === "draftInvoice") {
      const data = filterByClient(dashboardData.draftInvoice_Details || []).filter((item) => {
        if (draftInvoiceStatusFilter === "all") return true;
        return normalizeInvoiceStatus(item.invoiceStatus) === draftInvoiceStatusFilter;
      });
      const headers = [
        "Work Allocation",
        "Invoice Status",
        "Client Name",
        "Invoice #",
        "Bill Amount",
        "Tax Amount",
        "Invoice Amount",
        "Ref ID",
        "Anchor Name",
        "Anchor Email",
        "Cost Center",
        "Group Type",
        "Contract No",
        "Contract Code",
        "Location",
        "Processed User",
        "Due Days",
        "Payment Category",
      ];

      const stats = data.reduce(
        (acc, item) => {
          acc.bill += Number(item.billAmount || 0);
          acc.tax += Number(item.taxAmount || 0);
          acc.invoice += Number(item.invoiceAmount || 0);
          if (item.workLocked) {
            acc.locked += 1;
          }
          return acc;
        },
        { bill: 0, tax: 0, invoice: 0, locked: 0 }
      );

      return {
        headers,
        rows: data.map((item, idx) => ({
          key: item.refID || idx,
          cells: [
            item.workLocked ? (
              <div className="relative text-xs leading-tight text-center overflow-visible">
                {isAccountsHeadUser && (
                  <button
                    type="button"
                    data-reassign-toggle="true"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setReassignMenuRef((prev) =>
                        prev === Number(item.refID) ? null : Number(item.refID)
                      );
                    }}
                    className="absolute right-0 top-0 inline-flex items-center justify-center rounded-full border border-gray-200 bg-white p-1 text-[11px] text-gray-600 hover:text-gray-900 hover:border-gray-300"
                    title="Reassign"
                  >
                    <i className="ri-pencil-line"></i>
                  </button>
                )}
                <div className={`font-semibold ${item.workByMe ? "text-green-700" : "text-amber-700"}`}>
                  {`Assigned to ${item.workByName || item.workByUser || "User"}`}
                </div>
                <div className="text-gray-500 mt-1">{formatDateTime(item.workAt)}</div>
                {isAccountsHeadUser && reassignMenuRef === Number(item.refID) && (
                  <div
                    data-reassign-menu="true"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    className="absolute left-full top-0 z-40 ml-2 rounded-md border border-gray-200 bg-white shadow-lg p-1 text-left min-w-[170px]"
                  >
                    {accountsStaffLoading ? (
                      <div className="px-2 py-1 text-[11px] text-gray-500">Loading...</div>
                    ) : accountsStaffOptions.length > 0 ? (
                      (() => {
                        const currentValue = String(item.workByUser || "");
                        const filtered = currentValue
                          ? accountsStaffOptions.filter((opt) => opt.value !== currentValue)
                          : accountsStaffOptions;
                        return filtered.map((opt) => (
                        <button
                          key={`${item.refID}-${opt.value || "none"}`}
                          type="button"
                          disabled={reassignLoadingRef === Number(item.refID)}
                          onClick={() => handleReassignDraftInvoice(item, opt.value)}
                          className="w-full text-left px-2 py-1.5 rounded text-xs hover:bg-gray-100 disabled:opacity-60"
                        >
                          {opt.label}
                        </button>
                        ));
                      })()
                    ) : (
                      <div className="px-2 py-1 text-[11px] text-gray-500">No accounts staff found</div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="flex justify-center">
                <button
                  type="button"
                  disabled={claimLoadingRef === Number(item.refID)}
                  onClick={() => handleClaimDraftInvoice(item)}
                  className={`px-2.5 py-1 rounded-md text-xs font-semibold border transition ${
                    claimLoadingRef === Number(item.refID)
                      ? "bg-gray-100 text-gray-500 border-gray-200 cursor-not-allowed"
                      : "bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100"
                  }`}
                >
                  {claimLoadingRef === Number(item.refID) ? "Assigning..." : "Select"}
                </button>
              </div>
            ),
            <div data-invoice-status-dropdown="true" className="min-w-[145px] relative">
              {(() => {
                const canEditStatus = !!item.workByMe;
                return (
              <>
              <button
                type="button"
                disabled={statusSavingRef === Number(item.refID)}
                onClick={() =>
                  canEditStatus
                    ? setOpenInvoiceStatusRef((prev) =>
                        prev === Number(item.refID) ? null : Number(item.refID)
                      )
                    : setStatusGuardRef(Number(item.refID))
                }
                className={`w-full min-h-[34px] rounded-md border px-2 py-1 text-xs font-medium focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500 ${
                  canEditStatus
                    ? "border-gray-300 bg-white text-gray-700 hover:border-blue-300"
                    : "border-gray-200 bg-gray-100 text-gray-500 cursor-not-allowed"
                }`}
              >
                {statusSavingRef === Number(item.refID) ? (
                  <span className="flex items-center justify-center gap-2 text-[11px] text-gray-600">
                    <span className="external-dot-loader" aria-hidden="true">
                      <span />
                      <span />
                      <span />
                    </span>
                    Saving
                  </span>
                ) : (
                  <span className="flex items-center justify-between gap-2">
                    <span
                      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 ${
                        getInvoiceStatusMeta(item.invoiceStatus).chip
                      }`}
                    >
                      <span
                        className={`h-1.5 w-1.5 rounded-full ${
                          getInvoiceStatusMeta(item.invoiceStatus).dot
                        }`}
                      />
                      {getInvoiceStatusMeta(item.invoiceStatus).label}
                    </span>
                    <span className="text-[10px] text-gray-500">v</span>
                  </span>
                )}
              </button>
              {statusGuardRef === Number(item.refID) && !canEditStatus && (
                <p className="mt-1 text-[11px] font-semibold text-red-600">First assign it</p>
              )}
              {openInvoiceStatusRef === Number(item.refID) && canEditStatus && (
                <div className="absolute left-0 right-0 mt-1 z-20 rounded-md border border-gray-200 bg-white shadow-lg p-1">
                  {invoiceStatusOptions.map((option) => {
                    const optionMeta = getInvoiceStatusMeta(option.value);
                    const isActive =
                      getInvoiceStatusValue(item.invoiceStatus) === option.value;
                    return (
                      <button
                        key={option.value}
                        type="button"
                        onClick={() => {
                          setOpenInvoiceStatusRef(null);
                          handleDraftInvoiceStatusChange(item, option.value);
                        }}
                        className={`w-full text-left px-2 py-1.5 rounded text-xs ${
                          isActive
                            ? "bg-blue-50 text-blue-700 font-semibold"
                            : "text-gray-700 hover:bg-gray-100"
                        }`}
                      >
                        <span className="inline-flex items-center gap-1.5">
                          <span
                            className={`h-1.5 w-1.5 rounded-full ${optionMeta.dot}`}
                          />
                          {optionMeta.label}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
              </>
                );
              })()}
            </div>,
            item.clientName,
            item.invoiceNumber || "N/A",
            formatRupee(item.billAmount),
            formatRupee(item.taxAmount),
            formatRupee(item.invoiceAmount),
            item.refID,
            item.clientAnchorName || "N/A",
            item.clientAnchorEmailID || "N/A",
            item.clientConstCenter || "N/A",
            item.invGroupType || "N/A",
            item.contractNo || "N/A",
            item.contractCode || "N/A",
            item.location || "N/A",
            item.processedUser || "N/A",
            item.paymentDueDays ?? 0,
            item.paymentCategory || "N/A",
          ],
        })),
        summary: (
          <>
            <div>
              <strong>Total Bill Amount:</strong>
              <br />
              <span className="text-blue-700 text-lg">{formatRupee(stats.bill)}</span>
            </div>
            <div>
              <strong>Total Tax Amount:</strong>
              <br />
              <span className="text-amber-700 text-lg">{formatRupee(stats.tax)}</span>
            </div>
            <div>
              <strong>Total Invoice Amount:</strong>
              <br />
              <span className="text-green-700 text-lg">{formatRupee(stats.invoice)}</span>
            </div>
            <div>
              <strong>Selected For Work:</strong>
              <br />
              <span className="text-blue-700 text-lg">{stats.locked}</span>
            </div>
          </>
        ),
      };
    }

    if (currentTab === "outstandingInvoice") {
      const data = filterByClient(dashboardData.invoiceOutStand_Details || []);
      const headers = [
        "Client Name",
        "Ref ID",
        "Anchor Name",
        "Anchor Email",
        "Cost Center",
        "Group Type",
        "Contract No",
        "Contract Code",
        "Location",
        "Processed User",
        "Date",
        "Invoice #",
        "Proc. Count",
        "Amount",
        "Collected",
        "Balance",
        "Pending Days",
      ];

      const stats = data.reduce(
        (acc, item) => {
          acc.total += Number(item.invoiceTotalAmount || 0);
          acc.collected += Number(item.collectedAmount || 0);
          acc.outstanding += Number(item.outstandingBalance || 0);
          acc.processed += Number(item.invoice_Processed || 0);
          return acc;
        },
        { total: 0, collected: 0, outstanding: 0, processed: 0 }
      );

      return {
        headers,
        rows: data.map((item, idx) => ({
          key: item.refID || idx,
          cells: [
            item.clientName,
            item.refID,
            item.clientAnchorName || "N/A",
            item.clientAnchorEmailID || "N/A",
            item.clientConstCenter || "N/A",
            item.invGroupType || "N/A",
            item.contractNo || "N/A",
            item.contractCode || "N/A",
            item.location || "N/A",
            item.processedUser || "N/A",
            item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString() : "N/A",
            item.invoiceNumber || "N/A",
            item.invoice_Processed || 0,
            formatRupee(item.invoiceTotalAmount),
            formatRupee(item.collectedAmount),
            formatRupee(item.outstandingBalance),
            item.pendingDays ?? 0,
          ],
        })),
        summary: (
          <>
            <div>
              <strong>Total Invoice Amount:</strong>
              <br />
              <span className="text-blue-700 text-lg">{formatRupee(stats.total)}</span>
            </div>
            <div>
              <strong>Collected Amount:</strong>
              <br />
              <span className="text-green-700 text-lg">{formatRupee(stats.collected)}</span>
            </div>
            <div>
              <strong>Outstanding Balance:</strong>
              <br />
              <span className="text-red-700 text-lg">{formatRupee(stats.outstanding)}</span>
            </div>
            <div>
              <strong>Invoices Processed:</strong>
              <br />
              <span className="text-blue-700 text-lg">{stats.processed}</span>
            </div>
          </>
        ),
      };
    }

    const data = filterByClient(dashboardData.invoice_Details || []);
    const headers = [
      "Client Name",
      "Ref ID",
      "Anchor Name",
      "Anchor Email",
      "Cost Center",
      "Group Type",
      "Contract No",
      "Contract Code",
      "Location",
      "Processed User",
      "Date",
      "Invoice #",
      "Proc. Count",
      "Amount",
      "Collected",
      "Balance",
    ];

    const stats = data.reduce(
      (acc, item) => {
        acc.total += Number(item.invoiceTotalAmount || 0);
        acc.collected += Number(item.collectedAmount || 0);
        acc.outstanding += Number(item.outstandingBalance || 0);
        acc.processed += Number(item.invoice_Processed || 0);
        return acc;
      },
      { total: 0, collected: 0, outstanding: 0, processed: 0 }
    );

    return {
      headers,
      rows: data.map((item, idx) => ({
        key: item.refID || idx,
        cells: [
          item.clientName,
          item.refID,
          item.clientAnchorName || "N/A",
          item.clientAnchorEmailID || "N/A",
          item.clientConstCenter || "N/A",
          item.invGroupType || "N/A",
          item.contractNo || "N/A",
          item.contractCode || "N/A",
          item.location,
          item.processedUser || "N/A",
          item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString() : "N/A",
          item.invoiceNumber,
          item.invoice_Processed,
          formatRupee(item.invoiceTotalAmount),
          formatRupee(item.collectedAmount),
          formatRupee(item.outstandingBalance),
        ],
      })),
      summary: (
        <>
          <div>
            <strong>Total Invoice Amount:</strong>
            <br />
            <span className="text-blue-700 text-lg">{formatRupee(stats.total)}</span>
          </div>
          <div>
            <strong>Collected Amount:</strong>
            <br />
            <span className="text-green-700 text-lg">{formatRupee(stats.collected)}</span>
          </div>
          <div>
            <strong>Outstanding Balance:</strong>
            <br />
            <span className="text-red-700 text-lg">{formatRupee(stats.outstanding)}</span>
          </div>
          <div>
            <strong>Invoices Processed:</strong>
            <br />
            <span className="text-blue-700 text-lg">{stats.processed}</span>
          </div>
        </>
      ),
    };
  }, [
    dashboardData,
    currentTab,
    clientFilter,
    claimLoadingRef,
    statusSavingRef,
    openInvoiceStatusRef,
    statusGuardRef,
    reassignMenuRef,
    reassignLoadingRef,
    accountsStaffLoading,
    accountsStaffOptions,
    isAccountsHeadUser,
    chartInsights,
    draftInvoiceStatusFilter,
    payrollTransactionFilter,
    payrollStatusFilter,
    invoiceStatusOptions,
  ]);

  const activeTableSearch = tableSearchByTab[currentTab] || "";

  const filteredTableRows = useMemo(() => {
    const query = activeTableSearch.trim().toLowerCase();
    if (!query) return tabConfig.rows;
    return tabConfig.rows.filter((row) => {
      const rowText = extractTextFromNode(row.cells).toLowerCase();
      return rowText.includes(query);
    });
  }, [tabConfig.rows, activeTableSearch]);

  return (
    <div className="bg-gray-50 rounded-xl p-4 md:p-6">
      <style>{`
        .external-tab-active {
          border-bottom: 2px solid #2563eb;
          color: #2563eb;
        }
        .external-loader {
          border-top-color: #3498db;
          animation: external-spinner 1.5s linear infinite;
        }
        .external-dot-loader {
          display: inline-flex;
          align-items: center;
          gap: 3px;
        }
        .external-dot-loader span {
          width: 5px;
          height: 5px;
          border-radius: 9999px;
          background: #2563eb;
          opacity: 0.3;
          animation: external-dot-bounce 1s infinite ease-in-out;
        }
        .external-dot-loader span:nth-child(2) {
          animation-delay: 0.15s;
        }
        .external-dot-loader span:nth-child(3) {
          animation-delay: 0.3s;
        }
        @keyframes external-spinner {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes external-dot-bounce {
          0%, 80%, 100% { transform: scale(0.7); opacity: 0.3; }
          40% { transform: scale(1); opacity: 1; }
        }
        .external-table-container {
          max-height: 600px;
          overflow-y: auto;
        }
        .external-table-head th {
          position: sticky;
          top: 0;
          background: #f9fafb;
          z-index: 10;
        }
      `}</style>

      <div className="w-full mx-auto p-6 bg-white rounded-xl shadow-md">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <h2 className="text-xl font-bold text-gray-800">Fetch Dashboard Data</h2>
            <p className="text-sm text-gray-500 mt-1">Select date range and generate report.</p>
          </div>
          <div className="flex flex-col md:flex-row md:items-end gap-3 w-full md:w-auto">
            <div className="w-full md:w-auto">
              <label className="block text-sm font-medium text-gray-700">From Date</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full md:w-[180px] p-2 border rounded mt-1"
              />
            </div>
            <div className="w-full md:w-auto">
              <label className="block text-sm font-medium text-gray-700">To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full md:w-[180px] p-2 border rounded mt-1"
              />
            </div>
            <button
              onClick={() => handleFetch()}
              disabled={loading}
              className={`w-full md:w-auto text-white py-2 px-5 rounded-lg transition font-semibold ${
                loading
                  ? "bg-blue-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {loading ? "Generating..." : "Generate Report"}
            </button>
          </div>
        </div>
        {errorMsg && <p className="text-red-500 text-sm mt-4">{errorMsg}</p>}
      </div>

      {!dashboardData ? (
        <div />
      ) : (
        <div className="container mx-auto mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
            <h1 className="text-3xl font-extrabold text-gray-900">Summary Dashboard</h1>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-sm font-medium text-gray-500">Filter Client:</span>
              <div className="min-w-[320px] md:min-w-[380px]">
                <Select
                  value={clientOptions.find((option) => option.value === clientFilter) || clientOptions[0]}
                  options={clientOptions}
                  isSearchable
                  onChange={(selectedOption) => setClientFilter(selectedOption?.value || "all")}
                  classNamePrefix="client-filter-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                      borderRadius: "0.5rem",
                    }),
                  }}
                />
              </div>
              {/* <button
                onClick={handleNewRequest}
                className="ml-4 text-sm text-blue-600 hover:underline"
              >
                New Request
              </button> */}
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-md overflow-hidden relative">
            <div className="flex border-b">
              {[ 
                { key: "timesheet", label: "Time Sheet" },
                { key: "payroll", label: "Payroll" },
                { key: "invoice", label: "Processed Invoices" },
                { key: "outstandingInvoice", label: "Outstanding Invoices" },
                { key: "draftInvoice", label: "Payroll Invoices" },
              ].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setCurrentTab(tab.key)}
                  className={`px-6 py-4 font-semibold text-gray-600 hover:bg-gray-50 ${
                    currentTab === tab.key ? "external-tab-active" : ""
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="p-6 flex flex-col">
              <div className="external-table-container order-3 border rounded-lg overflow-x-auto">
                <table className="w-full text-left border-collapse min-w-[1200px]">
                  <thead className="external-table-head bg-gray-50 text-xs uppercase text-gray-500">
                    <tr>
                      {tabConfig.headers.map((h) => {
                        const normalizedHeader = String(h || "").trim().toLowerCase();
                        const isPhotoHeader = normalizedHeader.includes("photo");
                        const isDesignationHeader = normalizedHeader === "designation";
                        const isAssignedToHeader = normalizedHeader === "assigned to" || normalizedHeader === "assigned_to";
                        const isPayrollStatusHeader =
                          currentTab === "payroll" && h === "Status";
                        const isPayrollClientNameHeader =
                          currentTab === "payroll" && h === "Client Name";
                        const isPayrollCostCenterHeader =
                          currentTab === "payroll" && h === "Cost Center";
                        const isPayrollContractNoHeader =
                          currentTab === "payroll" && h === "Contract No";
                        const isPayrollTransactionHeader =
                          currentTab === "payroll" && h === "Transaction";
                        const isProcessedInvoiceContractColumn =
                          (currentTab === "invoice" || currentTab === "outstandingInvoice") &&
                          (h === "Contract No" || h === "Contract Code");
                        const isProcessedInvoiceCostCenterColumn =
                          (currentTab === "invoice" || currentTab === "outstandingInvoice") && h === "Cost Center";
                        const isDraftInvoiceStatusHeader =
                          currentTab === "draftInvoice" && h === "Invoice Status";
                        const isDraftInvoiceWorkAllocationHeader =
                          currentTab === "draftInvoice" && h === "Work Allocation";
                        const isDraftInvoiceClientNameHeader =
                          currentTab === "draftInvoice" && h === "Client Name";
                        const isDraftInvoiceCostCenterHeader =
                          currentTab === "draftInvoice" && h === "Cost Center";
                        return (
                          <th
                            key={h}
                            className={`px-3 py-3 border-b border-gray-200 font-bold whitespace-nowrap ${
                              isPayrollStatusHeader ? "min-w-[110px]" : ""
                            } ${
                              isPayrollClientNameHeader ? "min-w-[220px]" : ""
                            } ${
                              isPayrollCostCenterHeader ? "min-w-[180px]" : ""
                            } ${
                              isPayrollContractNoHeader ? "min-w-[160px]" : ""
                            } ${
                              isPayrollTransactionHeader ? "min-w-[160px]" : ""
                            } ${
                              isProcessedInvoiceContractColumn ? "w-[120px] max-w-[120px]" : ""
                            } ${
                              isProcessedInvoiceCostCenterColumn ? "min-w-[180px]" : ""
                            } ${
                              isDraftInvoiceStatusHeader ? "min-w-[155px]" : ""
                            } ${
                              isDraftInvoiceWorkAllocationHeader ? "min-w-[220px] text-center" : ""
                            } ${
                              isDraftInvoiceClientNameHeader ? "min-w-[240px]" : ""
                            } ${
                              isDraftInvoiceCostCenterHeader ? "min-w-[180px]" : ""
                            } ${
                              isPhotoHeader ? "w-[90px] min-w-[90px] max-w-[90px] text-center" : ""
                            } ${
                              isDesignationHeader ? "min-w-[320px]" : ""
                            } ${
                              isAssignedToHeader ? "min-w-[340px]" : ""
                            }`}
                          >
                            {isDraftInvoiceStatusHeader ? (
                                <div className="min-w-[145px] normal-case relative">
                                  <div className="flex items-center justify-between gap-2">
                                    <div className="uppercase text-xs tracking-wide text-gray-500">{h}</div>
                                    <button
                                      type="button"
                                      onClick={() => setIsDraftStatusMenuOpen((prev) => !prev)}
                                      className="h-7 w-7 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white text-gray-600 hover:bg-gray-100"
                                      title="Filter by status"
                                      aria-label="Filter by status"
                                    >
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 16 16"
                                        fill="currentColor"
                                        aria-hidden="true"
                                      >
                                        <circle cx="8" cy="3.2" r="1.4" />
                                        <circle cx="8" cy="8" r="1.4" />
                                        <circle cx="8" cy="12.8" r="1.4" />
                                      </svg>
                                    </button>
                                  </div>
                                  {isDraftStatusMenuOpen && (
                                    <div className="absolute right-0 mt-2 w-40 rounded-md border border-gray-200 bg-white shadow-lg z-20 flex flex-col">
                                      {draftInvoiceStatusFilterOptions.map((option) => {
                                        const isActive = draftInvoiceStatusFilter === option.value;
                                        return (
                                          <button
                                            key={option.value}
                                            type="button"
                                            onClick={() => {
                                              setDraftInvoiceStatusFilter(option.value);
                                              setIsDraftStatusMenuOpen(false);
                                            }}
                                            className={`block w-full text-left px-3 py-2 text-xs hover:bg-gray-50 ${
                                              isActive
                                                ? "text-blue-700 font-semibold"
                                                : "text-gray-700"
                                            }`}
                                          >
                                            {option.label}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  )}
                                </div>
                            ) : isPayrollStatusHeader ? (
                              <div className="min-w-[110px] normal-case relative">
                                <div className="flex items-center justify-between gap-2">
                                  <div className="uppercase text-xs tracking-wide text-gray-500">{h}</div>
                                  <button
                                    type="button"
                                    onClick={() => setShowPayrollStatusMenu((prev) => !prev)}
                                    className="h-7 w-7 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white text-gray-600 hover:bg-gray-100"
                                    title="Filter status"
                                    aria-label="Filter status"
                                  >
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 16 16"
                                      fill="currentColor"
                                      aria-hidden="true"
                                    >
                                      <circle cx="8" cy="3.2" r="1.4" />
                                      <circle cx="8" cy="8" r="1.4" />
                                      <circle cx="8" cy="12.8" r="1.4" />
                                    </svg>
                                  </button>
                                </div>
                                {showPayrollStatusMenu && (
                                  <div className="absolute right-0 mt-2 w-36 rounded-md border border-gray-200 bg-white shadow-lg z-20 flex flex-col">
                                    {[
                                      { label: "All", value: "" },
                                      { label: "Paid", value: "paid" },
                                      { label: "Not Paid", value: "not paid" },
                                      { label: "Partial Paid", value: "partial paid" },
                                    ].map((option) => (
                                      <button
                                        key={option.label}
                                        type="button"
                                        onClick={() => {
                                          setPayrollStatusFilter(option.value);
                                          setShowPayrollStatusMenu(false);
                                        }}
                                        className={`block w-full text-left px-3 py-2 text-xs hover:bg-gray-50 ${
                                          payrollStatusFilter === option.value
                                            ? "text-blue-700 font-semibold"
                                            : "text-gray-700"
                                        }`}
                                      >
                                        {option.label}
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : isPayrollTransactionHeader ? (
                              <div className="min-w-[160px] normal-case">
                                <div className="flex items-center justify-between gap-2">
                                  <div className="uppercase text-xs tracking-wide text-gray-500">{h}</div>
                                  <button
                                    type="button"
                                    onClick={() => setShowPayrollTransactionSearch((prev) => !prev)}
                                    className="h-7 w-7 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white text-gray-600 hover:bg-gray-100"
                                    title="Search transaction"
                                    aria-label="Search transaction"
                                  >
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 16 16"
                                      fill="currentColor"
                                      aria-hidden="true"
                                    >
                                      <circle cx="8" cy="3.2" r="1.4" />
                                      <circle cx="8" cy="8" r="1.4" />
                                      <circle cx="8" cy="12.8" r="1.4" />
                                    </svg>
                                  </button>
                                </div>
                                {showPayrollTransactionSearch && (
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      value={payrollTransactionFilter}
                                      onChange={(e) => setPayrollTransactionFilter(e.target.value)}
                                      placeholder="Search"
                                      className="w-full border rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                  </div>
                                )}
                              </div>
                            ) : (
                              h
                            )}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody className="text-sm text-gray-700">
                    {filteredTableRows.length > 0 ? (
                      filteredTableRows.map((row) => (
                        <tr key={row.key} className="hover:bg-gray-50 border-b border-gray-100">
                          {row.cells.map((cell, idx) => {
                            const rowHeader = String(tabConfig.headers?.[idx] || "").trim().toLowerCase();
                            const isPhotoCell = rowHeader.includes("photo");
                            const isDesignationCell = rowHeader === "designation";
                            const isAssignedToCell = rowHeader === "assigned to" || rowHeader === "assigned_to";
                            const highlightedCell = highlightNodeText(cell, activeTableSearch);
                            if (currentTab === "payroll" && idx === 13) {
                              const isPaid = (row.meta?.status || "").toUpperCase() === "PAID";
                              return (
                                <td key={idx} className="px-3 py-3 min-w-[110px]">
                                  <span
                                    className={`px-2 py-0.5 rounded-full text-[10px] uppercase font-bold whitespace-nowrap inline-block ${
                                      isPaid ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                                    }`}
                                  >
                                    {highlightedCell}
                                  </span>
                                </td>
                              );
                            }
                            if (currentTab === "payroll" && idx === 11) {
                              const processedTs = toTimestamp(row.meta?.processedDateRaw);
                              const expectedTs = toTimestamp(row.meta?.expectedPayrollDateRaw);
                              const isGreen =
                                processedTs !== null &&
                                expectedTs !== null &&
                                expectedTs >= processedTs;
                              return (
                                <td
                                  key={idx}
                                  className={`px-3 py-3 font-semibold ${
                                    isGreen ? "text-green-600" : "text-red-600"
                                  }`}
                                >
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "payroll" && idx === 0) {
                              return (
                                <td key={idx} className="px-3 py-3 min-w-[220px]">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "payroll" && idx === 4) {
                              return (
                                <td key={idx} className="px-3 py-3 min-w-[180px]">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "payroll" && idx === 5) {
                              return (
                                <td key={idx} className="px-3 py-3 min-w-[160px]">
                                  {highlightedCell}
                                </td>
                              );
                            }

                            if (currentTab === "timesheet" && idx === 10) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right font-bold text-blue-600">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "invoice" && idx === 13) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right font-medium">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "outstandingInvoice" && idx === 13) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right font-medium">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "invoice" && (idx === 6 || idx === 7)) {
                              return (
                                <td key={idx} className="px-3 py-3 max-w-[120px] whitespace-normal break-words">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "outstandingInvoice" && (idx === 6 || idx === 7)) {
                              return (
                                <td key={idx} className="px-3 py-3 max-w-[120px] whitespace-normal break-words">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "invoice" && idx === 4) {
                              return (
                                <td key={idx} className="px-3 py-3 min-w-[180px]">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "outstandingInvoice" && idx === 4) {
                              return (
                                <td key={idx} className="px-3 py-3 min-w-[180px]">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "invoice" && idx === 14) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right text-green-600">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "outstandingInvoice" && idx === 14) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right text-green-600">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "invoice" && idx === 15) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right text-red-600 font-bold">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "outstandingInvoice" && idx === 15) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right text-red-600 font-bold">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "outstandingInvoice" && idx === 16) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right font-semibold text-amber-700">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "draftInvoice" && idx === 4) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right font-medium">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "draftInvoice" && idx === 5) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right text-amber-700">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "draftInvoice" && idx === 6) {
                              return (
                                <td key={idx} className="px-3 py-3 text-right text-green-700 font-bold">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "draftInvoice" && idx === 2) {
                              return (
                                <td key={idx} className="px-3 py-3 min-w-[240px]">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "draftInvoice" && idx === 0) {
                              return (
                                <td key={idx} className="px-3 py-3 min-w-[220px] text-center">
                                  {highlightedCell}
                                </td>
                              );
                            }
                            if (currentTab === "draftInvoice" && idx === 10) {
                              return (
                                <td key={idx} className="px-3 py-3 min-w-[180px]">
                                  {highlightedCell}
                                </td>
                              );
                            }

                            return (
                              <td
                                key={idx}
                                className={`px-3 py-3 ${
                                  isPhotoCell
                                    ? "w-[90px] min-w-[90px] max-w-[90px] text-center"
                                    : isDesignationCell
                                    ? "min-w-[320px]"
                                    : isAssignedToCell
                                    ? "min-w-[340px]"
                                    : ""
                                }`}
                              >
                                {highlightedCell}
                              </td>
                            );
                          })}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={tabConfig.headers.length}
                          className="py-20 text-center text-gray-400 italic"
                        >
                          {activeTableSearch.trim()
                            ? "No matching records found."
                            : "No records found for the selected criteria."}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {chartInsights && (
                <div className="order-1 mb-6">
                  <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
                    <h3 className="text-base font-semibold text-gray-700">{chartInsights.title}</h3>
                    {(currentTab === "invoice" || currentTab === "outstandingInvoice" || currentTab === "timesheet" || currentTab === "payroll" || currentTab === "draftInvoice") && (
                      <div className="flex items-center gap-2 flex-wrap">
                        <input
                          type="text"
                          value={
                            currentTab === "invoice"
                              ? invoiceChartClientSearch
                              : currentTab === "outstandingInvoice"
                              ? outstandingInvoiceChartClientSearch
                              : currentTab === "timesheet"
                              ? timesheetChartClientSearch
                              : currentTab === "payroll"
                              ? payrollChartClientSearch
                              : draftInvoiceChartClientSearch
                          }
                          onChange={(e) =>
                            currentTab === "invoice"
                              ? setInvoiceChartClientSearch(e.target.value)
                              : currentTab === "outstandingInvoice"
                              ? setOutstandingInvoiceChartClientSearch(e.target.value)
                              : currentTab === "timesheet"
                              ? setTimesheetChartClientSearch(e.target.value)
                              : currentTab === "payroll"
                              ? setPayrollChartClientSearch(e.target.value)
                              : setDraftInvoiceChartClientSearch(e.target.value)
                          }
                          placeholder="Search client"
                          className="h-9 w-[180px] rounded-md border border-gray-300 px-3 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                        <select
                          value={
                            currentTab === "invoice"
                              ? invoiceChartTopN
                              : currentTab === "outstandingInvoice"
                              ? outstandingInvoiceChartTopN
                              : currentTab === "timesheet"
                              ? timesheetChartTopN
                              : currentTab === "payroll"
                              ? payrollChartTopN
                              : draftInvoiceChartTopN
                          }
                          onChange={(e) =>
                            currentTab === "invoice"
                              ? setInvoiceChartTopN(e.target.value)
                              : currentTab === "outstandingInvoice"
                              ? setOutstandingInvoiceChartTopN(e.target.value)
                              : currentTab === "timesheet"
                              ? setTimesheetChartTopN(e.target.value)
                              : currentTab === "payroll"
                              ? setPayrollChartTopN(e.target.value)
                              : setDraftInvoiceChartTopN(e.target.value)
                          }
                          className="h-9 rounded-md border border-gray-300 px-2 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                        >
                          <option value="5">Top 5</option>
                          <option value="10">Top 10</option>
                          <option value="20">Top 20</option>
                          <option value="50">Top 50</option>
                          <option value="all">All</option>
                        </select>
                        {((currentTab === "invoice" && (invoiceChartClientSearch || invoiceChartTopN !== "10")) ||
                          (currentTab === "outstandingInvoice" &&
                            (outstandingInvoiceChartClientSearch || outstandingInvoiceChartTopN !== "10")) ||
                          (currentTab === "timesheet" &&
                            (timesheetChartClientSearch || timesheetChartTopN !== "10")) ||
                          (currentTab === "payroll" &&
                            (payrollChartClientSearch || payrollChartTopN !== "10")) ||
                          (currentTab === "draftInvoice" &&
                            (draftInvoiceChartClientSearch || draftInvoiceChartTopN !== "10"))) && (
                          <button
                            type="button"
                            onClick={() => {
                              if (currentTab === "invoice") {
                                setInvoiceChartClientSearch("");
                                setInvoiceChartTopN("10");
                              } else if (currentTab === "outstandingInvoice") {
                                setOutstandingInvoiceChartClientSearch("");
                                setOutstandingInvoiceChartTopN("10");
                              } else if (currentTab === "timesheet") {
                                setTimesheetChartClientSearch("");
                                setTimesheetChartTopN("10");
                              } else if (currentTab === "payroll") {
                                setPayrollChartClientSearch("");
                                setPayrollChartTopN("10");
                              } else {
                                setDraftInvoiceChartClientSearch("");
                                setDraftInvoiceChartTopN("10");
                              }
                            }}
                            className="h-9 rounded-md border border-gray-300 px-3 text-xs text-gray-700 hover:bg-gray-50"
                          >
                            Reset
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                  {(currentTab === "invoice" || currentTab === "outstandingInvoice" || currentTab === "timesheet" || currentTab === "payroll" || currentTab === "draftInvoice") && chartInsights?.filterMeta && (
                    <div className="mb-3 text-xs text-gray-500">
                      Showing {chartInsights.filterMeta.shownClients} of {chartInsights.filterMeta.totalClients} clients
                    </div>
                  )}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {/* Left panel */}
                    <div className="rounded-lg border border-gray-200 bg-gradient-to-br from-white to-slate-50 p-4 shadow-sm">
                      <div className="text-xs font-semibold uppercase text-gray-500 mb-2">
                        {chartInsights.left.label}
                      </div>
                      {chartInsights.left.data.length > 0 ? (
                        currentTab === "invoice" || currentTab === "outstandingInvoice" || currentTab === "timesheet" || currentTab === "draftInvoice" ? (
                          renderScrollableVerticalBar(chartInsights.left.data)
                        ) : (
                          <ResponsiveContainer width="100%" height={240}>
                            {currentTab === "payroll" ? (
                              <ComposedChart data={chartInsights.left.data}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="label" tick={{ fontSize: 11 }} />
                                <YAxis tick={{ fontSize: 11 }} />
                                <Tooltip />
                                <Bar dataKey="value" barSize={24} radius={[6, 6, 0, 0]}>
                                  {chartInsights.left.data.map((_, idx) => (
                                    <Cell key={`bar-${idx}`} fill={chartPalette[idx % chartPalette.length]} />
                                  ))}
                                </Bar>
                                <Line type="monotone" dataKey="value" stroke="#0f766e" strokeWidth={2} dot={false} />
                              </ComposedChart>
                            ) : (
                              <BarChart data={chartInsights.left.data} margin={{ top: 26, right: 12, left: 0, bottom: 20 }}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="label" tick={{ fontSize: 11 }} />
                                <YAxis tick={{ fontSize: 11 }} />
                                <Tooltip />
                                <Bar dataKey="value" radius={[6, 6, 0, 0]}>
                                  {chartInsights.left.data.map((_, idx) => (
                                    <Cell key={`bar-${idx}`} fill={chartPalette[idx % chartPalette.length]} />
                                  ))}
                                </Bar>
                              </BarChart>
                            )}
                          </ResponsiveContainer>
                        )
                      ) : (
                        <div className="text-sm text-gray-400 py-12 text-center">No data available</div>
                      )}
                    </div>
                    {/* Right panel */}
                    <div className="rounded-lg border border-gray-200 bg-gradient-to-br from-white to-slate-50 p-4 shadow-sm">
                      <div className="text-xs font-semibold uppercase text-gray-500 mb-2">
                        {chartInsights.right.label}
                      </div>
                      {chartInsights.right.data.length > 0 ? (
                        currentTab === "invoice" || currentTab === "outstandingInvoice" || currentTab === "timesheet" ? (
                          renderScrollableVerticalBar(chartInsights.right.data)
                        ) : (
                          <ResponsiveContainer width="100%" height={240}>
                            {currentTab === "payroll" ? (
                              <PieChart>
                                <Tooltip />
                                <Pie
                                  data={chartInsights.right.data}
                                  dataKey="value"
                                  nameKey="label"
                                  innerRadius={40}
                                  outerRadius={90}
                                  paddingAngle={4}
                                >
                                  {chartInsights.right.data.map((_, idx) => (
                                    <Cell key={`pie-${idx}`} fill={chartPalette[idx % chartPalette.length]} />
                                  ))}
                                </Pie>
                              </PieChart>
                            ) : (
                              <PieChart>
                                <Tooltip />
                                <Pie
                                  data={chartInsights.right.data}
                                  dataKey="value"
                                  nameKey="label"
                                  innerRadius={50}
                                  outerRadius={90}
                                  paddingAngle={4}
                                >
                                  {chartInsights.right.data.map((_, idx) => (
                                    <Cell key={`pie-${idx}`} fill={chartPalette[idx % chartPalette.length]} />
                                  ))}
                                </Pie>
                              </PieChart>
                            )}
                          </ResponsiveContainer>
                        )
                      ) : (
                        <div className="text-sm text-gray-400 py-12 text-center">No data available</div>
                      )}
                      {currentTab === "draftInvoice" && chartInsights.right.data.length > 0 && (
                        <div className="mt-3 flex flex-wrap items-start gap-2">
                          {chartInsights.right.data.map((item, idx) => (
                            <div
                              key={`${item.label}-${idx}`}
                              className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs"
                            >
                              <span
                                className="inline-block h-2.5 w-2.5 rounded-full"
                                style={{ backgroundColor: chartPalette[idx % chartPalette.length] }}
                              />
                              <span className="text-gray-700">{item.label}</span>
                              <span className="font-semibold text-gray-900">{Number(item.value || 0)}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <div className="order-2 mb-4 rounded-xl border border-blue-100 bg-gradient-to-r from-blue-50 via-white to-sky-50 p-3">
                <div className="flex flex-col md:flex-row md:items-center gap-3">
                  <div className="relative w-full md:max-w-2xl">
                    <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 inline-flex items-center justify-center leading-none">
                      <i className="ri-search-line text-base" aria-hidden="true"></i>
                    </span>
                    <input
                      type="text"
                      value={activeTableSearch}
                      onChange={(e) =>
                        setTableSearchByTab((prev) => ({
                          ...prev,
                          [currentTab]: e.target.value,
                        }))
                      }
                      placeholder="Search anything in this table..."
                      className="h-11 w-full rounded-lg border border-blue-200 bg-white pl-10 pr-10 text-sm text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                    {activeTableSearch.trim() && (
                      <button
                        type="button"
                        onClick={() =>
                          setTableSearchByTab((prev) => ({
                            ...prev,
                            [currentTab]: "",
                          }))
                        }
                        className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex h-7 w-7 items-center justify-center rounded-md p-0 leading-none text-gray-400 hover:bg-gray-100 hover:text-gray-700"
                        aria-label="Clear table search"
                      >
                        <svg className="block" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                          <path d="M18.3 5.71 12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.29 19.7l-1.41-1.42L9.17 12 2.88 5.71 4.29 4.3l6.3 6.29 6.3-6.29z" />
                        </svg>
                      </button>
                    )}
                  </div>
                  <div className="text-xs text-gray-600 md:ml-auto whitespace-nowrap">
                    {activeTableSearch.trim()
                      ? `${filteredTableRows.length} match${filteredTableRows.length === 1 ? "" : "es"}`
                      : `${tabConfig.rows.length} total rows`}
                  </div>
                </div>
              </div>

              <div className="order-4 mt-6 p-4 bg-blue-50 rounded-lg grid grid-cols-2 md:grid-cols-4 gap-4 text-sm border border-blue-100">
                {filteredTableRows.length > 0 ? (
                  tabConfig.summary
                ) : (
                  <div className="col-span-full text-center text-gray-500">No data to summarize</div>
                )}
              </div>
            </div>


            {loading && (
              <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-10">
                <div className="external-loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12"></div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
// Define the Dashboard functional component
function Dashboard() {

const getLocalInputDate = (date) => {
const year = date.getFullYear();
const month = String(date.getMonth() + 1).padStart(2, "0");
const day = String(date.getDate()).padStart(2, "0");
return `${year}-${month}-${day}`;
};

const getCurrentMonthReportRange = () => {
const today = new Date();
const previousDay = new Date(today);
previousDay.setDate(today.getDate() - 1);
return {
  from: getLocalInputDate(previousDay),
  to: getLocalInputDate(today),
};
};

const emptyReportMetrics = {
total_requirements: 0,
open_campaign: 0,
paid_campaign: 0,
self_candidate: 0,
campaign_candidate: 0,
total_selection: 0,
total_joining: 0,
total_onboarding: 0,
total_payroll: 0,
};

const [activeTab, setActiveTab] = useState("client");
const [showDetails, setShowDetails] = useState(false);
const [divy_accounts,setDivs]= useState(0);

const {refreshKey} = useContext(RefreshContext);
const [target,setTarget]= useState(0);
const [dashboardDataa,setDashboardDataa] = useState([]);
const [jobData,setJob]=useState([]);
const [filterStartDate, setFilterStartDate] = useState("");
const [filterEndDate, setFilterEndDate] = useState("");
const [filterDateError, setFilterDateError] = useState("");
const [selectedRequirement, setSelectedRequirement] = useState(null);
const [selectedStaff, setSelectedStaff] = useState(null);
const [loading, setLoading] = useState(false);
const [post,setPost]= useState('');
const [userType, setUserType] = useState('');
const [topDashboardTab, setTopDashboardTab] = useState("dashboard");
const [showReportModal, setShowReportModal] = useState(false);
const [reportLoading, setReportLoading] = useState(false);
const [reportData, setReportData] = useState([]);
const [reportSelfData, setReportSelfData] = useState([]);
const [reportManagers, setReportManagers] = useState([]);
const [reportRecruiters, setReportRecruiters] = useState([]);
const [reportRecruiterTables, setReportRecruiterTables] = useState([]);
const [selectedReportManager, setSelectedReportManager] = useState(null);
const [reportDateFrom, setReportDateFrom] = useState(() => getCurrentMonthReportRange().from);
const [reportDateTo, setReportDateTo] = useState(() => getCurrentMonthReportRange().to);
const [reportSearch, setReportSearch] = useState("");
const [showRecruiterTables, setShowRecruiterTables] = useState(false);
const [reportMeta, setReportMeta] = useState({
scopeType: "",
scopeLabel: "",
scopeName: "",
fromDate: "",
toDate: "",
});
const [columnss, setColumns] = useState([]);
const [activeType, setActiveType] = useState(null);
const [showTatDetails, setShowTatDetails] = useState(false);
const [clientWise,setClientWise] = useState([]);
const [invoiceSummaryRows, setInvoiceSummaryRows] = useState([]);
const [invoiceSummaryMeta, setInvoiceSummaryMeta] = useState({
total: 0,
paid: 0,
pending: 0,
in_process: 0,
rejected: 0,
role: ""
});
const [invoiceSummaryLoading, setInvoiceSummaryLoading] = useState(false);
const [licenseTrackerLoading, setLicenseTrackerLoading] = useState(false);
const [licenseTracker, setLicenseTracker] = useState({
summary: {
total_licenses: 0,
upcoming_licenses: 0,
expired_licenses: 0,
renewed_licenses: 0,
not_renewed_licenses: 0,
total_contracts: 0,
upcoming_contracts: 0,
expired_contracts: 0
},
client_wise: [],
upcoming_contracts: []
});

const [campaginWise,setcampaginWise] = useState([]);

const [headingData, setHeadindData] = useState({
stats : '',
stats2 : '', provendor:false,
profile: '',
expe: '',clientlead:'',
location: '',
stats3:'',
require:'',reqclient:'',
linestat:'',
totalreq:'',
onboardreq:'',
pipeline:'',
onboard:'',
vendor:'',
bd:false
});


const [loadings, setTableLoading] = useState(true);
const [requirementOptions,setREQoptions] = useState([]);
const [chartData,setOnboardChart] = useState([]);
const [insightTab, setInsightTab] = useState("profile");
const [requirementDetailTab, setRequirementDetailTab] = useState("creation");
const [showLineupRequirementWise, setShowLineupRequirementWise] = useState(false);
const [showOnboardingRequirementWise, setShowOnboardingRequirementWise] = useState(false);

const [dashboardData, setDashboardData] = useState({
stats : [],
stats2 : [],
profile: [],
expe: [],clientlead:[],
location: [],
pro: [] ,// Kept for backward compatibility if staff had other data.
stats3:[],
require:[],reqclient:[],
linestat:[],
totalreq:[],
onboardreq:[],
pipeline:[],
onboard:[],
  vendor:[],
  vendorRequirementDetails: [],
  viewShow:false,
clientgraph:[],
clientRequirements:[],
tatSummary: {
  totalCandidates: 0,
  overallAvgDays: 0,
  stages: [],
},
campaignTatSummary: {
  thresholdHours: 2,
  totalRequests: 0,
  exceededCount: 0,
  stageTat: [],
  exceededRequests: [],
  requestRows: [],
},
});

const getDashboardCardOrder = (cardKey) => DASHBOARD_CARD_ORDER[cardKey] ?? 999;

  // Helper function to get a random Tailwind background color class
const getRandomBgColor = () => {
  const colors = ['bg-blue-100', 'bg-green-100', 'bg-red-100', 'bg-yellow-100', 'bg-purple-100'];
  return colors[Math.floor(Math.random() * colors.length)];
};

// Helper function to get a random Tailwind text color class
const getRandomTextColor = () => {
  const colors = ['text-blue-600', 'text-green-600', 'text-red-600', 'text-yellow-600', 'text-purple-600'];
  return colors[Math.floor(Math.random() * colors.length)];
};

// Helper function to get a random border color class
const getRandomBorderColor = () => {
    const colors = ['border-accent-500', 'border-primary-500', 'border-accent-500', 'border-red-500', 'border-purple-600', 'border-teal-500'];
  return colors[Math.floor(Math.random() * colors.length)];
};

    
  const LINE_COLORS = {
    // Note: The order in the image is Processing (bottom), Bank Verification (middle), Payroll (top).
    processing: '#1f77b4',       // Blue (Used for the bottom layer)
    bankVerification: '#2ca02c', // Green (Used for the middle layer)
    payroll: '#ff7f0e'           // Orange (Used for the top layer)
};

const StackedAreaLeadChart = ({ data, title = "Onboarding" }) => {
    const safeData = Array.isArray(data) ? data : [];
    const hasData = safeData.some((item) =>
        ["payroll", "bankVerification", "processing"].some((key) => Number(item?.[key]) > 0)
    );

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            // Calculate the total value for the month (used in tooltips for stacked charts)
            const total = payload.reduce((sum, entry) => sum + entry.value, 0);

            return (
                <div style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0 1px 5px rgba(0,0,0,0.2)' }}>
                    <p style={{ fontWeight: 'bold', margin: '0 0 5px 0' }}>{label}</p>
                    {/* The payload naturally orders data keys from top to bottom (Payroll to Processing) */}
                    {payload.map((entry, index) => (
                        <p key={`item-${index}`} style={{ margin: '2px 0', color: entry.color }}>
                            <span style={{ marginRight: '5px' }}>●</span>
                            {`${entry.name}: ${entry.value.toLocaleString()}`}
                        </p>
                    ))}
                    <hr style={{ margin: '5px 0' }} />
                    <p style={{ fontWeight: 'bold', margin: '0' }}>Total: {total.toLocaleString()}</p>
                </div>
            );
        }
        return null;
    };

    if (!hasData) {
        return (
            <div style={{ height: 260, padding: 0 }}>
                <div className="flex h-[260px] flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-[linear-gradient(180deg,#f8fafc_0%,#ffffff_100%)] px-6 text-center">
                    <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-400">
                        <DashboardStatGlyph type="idcard" className="h-7 w-7" />
                    </div>
                    <p className="text-base font-semibold text-slate-700 mb-1">No onboarding graph data</p>
                    <p className="text-sm text-slate-400 mb-0">Processing, bank verification, and payroll trends will appear here once onboarding activity is available.</p>
                </div>
            </div>
        );
    }

    return (
        <div style={{ height: 260, padding: 0 }}>
                        <ResponsiveContainer width="100%" height="100%">
                <LineChart 
                    data={safeData}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }} 
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" vertical={false} />
                    {/* XAxis, YAxis, Tooltip, Legend remain the same */}
                    <XAxis dataKey="month" tickLine={false} axisLine={{ stroke: '#e0e0e0' }} />
                    <YAxis tickLine={false} axisLine={false} tickFormatter={value => value.toLocaleString()} /> 
                    <Tooltip content={<CustomTooltip />} />
                    <Legend iconType="circle" wrapperStyle={{ paddingTop: '10px' }} />

                    {/* ---------------------------------------------------- */}
                    {/* 1. Payroll Line */}
                    <Line
                        type="monotone" 
                        dataKey="payroll"
                        name="Payroll" 
                        stroke={LINE_COLORS.payroll}
                        strokeWidth={3}
                        dot={false} 
                        activeDot={{ r: 5 }}
                        // 🟢 FIX: Ensure no fill is applied
                        fill="none" 
                    />
                    
                    {/* 2. Bank Verification Line */}
                    <Line
                        type="monotone" 
                        dataKey="bankVerification"
                        name="Bank Verification"
                        stroke={LINE_COLORS.bankVerification}
                        strokeWidth={3}
                        dot={false}
                        activeDot={{ r: 5 }}
                        // 🟢 FIX: Ensure no fill is applied
                        fill="none" 
                    />

                    {/* 3. Processing Line */}
                    <Line
                        type="monotone" 
                        dataKey="processing"
                        name="Processing"
                        stroke={LINE_COLORS.processing}
                        strokeWidth={3}
                        dot={false}
                        activeDot={{ r: 5 }}
                        // 🟢 FIX: Ensure no fill is applied
                        fill="none" 
                    />
                    {/* ---------------------------------------------------- */}

                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

    const profileColorMap = (index) => {
        const colors = ['border-accent-500', 'border-primary-500', 'border-accent-500', 'border-red-500', 'border-purple-600', 'border-teal-500'];
        const accentColors = ['text-accent-green', 'text-primary-blue', 'text-accent-orange', 'text-red-500', 'text-purple-600', 'text-teal-500'];
        const bgColors = ['bg-success-gradient', 'bg-primary-gradient', 'bg-warning-gradient', 'bg-danger-gradient', 'bg-purple-600', 'bg-teal-500'];
        
        return {
            borderColor: colors[index % colors.length],
            accentColor: accentColors[index % accentColors.length],
            bgColor: bgColors[index % bgColors.length],
        };
    };
    
// Use the same icon for all location cards (as requested).
const locationIconMap = () => "ri-navigation-line";

const buildDashboardFilterParams = (startDateArg, endDateArg, reqArg, staffArg) => {
    const startDateValue = startDateArg ?? (filterStartDate ? new Date(`${filterStartDate}T00:00:00`) : null);
    const endDateValue = endDateArg ?? (filterEndDate ? new Date(`${filterEndDate}T00:00:00`) : null);
    const requirementValue = reqArg ?? (selectedRequirement ? selectedRequirement.value : 'all');
    const staffValue = staffArg ?? (selectedStaff ? selectedStaff.value : 'all');

    const params = {};

    if (startDateValue && endDateValue) {
      params.fromdate = startDateValue.toISOString().split('T')[0];
      params.todate = endDateValue.toISOString().split('T')[0];
    }

    if (requirementValue && requirementValue !== 'all') {
      params.requirement = requirementValue;
    }

    if (staffValue && staffValue !== 'all') {
      params.staff = staffValue;
    }

    return params;
};

const fetchRequirementDetailSections = async (startDateArg, endDateArg, reqArg, staffArg) => {
  const filterParams = buildDashboardFilterParams(startDateArg, endDateArg, reqArg, staffArg);
  const [assignedRes, creationRes] = await Promise.all([
    axios.get(`${apiurl}dashboard.php`, {
      params: { subdomain: 'react', type: 'require_assigned_details', ...filterParams },
    }),
    axios.get(`${apiurl}dashboard.php`, {
      params: { subdomain: 'react', type: 'require_creation', ...filterParams },
    }),
  ]);

  const assignedRaw = assignedRes?.data?.dataObject;
  const assignedRows = Array.isArray(assignedRaw)
    ? assignedRaw
    : (assignedRaw && typeof assignedRaw === "object"
      ? Object.values(assignedRaw).filter((row) => row && typeof row === "object" && !Array.isArray(row))
      : []);

  const creationRaw = creationRes?.data?.dataObject;
  let creationRows = [];
  if (Array.isArray(creationRaw)) {
    creationRows = creationRaw;
  } else if (creationRaw && typeof creationRaw === "object") {
    creationRows = Object.values(creationRaw).filter(
      (row) => row && typeof row === "object" && !Array.isArray(row)
    );
  }

  return { assignedRows, creationRows };
};

const handleApplyFilters = async () => {
    const startDate = filterStartDate ? new Date(`${filterStartDate}T00:00:00`) : null;
    const endDate = filterEndDate ? new Date(`${filterEndDate}T00:00:00`) : null;
    const req = selectedRequirement ? selectedRequirement.value : 'all';
    const staff = selectedStaff ? selectedStaff.value : 'all';

    if (!startDate || !endDate) {
      setFilterDateError("First select start date and end date.");
      return;
    }

    setFilterDateError("");

    console.log('Applying Filters:', {
        dateRange: startDate && endDate ? `${startDate.toISOString().split('T')[0]} to ${endDate.toISOString().split('T')[0]}` : 'No range selected',
        requirement: req,
        staff: staff,
    });
    
    await Promise.all([
      fetchData(startDate, endDate, req, staff),
      fetchAdvancePaymentSummary(startDate, endDate, req, staff),
    ]);

    if (sectionData.require.show) {
      setSectionData((prev) => ({
        ...prev,
        require: { ...prev.require, loading: true, show: true },
        requireCreation: { ...prev.requireCreation, loading: true, show: true },
      }));
      try {
        const { assignedRows, creationRows } = await fetchRequirementDetailSections(startDate, endDate, req, staff);
        setSectionData((prev) => ({
          ...prev,
          require: { ...prev.require, data: assignedRows, activeTab: null },
          requireCreation: { ...prev.requireCreation, data: creationRows },
        }));
      } catch (error) {
        console.error(error);
      } finally {
        setSectionData((prev) => ({
          ...prev,
          require: { ...prev.require, loading: false },
          requireCreation: { ...prev.requireCreation, loading: false },
        }));
      }
    }

    if (showAdvancePaymentDetails) {
      setAdvancePaymentDetailLoading(true);
      setAdvancePaymentError("");
      try {
        const rows = await fetchAllAdvancePaymentRows(startDate, endDate, req, staff);
        setAdvancePaymentRows(rows);
      } catch (error) {
        setAdvancePaymentRows([]);
        setAdvancePaymentError(error?.message || "Unable to load advance payment details right now.");
      } finally {
        setAdvancePaymentDetailLoading(false);
      }
    }
};

const handleClearFilters = async () => {
    setFilterStartDate("");
    setFilterEndDate("");
    setSelectedRequirement(null);
    setSelectedStaff(null);
    setFilterDateError("");
    await Promise.all([
      fetchData(),
      fetchAdvancePaymentSummary(),
    ]);

    if (sectionData.require.show) {
      setSectionData((prev) => ({
        ...prev,
        require: { ...prev.require, loading: true, show: true },
        requireCreation: { ...prev.requireCreation, loading: true, show: true },
      }));
      try {
        const { assignedRows, creationRows } = await fetchRequirementDetailSections();
        setSectionData((prev) => ({
          ...prev,
          require: { ...prev.require, data: assignedRows, activeTab: null },
          requireCreation: { ...prev.requireCreation, data: creationRows },
        }));
      } catch (error) {
        console.error(error);
      } finally {
        setSectionData((prev) => ({
          ...prev,
          require: { ...prev.require, loading: false },
          requireCreation: { ...prev.requireCreation, loading: false },
        }));
      }
    }

    if (showAdvancePaymentDetails) {
      setAdvancePaymentDetailLoading(true);
      setAdvancePaymentError("");
      try {
        const rows = await fetchAllAdvancePaymentRows();
        setAdvancePaymentRows(rows);
      } catch (error) {
        setAdvancePaymentRows([]);
        setAdvancePaymentError(error?.message || "Unable to load advance payment details right now.");
      } finally {
        setAdvancePaymentDetailLoading(false);
      }
    }
};

// Assume you are using React's useState hook

const initialTabbedSectionState = {
    lineup: { 
        data: {}, // The object containing all tab arrays: { cxo_wise: [...], sh_wise: [...], ...}
        activeTab: null,
        show: false, // Controls whether the tabbed view is visible
        loading: false
    },
    onboardreq: {
        data: {}, 
        activeTab: null,
        show: false, 
        loading: false
    },
    clientlead: { 
        data: {}, // The object containing all tab arrays: { cxo_wise: [...], sh_wise: [...], ...}
        activeTab: null,
        show: false, // Controls whether the tabbed view is visible
        loading: false
    },
    reqclient: { 
        data: {}, // The object containing all tab arrays: { cxo_wise: [...], sh_wise: [...], ...}
        activeTab: null,
        show: false, // Controls whether the tabbed view is visible
        loading: false
    },
     campaign: { 
        data: {}, // The object containing all tab arrays: { cxo_wise: [...], sh_wise: [...], ...}
        activeTab: null,
        show: false, // Controls whether the tabbed view is visible
        loading: false
    },
};

const [tabbedSectionData, setTabbedSectionData] = useState(initialTabbedSectionState);

const fetchData = async (startDate, endDate, req, staff) => {
    setLoading(true);
    setTableLoading(true);
    setShowTatDetails(false);
    try {
        let url = apiurl + 'dashboard.php?subdomain=react';
        const filterParams = buildDashboardFilterParams(startDate, endDate, req, staff);
        const queryString = new URLSearchParams(filterParams).toString();
        if (queryString) {
            url += `&${queryString}`;
        }
        
        const response = await axios.get(url);

        const data = response.data;
        setREQoptions(data.reqoptions);
        if(data.divy_accounts===1){
          setDivs(data.divy_accounts);
          setPost(response.data.loginpost);
          setUserType((data.typess || "").toString());
          
           setDashboardData({
              stats: [],
              stats2: [],
              profile: [],
              expe: [],
              location: [],
              pro: [],
              stats3: [],
              require: [],
              linestat: [],
              totalreq: [],
              onboardreq: [],
              pipeline: [],
              onboard: [],
              vendor: data.vendor || [],
              vendorRequirementDetails: data.vendorRequirementDetails || [],
              viewShow: false,
              clientgraph: [],
              clientRequirements: [],
              tatSummary: data.tatSummary || { totalCandidates: 0, overallAvgDays: 0, stages: [] },
              campaignTatSummary: data.campaignTatSummary || {
                thresholdHours: 2, totalRequests: 0, exceededCount: 0, stageTat: [], exceededRequests: [], requestRows: []
              }
           });

        } else {
        setJob(response.data.team);
        const loginPost=data.loginpost;
        setTarget(response.data.campaigntarget);
        setOnboardChart(response.data.chartData);
       
        setPost(response.data.loginpost);
        setUserType((data.typess || "").toString());
        setHeadindData({
           stats: response.data.hstats,
           stats2: response.data.hstats2,
           viewShow: response.data.bd,
           provendor: response.data.vendorShow
        });
       
         const tabclientlead = data.campclient?.[0] || {};
         const tabreqlead = data.reqclient?.[0] || {};
         const allowedTabs = tabsByPost[loginPost] || []; 
         const firstKey = allowedTabs[0]?.key || null;
         const tabDataForLineup = data.totalreq?.[0] || {}; 
         const tabDataForOnboardReq = data.onboardreq?.[0] || {};

        if (data.viewShow === '1') {
            if (firstKey) {
                setTabbedSectionData(prev => ({
                    ...prev,
                    lineup: { 
                        data: tabDataForLineup,
                        activeTab: firstKey,
                        show: true, // Show tabs
                        loading: false, 
                    },
                    onboardreq: { 
                        data: tabDataForOnboardReq,
                        activeTab: firstKey,
                        show: true, // Show tabs
                        loading: false, 
                    },
                    clientlead: { 
                        data: tabclientlead,
                        activeTab: firstKey,
                        show: true, // Show tabs
                        loading: false, 
                    },
                    reqclient: { 
                        data: tabreqlead,
                        activeTab: firstKey,
                        show: true, // Show tabs
                        loading: false, 
                    },
                }));
            }
        }
        else if(data.viewShow!='2'){
              setTabbedSectionData(prev => ({
                    ...prev,
                    lineup: { 
                        data: tabDataForLineup,
                        activeTab: 'rec_wise',
                        show: true, // Show tabs
                        loading: false, 
                    },
                    onboardreq: { 
                        data: tabDataForOnboardReq,
                        activeTab: 'rec_wise',
                        show: true, // Show tabs
                        loading: false, 
                    },
                   clientlead: { 
                        data: tabclientlead,
                        activeTab: 'rec_wise',
                        show: true, // Show tabs
                        loading: false, 
                    },
                    reqclient: { 
                        data: tabreqlead,
                        activeTab: 'rec_wise',
                        show: true, // Show tabs
                        loading: false, 
                    },
                }));
        }
        else if(data.viewShow=='2'){
           const tabclientlead2 = data.getCamp?.[0] || {};
          setTabbedSectionData(prev => ({
                    ...prev,
                    campaign: { 
                        data: tabclientlead2,
                        activeTab: 'sh_wise',
                        show: true, // Show tabs
                        loading: false, 
                    }
                }));
          setClientWise(data.campclient);setcampaginWise(data.campaignWise);
          
        }
       
         setDashboardData({
            profile: data.profile || [],
            expe: data.expe || [],
            location: data.location || [],
            pro: data.pro || [],
            stats:data.stats || [],
            stats2:data.stats2 || [],
            clientlead:data.campclient || [],
            stats3:data.stats3 || [],
            require:data.require || [],
            linestat:data.linestat || [],
            totalreq:data.totalreq || [],
            onboardreq:data.onboardreq || [],
            onboard:data.onboard || [],
            pipeline:data.pipline || [],
            vendor:data.vendor || [],
            vendorRequirementDetails:data.vendorRequirementDetails || [],
            viewShow:data.viewShow,
            clientgraph:data.clientleadgraph ||[],
            clientRequirements:data.clientRequirementGraph || [],
            tatSummary:data.tatSummary || { totalCandidates: 0, overallAvgDays: 0, stages: [] },
            campaignTatSummary:data.campaignTatSummary || {
              thresholdHours: 2, totalRequests: 0, exceededCount: 0, stageTat: [], exceededRequests: [], requestRows: []
            }
        });
      }
    } catch (error) {
        console.error("Error fetching dashboard data:", error);
    } finally {
        setLoading(false);
        setTableLoading(false);
    }
};

const fetchAdvancePaymentSummary = async (startDate, endDate, req, staff) => {
  setAdvancePaymentLoading(true);
  setAdvancePaymentError("");

  try {
    const filterParams = buildDashboardFilterParams(startDate, endDate, req, staff);
    const response = await axios.get(`${apiurl}dashboard.php`, {
      params: {
        subdomain: "react",
        type: "advance_payment_dashboard",
        ...filterParams,
      },
    });

    if (response.data?.status === true) {
      setAdvancePaymentSummary({
        ...initialAdvancePaymentSummary,
        ...(response.data.summary || {}),
      });
      setShowAdvancePaymentCard(true);
      return;
    }

    setShowAdvancePaymentCard(false);
    setShowAdvancePaymentDetails(false);
    setAdvancePaymentRows([]);
    setAdvancePaymentSummary(initialAdvancePaymentSummary);
  } catch (error) {
    setShowAdvancePaymentCard(false);
    setShowAdvancePaymentDetails(false);
    setAdvancePaymentRows([]);
    setAdvancePaymentSummary(initialAdvancePaymentSummary);
  } finally {
    setAdvancePaymentLoading(false);
  }
};

const fetchAllAdvancePaymentRows = async (startDate, endDate, req, staff) => {
  const filterParams = buildDashboardFilterParams(startDate, endDate, req, staff);
  const response = await axios.get(`${apiurl}dashboard.php`, {
    params: {
      subdomain: "react",
      type: "advance_payment_dashboard",
      ...filterParams,
    },
  });

  if (response.data?.status !== true) {
    throw new Error(response.data?.message || "Failed to load advance payment details.");
  }

  setAdvancePaymentSummary({
    ...initialAdvancePaymentSummary,
    ...(response.data.summary || {}),
  });

  return Array.isArray(response.data?.dataObject) ? response.data.dataObject : [];
};

const handleAdvancePaymentDetailsToggle = async () => {
  if (showAdvancePaymentDetails) {
    setShowAdvancePaymentDetails(false);
    return;
  }

  setShowAdvancePaymentDetails(true);
  setAdvancePaymentDetailLoading(true);
  setAdvancePaymentError("");

  try {
    const rows = await fetchAllAdvancePaymentRows();
    setAdvancePaymentRows(rows);
  } catch (error) {
    setAdvancePaymentRows([]);
    setAdvancePaymentError(error?.message || "Unable to load advance payment details right now.");
  } finally {
    setAdvancePaymentDetailLoading(false);
  }
};

const fetchInvoiceSummary = async () => {
  try {
    setInvoiceSummaryLoading(true);
    const response = await axios.get(`${apiurl}save_invoice.php?list=dashboard_invoice_summary`);
    if (response.data?.status === true) {
      const summary = response.data.summary || {};
      setInvoiceSummaryMeta({
        total: Number(summary.total || 0),
        paid: Number(summary.paid || 0),
        pending: Number(summary.pending || 0),
        in_process: Number(summary.in_process || 0),
        rejected: Number(summary.rejected || 0),
        role: (response.data.role || "").toString(),
      });
      setInvoiceSummaryRows(Array.isArray(response.data.data) ? response.data.data : []);
    } else {
      setInvoiceSummaryRows([]);
    }
  } catch (error) {
    setInvoiceSummaryRows([]);
  } finally {
    setInvoiceSummaryLoading(false);
  }
};

const fetchLicenseTrackerSummary = async () => {
  try {
    setLicenseTrackerLoading(true);
    const response = await axios.get(`${apiurl}license_registration.php?list=dashboard_tracker_summary`);
    if (response?.data?.status === true) {
      setLicenseTracker({
        summary: response?.data?.summary || {},
        client_wise: Array.isArray(response?.data?.client_wise) ? response.data.client_wise : [],
        upcoming_contracts: Array.isArray(response?.data?.upcoming_contracts) ? response.data.upcoming_contracts : []
      });
    } else {
      setLicenseTracker({
        summary: {},
        client_wise: [],
        upcoming_contracts: []
      });
    }
  } catch (error) {
    setLicenseTracker({
      summary: {},
      client_wise: [],
      upcoming_contracts: []
    });
  } finally {
    setLicenseTrackerLoading(false);
  }
};

    useEffect(() => {
        fetchData();
        fetchAdvancePaymentSummary();
        fetchInvoiceSummary();
        fetchLicenseTrackerSummary();
        document.title = "Dashboard |  MERAQUI";
    }, [refreshKey]);

const formatInvoiceAmount = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "-";
  return `INR ${num.toLocaleString("en-IN")}`;
};

const formatInvoiceDateTime = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatInvoiceTat = (startValue, endValue) => {
  if (!startValue || !endValue) return "-";
  const start = new Date(startValue);
  const end = new Date(endValue);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return "-";
  const diffMs = end.getTime() - start.getTime();
  if (diffMs <= 0) return "-";
  const totalMinutes = Math.floor(diffMs / 60000);
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;
  if (days > 0) return `${days}d ${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};

const getInvoiceStageBadgeClass = (stage) => {
  const text = (stage || "").toString().trim().toLowerCase();
  if (text === "paid" || text === "invoice settled") return "bg-success";
  if (text === "payment" || text === "process for settlement") return "bg-info";
  if (text === "rejected") return "bg-danger";
  return "bg-warning";
};
    
const tableData = activeTab === "client"  ? dashboardData.clientlead  : dashboardData.location;

const DashboardChartTwo = ({ data, statName, keyLabel, keyCount }) => {
  
    if (!data || !Array.isArray(data) || data.length === 0) {
        return <div style={{ height: 250, textAlign: 'center', paddingTop: 100 }}>No data available to display chart.</div>;
    }

    const labels = data.map(s => s[keyLabel]);
    const counts = data.map(s => s[keyCount]);

    // --- Series Setup ---
    const series = [{
        name: statName, // Use the provided statName
        data: counts,
    }];

    // --- Options Setup (Your Beautiful Structure) ---
    const options = {
        chart: {
            type: 'area',
            height: 250,
            toolbar: { show: false },
        },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 3, colors: ['#4e73df'] },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100],
                colorStops: [
                    { offset: 0, color: '#4e73df', opacity: 0.1 },
                    { offset: 100, color: '#FFFFFF', opacity: 0.9 }
                ]
            }
        },
        xaxis: {
            categories: labels,
            tooltip: { enabled: false }
        },
        yaxis: {
            show: false, // Hidden Y-axis
        },
        grid: { show: false }, // Hidden Grid
        markers: { size: 5, colors: ['#4e73df'], strokeColors: '#fff', strokeWidth: 2 }
    };

    return (
        <ReactApexChart 
            options={options} 
            series={series} 
            type="area" 
            height={200} 
        />
    );
};

    const ProfilePieChart = ({ data, keyLabel, keyValue }) => {
    if (!data || data.length === 0) {
        return <div>No Data Available</div>;
    }

    // 2. Ensure seriesData contains actual NUMBERS, not strings
    const seriesData = data.map(item => Number(item[keyValue]) || 0);
    const labels = data.map(item => item[keyLabel] || 'N/A');

    const options = {
        chart: {
            type: 'pie', // Changed to 'pie'
            height: 300,
        },
        labels: labels, // Set labels for each slice
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }],
        legend: {
            position: 'bottom' // Place legend at the bottom for clarity
        },
        tooltip: {
            y: {
                formatter: function (value) {
                    return value.toLocaleString(); // Format number for readability
                }
            }
        }
    };

    return (
        <ReactApexChart options={options} series={seriesData} type="pie" height={300} />
    );
};

const ClientLeadStacked = ({ data }) => {
   const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const fullClient = payload[0].payload.client; // full name
      
      return (
        <div style={{ background: "#fff", padding: "8px", borderRadius: 6, boxShadow: "0px 0px 8px rgba(0,0,0,0.15)" }}>
          <p><strong>{fullClient}</strong></p>

          <p style={{ color: "#3B82F6" }}>Pending: {payload[0].payload.pending}</p>
          <p style={{ color: "#FACC15" }}>On Hold: {payload[0].payload.onhold}</p>
          <p style={{ color: "#F97316" }}>Closed: {payload[0].payload.closed}</p>
        </div>
      );
    }
    return null;
  };
  return (
   <>
     <ResponsiveContainer width="100%" height={250}>
        <BarChart
          data={data} 
          barCategoryGap={60}  
          barGap={0} // space between bars
        >
          <XAxis dataKey="clientshort" tick={true} axisLine={true} />
          <YAxis />
          <Tooltip
          content={<CustomTooltip />}
            cursor={{ fill: "transparent" }}
          />
          <Legend />

          {/* STACKED BARS */}
          <Bar dataKey="pending" stackId="a" fill="#3B82F6">
           </Bar>
          <Bar dataKey="onhold" stackId="a" fill="#FACC15" />
          <Bar dataKey="closed" stackId="a" fill="#F97316" />
        </BarChart>
      </ResponsiveContainer>
      </>
  );
}

const columns = React.useMemo(() => {
    const base = [];

    // CASE 1: viewShow === 1
    if (headingData.viewShow === 1) {

        // Client Wise Columns
        if (activeTab === "client") {
            base.push(
                { name: "Client Name", selector: row => row.client, sortable: true, wrap: true },
                { name: "Total", selector: row => row.total, sortable: true, wrap: true },
                { name: "Pending", selector: row => row.pending, sortable: true, wrap: true },
                { name: "Onhold", selector: row => row.onhold, sortable: true, wrap: true },
                { name: "Closed", selector: row => row.closed, sortable: true, wrap: true },
                { name: "Assigned to SH", selector: row => row.assign, sortable: true, wrap: true },
            );
        }

        // Location Wise Columns (inside viewShow === 1)
        if (activeTab === "location") {
            base.push(
                { name: "Location", selector: row => row.location, sortable: true, wrap: true },
                { name: "Total", selector: row => row.total, sortable: true, wrap: true },
                { name: "Pending", selector: row => row.pending, sortable: true, wrap: true },
                { name: "Onhold", selector: row => row.onhold, sortable: true, wrap: true },
                { name: "Closed", selector: row => row.closed, sortable: true, wrap: true },
                { name: "Assigned to SH", selector: row => row.assign, sortable: true, wrap: true },
            );
        }
    }

    // CASE 2: viewShow !== 1
    else {
        base.push(
            { name: "Client/Location", selector: row => row.client, sortable: true, wrap: true },
            { name: "Today", selector: row => row.today, sortable: true, wrap: true },
            { name: "Week", selector: row => row.week, sortable: true, wrap: true },
            { name: "Month", selector: row => row.month, sortable: true, wrap: true }
        );
    }

    return base;

}, [headingData.viewShow, activeTab]);

const columns3 = [
    { name: "Requirement Name", selector: (row) => row.jobtitle, sortable: true, wrap: true },
    { name: "Total Position", selector: (row) => row.position, sortable: true, wrap: true },
    { name: "Candidates", selector: (row) => row.total, sortable: true, wrap: true },
    { name: "Selected", selector: (row) => row.select, sortable: true, wrap: true },
    { name: "Joined", selector: (row) => row.joined, sortable: true, wrap: true },
    { name: "Onboard", selector: (row) => row.onboard, sortable: true, wrap: true },
    { name: "Payroll", selector: (row) => row.pay, sortable: true, wrap: true },
];


const RechartsStackedBarChart = ({ data }) => {

  return (
      <ResponsiveContainer width="100%" height={260}>
        <ComposedChart
          data={data}
          margin={{ top: 0, right: 24, left: 0, bottom: 50 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />

          <XAxis
            dataKey="client_short"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: '#6b7280' }}
            angle={-35}
            textAnchor="end"
            interval={0}
          />

          {/* Left Y — today & week bars */}
          <YAxis
            yAxisId="left"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: '#6b7280' }}
            label={{ value: 'Today / Week', angle: -90, position: 'insideLeft', fontSize: 11, fill: '#9ca3af' }}
          />

          {/* Right Y — month line */}
          <YAxis
            yAxisId="right"
            orientation="right"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: '#f59e0b' }}
            label={{ value: 'Month', angle: 90, position: 'insideRight', fontSize: 11, fill: '#f59e0b' }}
          />

          <Tooltip
            contentStyle={{ borderRadius: 8, fontSize: 12, border: '1px solid #e5e7eb' }}
            formatter={(value, name) => [value.toLocaleString(), name]}
            labelFormatter={(label) => {
              const found = data.find(d => d.client_short === label);
              return `Client: ${found ? found.client : label}`;
            }}
          />

          <Legend
            verticalAlign="top"
            align="center"
            wrapperStyle={{ fontSize: 12, paddingTop: 0 }}
            iconType="square"
          />

          <Bar
            yAxisId="left"
            dataKey="today"
            name="Today"
            fill="#6366f1"
            radius={[4, 4, 0, 0]}
            barSize={16}
          />

          <Bar
            yAxisId="left"
            dataKey="week"
            name="Week"
            fill="#06b6d4"
            radius={[4, 4, 0, 0]}
            barSize={16}
          />

          <Line
            yAxisId="right"
            type="monotone"
            dataKey="month"
            name="Month (line)"
            stroke="#f59e0b"
            strokeWidth={2.5}
            dot={{ r: 4, fill: '#f59e0b' }}
            activeDot={{ r: 6 }}
          />

        </ComposedChart>
      </ResponsiveContainer>
  );
};

const COLORS = ['#0088FE', '#FFBB28', '#FF8042', '#00C49F'];

const RequirementsDonutChart = ({ data = [] }) => {
  const chartData = useMemo(
    () =>
      (Array.isArray(data) ? data : [])
        .map((item, index) => ({
          name: item?.label || `Status ${index + 1}`,
          value: Number.parseInt(item?.count, 10) || 0,
          color: item?.hexcolor || COLORS[index % COLORS.length],
        }))
        .sort((a, b) => b.value - a.value),
    [data]
  );

  const totalRequirements = chartData.reduce((sum, item) => sum + item.value, 0);

  if (!chartData.length) {
    return (
      <div className="flex min-h-[220px] items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-white text-sm text-slate-400">
        No requirement data available
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      {chartData.map((item) => {
        const share = totalRequirements ? (item.value / totalRequirements) * 100 : 0;
        return (
          <div key={item.name} className="rounded-lg border border-slate-200 bg-slate-50 px-2.5 py-1.5 shadow-sm">
            <div className="mb-1 flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full" style={{ backgroundColor: item.color }} />
                <span className="text-xs font-semibold text-slate-700">{item.name}</span>
              </div>
              <span className="text-sm font-bold text-slate-900">{item.value}</span>
            </div>
            <div className="h-1 overflow-hidden rounded-full bg-slate-200">
              <div
                className="h-full rounded-full"
                style={{ width: `${Math.max(share, 6)}%`, backgroundColor: item.color }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

const RequirementsStatsMiniChart = ({ data = [] }) => {
  const chartData = useMemo(() => {
    const source = Array.isArray(data) ? data : [];
    return source
      .map((item, index) => {
        const label = String(item?.label || `Status ${index + 1}`);
        const value = Number(item?.count || 0);
        const color = item?.hexcolor || item?.color || COLORS[index % COLORS.length];
        const shortLabel =
          label.length > 14 ? `${label.slice(0, 14).trim()}...` : label;
        return { label, shortLabel, value, color };
      })
      .filter((row) => row.label && Number.isFinite(row.value));
  }, [data]);

  if (!chartData.length) {
    return (
      <div className="flex min-h-[180px] items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-white text-sm text-slate-400">
        No requirement data available
      </div>
    );
  }

  const maxValue = Math.max(...chartData.map((d) => d.value), 0);
  const yAxisMax = maxValue < 5 ? 5 : Math.ceil(maxValue * 1.25);

  return (
    <div className="h-[155px] w-full min-w-0">
      <ResponsiveContainer width="100%" height={155} minWidth={1} minHeight={155}>
        <AreaChart data={chartData} margin={{ top: 8, right: 12, left: 0, bottom: 18 }}>
          <defs>
            <linearGradient id="reqStatsFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#2563eb" stopOpacity={0.35} />
              <stop offset="95%" stopColor="#2563eb" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
          <XAxis
            dataKey="shortLabel"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: "#6b7280" }}
            angle={-18}
            textAnchor="end"
            interval={0}
          />
          <YAxis hide domain={[0, yAxisMax]} />
          <Tooltip
            cursor={{ stroke: "#cbd5e1", strokeWidth: 1 }}
            contentStyle={{ borderRadius: 10, fontSize: 12, border: "1px solid #e5e7eb" }}
            labelFormatter={(_, payload) => payload?.[0]?.payload?.label ?? ""}
            formatter={(value) => [Number(value || 0).toLocaleString(), "Requirements"]}
          />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#2563eb"
            strokeWidth={2.2}
            fill="url(#reqStatsFill)"
            dot={{ r: 4, fill: "#2563eb", strokeWidth: 2, stroke: "#fff" }}
            activeDot={{ r: 6 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

const ClientLeadAreaChart = ({ data, xKey, yKey, title = "Lead Data (Graph)" }) => {
 const safeData = Array.isArray(data) ? data : [];
 const yValues = safeData.map(item => item[yKey] || 0);
    const maxDataValue = Math.max(...yValues, 0); 
    const yAxisMax = (maxDataValue < 10) ? 10 : Math.ceil(maxDataValue * 1.1); 
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            // Assume the 'name' (label) is the client name
            const value = payload[0].value;
            const dataKey = payload[0].dataKey;
            
            return (
                <div style={{ backgroundColor: '#fff', padding: '8px 12px', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                   <p style={{ fontWeight: 'bold', margin: '0 0 4px 0', fontSize: '14px' }}>{label}</p>
                    <p style={{ margin: 0, color: payload[0].stroke, fontSize: '14px' }}>
                        <span style={{ color: payload[0].stroke, marginRight: '5px' }}>●</span>
                        {`${dataKey}: ${value.toLocaleString()}`}
                    </p>
                </div>
            );
        }
        return null;
    };
    // --------------------------------

    return (
        <div style={{ height: 200, minWidth: 0 }}>
            <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '16px', alignSelf: 'flex-start' }}>{title}</h3>
            
            <ResponsiveContainer width="100%" height={160} minWidth={1} minHeight={160}>
                <AreaChart
                    data={safeData}
                    // Adjusted margin to hide Y-axis but leave a bit of room
                    margin={{ top: 10, right: 30, left: 1, bottom: 0 }} 
                >
                    {/* Define the gradient fill for the area (Light Green) */}
                    <defs>
                        <linearGradient id="colorLeads" x1="0" y1="0" x2="0" y2="1">
                            {/* Color is light teal/green (#4CAF50 is a good match for the image) */}
                            <stop offset="5%" stopColor="#20C997" stopOpacity={0.8}/> 
                            <stop offset="95%" stopColor="#20C997" stopOpacity={0.1}/>
                        </linearGradient>
                    </defs>

                    {/* Hiding the vertical grid lines */}
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" />
                    
                    {/* X-Axis (Client Names) */}
                    <XAxis 
                        dataKey={xKey} 
                        tickLine={false} 
                        axisLine={{ stroke: '#e0e0e0' }}
                        // Set tick margin to 0 to prevent cutting off labels (like Alpha Corp, Beta Solutions)
                        padding={{ left: 10, right: 10 }}
                    />
                    
                    {/* Y-Axis (Count) - Hidden to match the visual style in images 1b3115/1ab1b1 */}
                    <YAxis 
                        dataKey={yKey}
                        hide={true} // Hides the axis numbers and line
                        domain={[0, yAxisMax]} 
                    /> 

                    {/* Tooltip on Hover */}
                    <Tooltip content={<CustomTooltip />} />

                    {/* The Area Series */}
                    <Area
                        type="linear" // Simple straight line segments (vs 'monotone' curve)
                        dataKey={yKey}
                        stroke="#20C997" // Bright Green/Teal Line color
                        strokeWidth={2}
                        fill="url(#colorLeads)" // Gradient Fill
                        activeDot={{ r: 5, fill: '#20C997', stroke: '#fff', strokeWidth: 2 }} // Dot on hover
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}

const ClientLeadPieChart = ({ data, title = "Line Up" }) => {
  const safeData = Array.isArray(data) ? data : [];
  const totalItem =
    safeData.find((item) => String(item?.label || "").toLowerCase().includes("total")) || null;
  const stagePalette = {
    selection: "#f59e0b",
    joining: "#fb7185",
    onboard: "#14b8a6",
    onboarding: "#14b8a6",
    payroll: "#64748b",
  };
  const stageData = safeData
    .filter((item) => !String(item?.label || "").toLowerCase().includes("total"))
    .map((item, index) => {
      const label = String(item?.label || "");
      const normalized = label.toLowerCase();
      const value = Number(item?.count) || 0;
      return {
        name: label,
        value,
        color:
          Object.entries(stagePalette).find(([key]) => normalized.includes(key))?.[1] ||
          COLORS[index % COLORS.length],
      };
    });

  const computedTotal = stageData.reduce((sum, item) => sum + item.value, 0);
  const totalCount = Number(totalItem?.count) || computedTotal;
  const hasData = totalCount > 0 && stageData.some((item) => item.value > 0);
  const chartData = stageData.map((item) => ({
    ...item,
    share: totalCount > 0 ? Number(((item.value / totalCount) * 100).toFixed(1)) : 0,
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const item = payload[0]?.payload;
    if (!item) return null;
    return (
      <div className="rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-md">
        <p className="mb-1 text-sm font-semibold text-slate-800">{item.name}</p>
        <p className="mb-0 text-xs text-slate-500">Count: {item.value.toLocaleString()}</p>
        <p className="mb-0 text-xs text-slate-500">Share: {item.share.toFixed(1)}%</p>
      </div>
    );
  };

  if (!hasData) {
    return (
      <div
        style={{
          minHeight: 250,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="flex flex-1 flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-[linear-gradient(180deg,#f8fafc_0%,#ffffff_100%)] px-6 text-center">
          <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-400">
            <DashboardStatGlyph type="list" className="h-7 w-7" />
          </div>
          <p className="mb-1 text-base font-semibold text-slate-700">No lineup graph data</p>
          <p className="mb-0 text-sm text-slate-400">Counts appear here once selection, joining, onboarding, or payroll data is available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-[250px] flex-col">
      <div className="p-2">
        <div className="mb-3 flex items-start justify-between gap-4">
          <div>
            <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">Total Lineup</p>
            <p className="mb-0 text-3xl font-extrabold text-slate-900">{totalCount.toLocaleString()}</p>
          </div>
        </div>
        <div className="h-[185px] min-w-0">
          <ResponsiveContainer width="100%" height={185} minWidth={1} minHeight={185}>
            <BarChart
              data={chartData}
              layout="vertical"
              margin={{ top: 6, right: 8, left: 8, bottom: 0 }}
              barCategoryGap={16}
            >
              <CartesianGrid horizontal strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
              <XAxis type="number" hide domain={[0, Math.max(totalCount, ...chartData.map((item) => item.value || 0))]} />
              <YAxis
                type="category"
                dataKey="name"
                tickLine={false}
                axisLine={false}
                width={78}
                tick={{ fill: "#64748b", fontSize: 12, fontWeight: 600 }}
              />
              <Tooltip cursor={{ fill: "rgba(148,163,184,0.08)" }} content={<CustomTooltip />} />
              <Bar dataKey="value" radius={[0, 10, 10, 0]} barSize={18}>
                <LabelList dataKey="value" position="right" style={{ fill: "#0f172a", fontSize: 12, fontWeight: 700 }} />
                {chartData.map((entry, index) => (
                  <Cell key={`lineup-cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};


const tabsByPost = {
  founder: [
    { key: "cxo_wise", label: "CXO Wise" },
    { key: "sh_wise", label: "Sourcing Head" },
    { key: "sm_wise", label: "Sourcing Manager" },
    { key: "rec_wise", label: "Recruiter" },
  ],
  admin: [
    { key: "cxo_wise", label: "CXO Wise" },
    { key: "sh_wise", label: "Sourcing Head" },
    { key: "sm_wise", label: "Sourcing Manager" },
    { key: "rec_wise", label: "Recruiter" },
  ],
  cxo: [
  { key: "cxo_wise", label: "CXO Wise" },
     { key: "sh_wise", label: "Sourcing Head" },
  { key: "sm_wise", label: "Sourcing Manager" },
  { key: "rec_wise", label: "Recruiter" },
  ],
  dst_manager: [
     { key: "sh_wise", label: "Sourcing Head" },
  { key: "sm_wise", label: "Sourcing Manager" },
  { key: "rec_wise", label: "Recruiter" },
  ],
  sourcing_head: [
    { key: "sh_wise", label: "Sourcing Head" },
    { key: "sm_wise", label: "Sourcing Manager" },
    { key: "rec_wise", label: "Recruiter" },
  ],
  sourcing_manager: [
    { key: "sm_wise", label: "Sourcing Manager" },
    { key: "rec_wise", label: "Recruiter" },
  ],
  recruiter: [
    { key: "rec_wise", label: "Recruiter" },
  ],
};

const initialAdvancePaymentSummary = {
  total_visible: 0,
  my_requests: 0,
  awaiting_me: 0,
  paid: 0,
  rejected: 0,
};
const [advancePaymentSummary, setAdvancePaymentSummary] = useState(initialAdvancePaymentSummary);
const [showAdvancePaymentCard, setShowAdvancePaymentCard] = useState(false);
const [showAdvancePaymentDetails, setShowAdvancePaymentDetails] = useState(false);
const [advancePaymentRows, setAdvancePaymentRows] = useState([]);
const [advancePaymentLoading, setAdvancePaymentLoading] = useState(false);
const [advancePaymentDetailLoading, setAdvancePaymentDetailLoading] = useState(false);
const [advancePaymentError, setAdvancePaymentError] = useState("");

const userPost = post?.toLowerCase(); // coming from API or session
const isVendorDashboard = (userType || "").toUpperCase() === "VENDOR";
const shouldShowRequirementsStatsGraph =
  userPost === "business_manager" &&
  (dashboardData.stats || []).some((stat) =>
    String(stat?.label || "").toLowerCase().includes("require")
  );
const shouldShowTatSummaryCard = [
  "business_manager",
  "business_head",
  "sourcing_head",
  "sourcing_manager",
  "recruiter",
  "admin",
  "founder",
].includes(userPost);
const tatStageVisualMap = {
  lineup: { icon: "ri-route-line", color: "#3b82f6", bg: "rgba(59,130,246,0.12)" },
  selection: { icon: "ri-check-double-line", color: "#0ea5e9", bg: "rgba(14,165,233,0.12)" },
  joining: { icon: "ri-user-star-line", color: "#f59e0b", bg: "rgba(245,158,11,0.14)" },
  onboarding: { icon: "ri-user-line", color: "#10b981", bg: "rgba(16,185,129,0.14)" },
  payroll: { icon: "ri-secure-payment-line", color: "#8b5cf6", bg: "rgba(139,92,246,0.14)" },
};
const normalizedTatSummary = useMemo(() => {
  const raw = dashboardData?.tatSummary || {};
  const rawStages = Array.isArray(raw.stages) ? raw.stages : [];
  const stages = rawStages.map((stage) => {
    const key = String(stage?.key || "").toLowerCase();
    const visual = tatStageVisualMap[key] || {
      icon: "ri-timer-line",
      color: "#64748b",
      bg: "rgba(100,116,139,0.15)",
    };
    return {
      key,
      label: stage?.label || "Stage",
      count: Number(stage?.count || 0),
      avgDays: Number(stage?.avgDays || 0),
      icon: visual.icon,
      color: visual.color,
      bg: visual.bg,
    };
  });
  return {
    totalCandidates: Number(raw.totalCandidates || 0),
    overallAvgDays: Number(raw.overallAvgDays || 0),
    stages,
  };
}, [dashboardData?.tatSummary]);
const tatStagesForCard = useMemo(() => {
  if (normalizedTatSummary.stages.length > 0) {
    return normalizedTatSummary.stages;
  }
  return [
    { key: "lineup", label: "Lineup", count: 0, avgDays: 0, ...(tatStageVisualMap.lineup || {}) },
    { key: "selection", label: "Selection", count: 0, avgDays: 0, ...(tatStageVisualMap.selection || {}) },
    { key: "joining", label: "Joining", count: 0, avgDays: 0, ...(tatStageVisualMap.joining || {}) },
    { key: "onboarding", label: "Onboarding", count: 0, avgDays: 0, ...(tatStageVisualMap.onboarding || {}) },
    { key: "payroll", label: "Payroll", count: 0, avgDays: 0, ...(tatStageVisualMap.payroll || {}) },
  ];
}, [normalizedTatSummary.stages]);
const campaignTatStageVisualMap = {
  recruiter: { icon: "ri-user-voice-line", color: "#0ea5e9", bg: "rgba(14,165,233,0.14)" },
  sm: { icon: "ri-user-settings-line", color: "#10b981", bg: "rgba(16,185,129,0.14)" },
  sh: { icon: "ri-shield-user-line", color: "#f59e0b", bg: "rgba(245,158,11,0.14)" },
  dst: { icon: "ri-team-line", color: "#ef4444", bg: "rgba(239,68,68,0.12)" },
};
const normalizedCampaignTat = useMemo(() => {
  const raw = dashboardData?.campaignTatSummary || {};
  const rawStages = Array.isArray(raw.stageTat) ? raw.stageTat : [];
  const stageTat = rawStages.map((stage) => {
    const key = String(stage?.key || "").toLowerCase();
    const visual = campaignTatStageVisualMap[key] || {
      icon: "ri-timer-line",
      color: "#64748b",
      bg: "rgba(100,116,139,0.14)",
    };
    return {
      key,
      label: stage?.label || "Stage",
      avgHours: Number(stage?.avgHours || 0),
      samples: Number(stage?.samples || 0),
      exceeded: Number(stage?.exceeded || 0),
      icon: visual.icon,
      color: visual.color,
      bg: visual.bg,
    };
  });

  return {
    thresholdHours: Number(raw.thresholdHours || 2),
    totalRequests: Number(raw.totalRequests || 0),
    exceededCount: Number(raw.exceededCount || 0),
    stageTat,
    exceededRequests: Array.isArray(raw.exceededRequests) ? raw.exceededRequests : [],
    requestRows: Array.isArray(raw.requestRows) ? raw.requestRows : [],
  };
}, [dashboardData?.campaignTatSummary]);
const campaignTatStagesForCard = useMemo(() => {
  if (normalizedCampaignTat.stageTat.length > 0) {
    return normalizedCampaignTat.stageTat;
  }
  return [
    { key: "recruiter", label: "Recruiter -> SM", avgHours: 0, samples: 0, exceeded: 0, ...(campaignTatStageVisualMap.recruiter || {}) },
    { key: "sm", label: "SM -> SH", avgHours: 0, samples: 0, exceeded: 0, ...(campaignTatStageVisualMap.sm || {}) },
    { key: "sh", label: "SH -> DST Team", avgHours: 0, samples: 0, exceeded: 0, ...(campaignTatStageVisualMap.sh || {}) },
    { key: "dst", label: "DST Team Approval", avgHours: 0, samples: 0, exceeded: 0, ...(campaignTatStageVisualMap.dst || {}) },
  ];
}, [normalizedCampaignTat.stageTat]);
const softenTatColor = (color, opacity = 0.14) => {
  const hex = String(color || "").replace("#", "");
  if (hex.length !== 6) return `rgba(148,163,184,${opacity})`;
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
const advancePaymentTatPalette = [
  { accent: "#3157d7", soft: "#eff6ff" },
  { accent: "#d99211", soft: "#fff7ed" },
  { accent: "#0d9488", soft: "#f0fdfa" },
  { accent: "#059669", soft: "#ecfdf5" },
  { accent: "#dc4c4c", soft: "#fef2f2" },
];
const getAdvancePaymentTatTheme = (index) =>
  advancePaymentTatPalette[index % advancePaymentTatPalette.length];
const formatTatRequestDateTime = (value) => {
  if (!value) return "-";
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return String(value);
  return dt.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
const campaignTatDetailColumns = useMemo(
  () => [
    { name: "Req ID", selector: (row) => row.requestId || "-", sortable: true, width: "86px" },
    { name: "Campaign", selector: (row) => row.campaignId || "-", sortable: true, wrap: true },
    { name: "Type", selector: (row) => String(row.source || "").toUpperCase() || "-", sortable: true, width: "85px" },
    { name: "Requested By", selector: (row) => row.requestBy || "-", sortable: true, wrap: true },
    { name: "Requested At", selector: (row) => formatTatRequestDateTime(row.requestTime), sortable: true, wrap: true, minWidth: "150px" },
    { name: "R->SM (hours)", selector: (row) => Number(row.recruiterToSmHours || 0).toFixed(2), sortable: true, right: true },
    { name: "SM->SH (hours)", selector: (row) => (row.smToShHours === null || row.smToShHours === undefined ? "-" : Number(row.smToShHours).toFixed(2)), sortable: true, right: true },
    { name: "SH->DST (hours)", selector: (row) => (row.shToDstHours === null || row.shToDstHours === undefined ? "-" : Number(row.shToDstHours).toFixed(2)), sortable: true, right: true },
    { name: "Overall (hours)", selector: (row) => Number(row.dstOverallHours || 0).toFixed(2), sortable: true, right: true },
    {
      name: "Pending Stage",
      selector: (row) => row.pendingStage || "-",
      sortable: true,
      wrap: true,
      cell: (row) => {
        const exceeded = Number(row.isExceeded || 0) === 1;
        if (!row.pendingStage) return <span className="text-emerald-700 text-xs font-semibold">Completed</span>;
        return (
          <span className={`text-xs font-semibold ${exceeded ? "text-red-600" : "text-slate-600"}`}>
            {row.pendingStage}
          </span>
        );
      },
    },
    {
      name: `Pending (>${normalizedCampaignTat.thresholdHours} hours)`,
      selector: (row) => (row.pendingHours === null || row.pendingHours === undefined ? "-" : Number(row.pendingHours).toFixed(1)),
      sortable: true,
      right: true,
      cell: (row) => {
        if (row.pendingHours === null || row.pendingHours === undefined) return <span>-</span>;
        const val = Number(row.pendingHours || 0).toFixed(1);
        const exceeded = Number(row.isExceeded || 0) === 1;
        return <span className={`text-xs font-bold ${exceeded ? "text-red-600" : "text-slate-700"}`}>{val}</span>;
      },
    },
  ],
  [normalizedCampaignTat.thresholdHours]
);
const advancePaymentStageMetaMap = {
  sourcing_manager: { label: "SM Approval", tone: "bg-sky-50 text-sky-700 border-sky-200" },
  sourcing_head: { label: "SH Approval", tone: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  cxo: { label: "CXO Approval", tone: "bg-violet-50 text-violet-700 border-violet-200" },
  accounts: { label: "Accounts", tone: "bg-amber-50 text-amber-700 border-amber-200" },
  completed: { label: "Completed", tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};
const formatAdvancePaymentStage = (value) => {
  const key = String(value || "").trim().toLowerCase();
  if (advancePaymentStageMetaMap[key]?.label) return advancePaymentStageMetaMap[key].label;
  if (!key) return "-";
  return key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};
const formatAdvancePaymentOverallStatus = (row) => {
  const status = String(row?.overall_status || "").trim().toLowerCase();
  if (status === "rejected" && row?.dashboard_rejected_by_post) {
    return `Rejected by ${row.dashboard_rejected_by_post}`;
  }
  return formatAdvancePaymentStage(row?.overall_status);
};
const formatAdvancePaymentDateTime = (value) => {
  if (!value) return "-";
  const parsed = dayjs(value);
  if (!parsed.isValid()) return String(value);
  return parsed.format("DD MMM YYYY, hh:mm A");
};
const getAdvancePaymentStageTone = (value) => {
  const key = String(value || "").trim().toLowerCase();
  return advancePaymentStageMetaMap[key]?.tone || "bg-slate-100 text-slate-700 border-slate-200";
};
const getAdvancePaymentOverallTone = (value) => {
  const key = String(value || "").trim().toLowerCase();
  if (key === "paid") return "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (key === "rejected") return "bg-rose-50 text-rose-700 border-rose-200";
  return "bg-blue-50 text-blue-700 border-blue-200";
};
const getAdvancePaymentAccountsTone = (value) => {
  const key = String(value || "").trim().toLowerCase();
  if (key === "paid") return "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (key === "utr_added") return "bg-amber-50 text-amber-700 border-amber-200";
  return "bg-slate-100 text-slate-700 border-slate-200";
};
const normalizedAdvancePaymentSummary = useMemo(() => {
  const totalVisible = Number(advancePaymentSummary.total_visible || 0);
  const myRequests = Number(advancePaymentSummary.my_requests || 0);
  const awaitingMe = Number(advancePaymentSummary.awaiting_me || 0);
  const paid = Number(advancePaymentSummary.paid || 0);
  const rejected = Number(advancePaymentSummary.rejected || 0);
  const inProgress = Math.max(totalVisible - paid - rejected, 0);

  return {
    totalVisible,
    myRequests,
    awaitingMe,
    paid,
    rejected,
    inProgress,
  };
}, [advancePaymentSummary]);
const advancePaymentSummaryCards = useMemo(
  () => [
    {
      key: "mine",
      label: "My Requests",
      value: normalizedAdvancePaymentSummary.myRequests,
      icon: "ri-user-heart-line",
      color: "#3157d7",
      bg: "#eff6ff",
    },
    {
      key: "awaiting",
      label: "Awaiting Me",
      value: normalizedAdvancePaymentSummary.awaitingMe,
      icon: "ri-alarm-warning-line",
      color: "#d99211",
      bg: "#fff7ed",
    },
    {
      key: "progress",
      label: "In Progress",
      value: normalizedAdvancePaymentSummary.inProgress,
      icon: "ri-refresh-line",
      color: "#0d9488",
      bg: "#f0fdfa",
    },
    {
      key: "paid",
      label: "Paid",
      value: normalizedAdvancePaymentSummary.paid,
      icon: "ri-checkbox-circle-line",
      color: "#059669",
      bg: "rgba(5,150,105,0.13)",
    },
    {
      key: "rejected",
      label: "Rejected",
      value: normalizedAdvancePaymentSummary.rejected,
      icon: "ri-close-circle-line",
      color: "#dc2626",
      bg: "rgba(220,38,38,0.12)",
    },
  ],
  [normalizedAdvancePaymentSummary]
);
const advancePaymentProgressMetrics = useMemo(() => {
  const total = normalizedAdvancePaymentSummary.totalVisible || 0;
  const toPercent = (value) => (total > 0 ? Math.round((value / total) * 100) : 0);

  return [
    {
      key: "in_progress",
      label: "In Progress",
      value: normalizedAdvancePaymentSummary.inProgress,
      percent: toPercent(normalizedAdvancePaymentSummary.inProgress),
      bar: "from-sky-500 to-blue-600",
      text: "text-sky-700",
      track: "bg-sky-100",
    },
    {
      key: "paid",
      label: "Paid",
      value: normalizedAdvancePaymentSummary.paid,
      percent: toPercent(normalizedAdvancePaymentSummary.paid),
      bar: "from-emerald-500 to-teal-600",
      text: "text-emerald-700",
      track: "bg-emerald-100",
    },
    {
      key: "rejected",
      label: "Rejected",
      value: normalizedAdvancePaymentSummary.rejected,
      percent: toPercent(normalizedAdvancePaymentSummary.rejected),
      bar: "from-rose-500 to-red-600",
      text: "text-rose-700",
      track: "bg-rose-100",
    },
  ];
}, [normalizedAdvancePaymentSummary]);
const advancePaymentDetailColumns = useMemo(
  () => [
    {
      name: "Request",
      selector: (row) => row.request_code || "-",
      sortable: true,
      minWidth: "170px",
      cell: (row) => (
        <div className="py-1">
          <div className="font-semibold text-slate-800">{row.request_code || "-"}</div>
          <div className="text-xs text-slate-500">{formatAdvancePaymentDateTime(row.created_at)}</div>
        </div>
      ),
    },
    {
      name: "Requester",
      selector: (row) => row.created_by_name || "-",
      sortable: true,
      grow: 0,
      cell: (row) => (
        <div className="py-1">
          <div className="font-medium text-slate-800">{row.created_by_name || "-"}</div>
          <div className="text-xs text-slate-500">{formatAdvancePaymentStage(row.created_by_post)}</div>
        </div>
      ),
    },
    {
      name: "Client",
      selector: (row) => row.client_name || "-",
      sortable: true,
      grow: 0,
      cell: (row) => (
        <div className="py-1">
          <div className="font-medium text-slate-800">{row.client_name || "-"}</div>
          <div className="text-xs text-slate-500">{row.location_name || "-"}</div>
        </div>
      ),
    },
    {
      name: "Purpose",
      selector: (row) => row.purpose_text || "-",
      sortable: true,
      minWidth: "260px",
      cell: (row) => (
        <div className="max-w-[280px] whitespace-normal break-words py-1">
          <div className="font-medium text-slate-800">{row.purpose_text || "-"}</div>
          {row.other_cause ? <div className="text-xs text-slate-500 mt-1">Other: {row.other_cause}</div> : null}
        </div>
      ),
    },
    {
      name: "Amount",
      selector: (row) => Number(row.amount || 0),
      sortable: true,
      right: true,
      cell: (row) => (
        <span className="font-semibold text-slate-800">
          INR {Number(row.amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </span>
      ),
    },
    {
      name: "Current Stage",
      selector: (row) => formatAdvancePaymentStage(row.current_stage),
      sortable: true,
      minWidth: "150px",
      cell: (row) => (
        <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${getAdvancePaymentStageTone(row.current_stage)}`}>
          {formatAdvancePaymentStage(row.current_stage)}
        </span>
      ),
    },
    {
      name: "Overall Status",
      selector: (row) => formatAdvancePaymentOverallStatus(row),
      sortable: true,
      minWidth: "165px",
      cell: (row) => (
        <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${getAdvancePaymentOverallTone(row.overall_status)}`}>
          {formatAdvancePaymentOverallStatus(row)}
        </span>
      ),
    },
    {
      name: "Accounts",
      selector: (row) => row.accounts_status || "-",
      sortable: true,
      minWidth: "145px",
      cell: (row) => (
        <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${getAdvancePaymentAccountsTone(row.accounts_status)}`}>
          {formatAdvancePaymentStage(row.accounts_status)}
        </span>
      ),
    },
    {
      name: "Paid At",
      selector: (row) => row.payment_marked_at || "",
      sortable: true,
      minWidth: "170px",
      cell: (row) => <span className="text-sm text-slate-600">{formatAdvancePaymentDateTime(row.payment_marked_at)}</span>,
    },
  ],
  []
);
const defaultTab = tabsByPost[userPost]?.[0]?.key || null
const showTopTabsForPost = [
  "business_manager",
  "business_head",
  "dst_manager",
  "sourcing_head",
  "cxo",
  "founder",
].includes(userPost);
const isMtdDashboardTab = showTopTabsForPost && topDashboardTab === "mtd";

useEffect(() => {
  if (!showTopTabsForPost && topDashboardTab !== "dashboard") {
    setTopDashboardTab("dashboard");
  }
}, [showTopTabsForPost, topDashboardTab]);

const [sectionData, setSectionData] = useState({
  stats: { data: {}, loading: false, show: false, activeTab: defaultTab  },
  profile: { data: {}, loading: false, show: false, activeTab: defaultTab  },
  experience: { data: {}, loading: false, show: false, activeTab: defaultTab  },
  location: { data: {}, loading: false, show: false, activeTab: defaultTab  },
  campaign: { data: {}, loading: false, show: false, activeTab: defaultTab  },
  
  require: { data: [], loading: false, show: false, activeTab: null  },
  requireCreation: { data: [], loading: false, show: false, activeTab: null  },
  
  lineup: { data: {}, loading: false, show: false, activeTab: defaultTab  },
  
  onboard: { data: {}, loading: false, show: false, activeTab: defaultTab  },
  
  vendor: { data: {}, loading: false, show: false, activeTab: defaultTab  },
  onboardreq: { data: {}, loading: false, show: false, activeTab: defaultTab  },
});


const columnHeaderMap = {
  cxo_name: "CXO",
  sh_name: "Sourcing Head",
  sm_name: "Sourcing Manager",
  rec_name: "Recruiter",
  category: "Category",
  today: "Today",
  week: "Week",
  month: "Month",
};

const renderFullCell = (value, maxWidthClass = "max-w-[220px]") => {
  const text = value === null || value === undefined || value === "" ? "-" : String(value);
  return (
    <div className={`${maxWidthClass} whitespace-normal break-words`} title={text}>
      {text}
    </div>
  );
};

const renderAssignedToCell = (row) => {
  const assignedText = row?.assigned_to ? String(row.assigned_to) : "-";
  const flowText = row?.assignment_flow ? String(row.assignment_flow) : "";
  const flowSteps = flowText
    .split("||")
    .map((item) => item.trim())
    .filter(Boolean);
  const hasFlow = flowSteps.length > 0 && flowText !== "-";

  return (
    <div className="max-w-[680px] whitespace-normal break-words">
      <div className="text-slate-800">{assignedText}</div>
      {hasFlow && (
        <details className="mt-1 group">
          <summary className="inline-flex cursor-pointer list-none items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-700 hover:bg-blue-100">
            <span className="group-open:hidden">View Flow</span>
            <span className="hidden group-open:inline">Hide Flow</span>
          </summary>
          <div className="mt-2 rounded-lg border border-blue-100 bg-white p-2 shadow-sm">
            <div className="space-y-1.5">
              {flowSteps.map((step, idx) => (
                <div key={`${row?.req_id || "req"}-flow-${idx}`} className="text-xs text-slate-700 leading-5">
                  {idx + 1}. {step}
                </div>
              ))}
            </div>
          </div>
        </details>
      )}
    </div>
  );
};

const requirementCreationColumns = useMemo(() => ([
  { name: "Req ID", selector: (row) => row.req_id || "-", cell: (row) => renderFullCell(row.req_id, "max-w-[130px]"), sortable: true },
  { name: "Date", selector: (row) => row.date || "-", cell: (row) => renderFullCell(row.date, "max-w-[130px]"), sortable: true },
  { name: "Created By", selector: (row) => row.created_by || "-", cell: (row) => renderFullCell(row.created_by, "max-w-[220px]"), sortable: true },
  { name: "Client Name", selector: (row) => row.client_name || "-", cell: (row) => renderFullCell(row.client_name, "max-w-[260px]"), sortable: true },
  { name: "Location", selector: (row) => row.location || "-", cell: (row) => renderFullCell(row.location, "max-w-[200px]"), sortable: true },
  { name: "Contract", selector: (row) => row.contract || "-", cell: (row) => renderFullCell(row.contract, "max-w-[170px]"), sortable: true },
  { name: "Designation", selector: (row) => row.designation || "-", cell: (row) => renderFullCell(row.designation, "max-w-[460px]"), sortable: true, minWidth: "300px" },
  { name: "Profile", selector: (row) => row.profile || "-", cell: (row) => renderFullCell(row.profile, "max-w-[420px]"), sortable: true, minWidth: "280px" },
  { name: "Positions", selector: (row) => row.positions ?? 0, sortable: true, right: true },
]), []);

const requirementAssignedColumns = useMemo(() => ([
  { name: "Req ID", selector: (row) => row.req_id || "-", cell: (row) => renderFullCell(row.req_id, "max-w-[140px]"), sortable: true },
  { name: "Created By", selector: (row) => row.created_by || "-", cell: (row) => renderFullCell(row.created_by, "max-w-[220px]"), sortable: true },
  { name: "Creation Date", selector: (row) => row.creation_date || "-", cell: (row) => renderFullCell(row.creation_date, "max-w-[140px]"), sortable: true },
  { name: "Assigned To", selector: (row) => row.assigned_to || "-", cell: (row) => renderAssignedToCell(row), sortable: true, minWidth: "320px" },
  { name: "Client Name", selector: (row) => row.client_name || "-", cell: (row) => renderFullCell(row.client_name, "max-w-[280px]"), sortable: true },
  { name: "Location", selector: (row) => row.location || "-", cell: (row) => renderFullCell(row.location, "max-w-[220px]"), sortable: true },
  { name: "Designation", selector: (row) => row.designation || "-", cell: (row) => renderFullCell(row.designation, "max-w-[460px]"), sortable: true, minWidth: "300px" },
  { name: "Positions", selector: (row) => Number(row.positions ?? 0), sortable: true, right: true },
  { name: "Campaigns Done", selector: (row) => Number(row.campaigns_done ?? 0), sortable: true, right: true },
  { name: "Lineup Count", selector: (row) => Number(row.lineup_count ?? 0), sortable: true, right: true },
  { name: "Selection", selector: (row) => Number(row.selection ?? 0), sortable: true, right: true },
  { name: "Joining", selector: (row) => Number(row.joining ?? 0), sortable: true, right: true },
  { name: "Onboarding", selector: (row) => Number(row.onboarding ?? 0), sortable: true, right: true },
  { name: "Payroll", selector: (row) => Number(row.payroll ?? 0), sortable: true, right: true },
]), []);

const vendorRequirementColumns = useMemo(() => ([
  { name: "Req ID", selector: (row) => row.req_id || "-", cell: (row) => renderFullCell(row.req_id, "max-w-[130px]"), sortable: true },
  { name: "Client Name", selector: (row) => row.client_name || "-", cell: (row) => renderFullCell(row.client_name, "max-w-[240px]"), sortable: true },
  { name: "Location", selector: (row) => row.location || "-", cell: (row) => renderFullCell(row.location, "max-w-[180px]"), sortable: true },
  { name: "Profile", selector: (row) => row.profile || "-", cell: (row) => renderFullCell(row.profile, "max-w-[320px]"), sortable: true, minWidth: "240px" },
  { name: "Uploaded", selector: (row) => Number(row.uploaded ?? 0), sortable: true, right: true },
  { name: "Line Up", selector: (row) => Number(row.lineup ?? 0), sortable: true, right: true },
  { name: "Selected", selector: (row) => Number(row.selected ?? 0), sortable: true, right: true },
  { name: "Joined", selector: (row) => Number(row.joined ?? 0), sortable: true, right: true },
  { name: "Onboarded", selector: (row) => Number(row.onboarded ?? 0), sortable: true, right: true },
]), []);

const requirementCreationTableStyles = useMemo(
  () => ({
    table: { style: { minWidth: "1500px" } },
    rows: { style: { minHeight: "56px" } },
    cells: { style: { paddingTop: "10px", paddingBottom: "10px" } },
    headCells: { style: { paddingTop: "12px", paddingBottom: "12px" } },
  }),
  []
);

const requirementAssignedTableStyles = useMemo(
  () => ({
    table: { style: { minWidth: "2380px" } },
    rows: { style: { minHeight: "56px" } },
    cells: { style: { paddingTop: "10px", paddingBottom: "10px" } },
    headCells: { style: { paddingTop: "12px", paddingBottom: "12px" } },
  }),
  []
);

const escapeExcelCell = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const downloadCampaignExcel = () => {
  const activeTab = sectionData.campaign.activeTab;
  const activeRows = sectionData.campaign.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `campaign_performance_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const requirementClientChartData = useMemo(() => {
  const clientKeys = [
    "client",
    "client_name",
    "clientName",
    "cname",
    "company",
    "company_name",
    "account_name",
    "name",
    "label",
    "pname",
  ];
  const directTotalKeys = [
    "total",
    "count",
    "requirements",
    "requirement_count",
    "total_requirements",
    "total_req",
    "client_demands",
  ];

  const toNumber = (value) => {
    const num = Number(String(value ?? "").replace(/,/g, "").trim());
    return Number.isFinite(num) ? num : 0;
  };

  const pickClientName = (row) => {
    if (!row || typeof row !== "object") return "";
    for (const key of clientKeys) {
      const val = row[key];
      if (val !== undefined && val !== null && String(val).trim() !== "") return String(val).trim();
    }
    return "";
  };

  const pickTotal = (row) => {
    if (!row || typeof row !== "object") return 0;
    for (const key of directTotalKeys) {
      const num = toNumber(row[key]);
      if (num > 0) return num;
    }
    const stagedTotal =
      toNumber(row.total_position) +
      toNumber(row.position) +
      toNumber(row.open) +
      toNumber(row.pending) +
      toNumber(row.onhold) +
      toNumber(row.closed) +
      toNumber(row.assign) +
      toNumber(row.assigned_to_sh);
    return stagedTotal;
  };

  const isRowLikeObject = (value) => {
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    return clientKeys.some((key) => value[key] !== undefined && value[key] !== null && String(value[key]).trim() !== "");
  };

  const collectRows = (source) => {
    if (!source) return [];
    if (Array.isArray(source)) return source.flatMap((item) => collectRows(item));
    if (typeof source !== "object") return [];

    if (isRowLikeObject(source)) return [source];

    return Object.values(source).flatMap((value) => collectRows(value));
  };

  const candidateRows = [
    ...collectRows(dashboardData.clientRequirements),
    ...collectRows(dashboardData.reqclient),
    ...collectRows(dashboardData.clientlead),
    ...collectRows(tabbedSectionData.reqclient?.data),
    ...collectRows(sectionData.require?.data),
  ];

  const aggregated = new Map();
  candidateRows.forEach((row) => {
    const client = pickClientName(row);
    if (!client) return;
    const total = pickTotal(row);
    const prev = aggregated.get(client) || 0;
    aggregated.set(client, prev + total);
  });

  return Array.from(aggregated.entries())
    .map(([client, total]) => ({ client, total }))
    .filter((item) => item.total > 0);
}, [dashboardData.clientRequirements, dashboardData.reqclient, dashboardData.clientlead, tabbedSectionData.reqclient, sectionData.require]);

const shouldKeepClientWiseChartForRequirements = ["business_manager", "business_head"].includes(userPost);

const requirementSummaryRows = useMemo(() => {
  const source = Array.isArray(dashboardData.require) ? dashboardData.require : [];
  const normalize = (value) => String(value || "").toLowerCase().replace(/\s+/g, " ").trim();
  const toNumber = (value) => {
    const num = Number(String(value ?? "").replace(/,/g, "").trim());
    return Number.isFinite(num) ? num : 0;
  };

  const findByLabel = (matcher) =>
    source.find((item) => matcher(normalize(item?.label)));

  const totalItem = findByLabel((label) => label.includes("total"));
  const openItem = findByLabel((label) => label.includes("open"));
  const closedItem = findByLabel((label) => label.includes("closed"));
  const holdItem = findByLabel((label) => label.includes("on hold") || label.includes("onhold"));

  const fallbackPalette = ["#4f46e5", "#059669", "#dc2626", "#f59e0b"];
  const rows = [
    { label: "Total Requirements", item: totalItem, color: fallbackPalette[0] },
    { label: "Open", item: openItem, color: fallbackPalette[1] },
    { label: "Closed", item: closedItem, color: fallbackPalette[2] },
    { label: "On Hold", item: holdItem, color: fallbackPalette[3] },
  ].map((row) => ({
    ...row,
    value: toNumber(row.item?.count),
    tone: row.item?.hexcolor || row.color,
  }));

  const total = rows[0].value > 0 ? rows[0].value : Math.max(...rows.map((row) => row.value), 0);
  return rows.map((row) => ({
    ...row,
    percent: total > 0 ? Math.min(100, Math.round((row.value / total) * 100)) : 0,
  }));
}, [dashboardData.require]);

const downloadLineupExcel = () => {
  const activeTab = sectionData.lineup.activeTab;
  const activeRows = sectionData.lineup.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `lineup_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const downloadLineupRequirementWiseExcel = () => {
  const activeTab = tabbedSectionData.lineup.activeTab;
  const activeRows = tabbedSectionData.lineup.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `lineup_requirement_wise_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const downloadOnboardingExcel = () => {
  const activeTab = sectionData.onboard.activeTab;
  const activeRows = sectionData.onboard.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `onboarding_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const downloadOnboardingRequirementWiseExcel = () => {
  const activeTab = tabbedSectionData.onboardreq.activeTab;
  const activeRows = tabbedSectionData.onboardreq.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `onboarding_requirement_wise_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const downloadVendorOnboardingExcel = () => {
  const activeTab = sectionData.vendor.activeTab;
  const activeRows = sectionData.vendor.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `vendor_onboarding_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const downloadCandidateRegisterExcel = () => {
  const activeTab = sectionData.stats.activeTab;
  const activeRows = sectionData.stats.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `candidate_register_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const downloadCandidateProfileExcel = () => {
  const activeTab = sectionData.profile.activeTab;
  const activeRows = sectionData.profile.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `candidate_profile_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const downloadCandidateExperienceExcel = () => {
  const activeTab = sectionData.experience.activeTab;
  const activeRows = sectionData.experience.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `candidate_experience_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const downloadCandidateLocationExcel = () => {
  const activeTab = sectionData.location.activeTab;
  const activeRows = sectionData.location.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `candidate_location_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const downloadLeadDataExcel = () => {
  const activeTab = tabbedSectionData.clientlead.activeTab;
  const activeRows = tabbedSectionData.clientlead.data?.[activeTab] || [];

  if (!activeRows.length) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye table data available nahi hai.",
    });
    return;
  }

  const keys = Object.keys(activeRows[0]);
  const headers = keys.map((key) => columnHeaderMap[key] || key.replace(/_/g, " ").toUpperCase());
  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = activeRows
    .map(
      (row) =>
        `<tr>${keys
          .map((key) => `<td>${escapeExcelCell(row[key])}</td>`)
          .join("")}</tr>`
    )
    .join("");

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <table border="1">
          <thead>${tableHead}</thead>
          <tbody>${tableBody}</tbody>
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  const tabLabel = activeTab || "details";
  link.href = URL.createObjectURL(blob);
  link.download = `lead_data_${tabLabel}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const handleViewClick = async (type) => {
  if (sectionData[type].show) {
    setSectionData(prev => ({
      ...prev,
      [type]: { ...prev[type], show: false, data: [], activeTab: null }
    }));
    if (type === "require") {
      setRequirementDetailTab("creation");
      setSectionData(prev => ({
        ...prev,
        requireCreation: { ...prev.requireCreation, show: false, data: [], activeTab: null, loading: false }
      }));
    }
    setColumns([]);
    setActiveType(null);
    return;
  }

  if (type === "require") {
    setRequirementDetailTab("creation");
    setSectionData(prev => ({
      ...prev,
      require: { ...prev.require, loading: true, show: true },
      requireCreation: { ...prev.requireCreation, loading: true, show: true },
    }));

    try {
      const { assignedRows, creationRows } = await fetchRequirementDetailSections();

      setSectionData(prev => ({
        ...prev,
        require: { ...prev.require, data: assignedRows, activeTab: null },
        requireCreation: { ...prev.requireCreation, data: creationRows },
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setSectionData(prev => ({
        ...prev,
        require: { ...prev.require, loading: false },
        requireCreation: { ...prev.requireCreation, loading: false },
      }));
    }
    return;
  }

  if (type === "stats" && isVendorDashboard) {
    setSectionData(prev => ({
      ...prev,
      stats: {
        ...prev.stats,
        data: dashboardData.vendorRequirementDetails || [],
        activeTab: null,
        loading: false,
        show: true,
      }
    }));
    return;
  }

  setSectionData(prev => ({
    ...prev,
    [type]: { ...prev[type], loading: true, show: true }
  }));

  try {
    const res = await axios.get(`${apiurl}dashboard.php`, { params: { subdomain: 'react', type } });
    const data = res.data.dataObject; // { cxo_wise: [...], sh_wise: [...], sm_wise: [...], rec_wise: [...] }
    
    const allowedTabs = tabsByPost[res.data.loginpost] || [];
    const firstKey = allowedTabs[0]?.key || null;
    
    console.log(allowedTabs);
    console.log("key ",firstKey);
    
    setSectionData(prev => {
      const updated = {
        ...prev,
        [type]: { ...prev[type], data, activeTab: firstKey }
      };
      return updated;
    });

  } catch (err) {
    console.error(err);
  } finally {
    setSectionData(prev => ({
      ...prev,
      [type]: { ...prev[type], loading: false }
    }));
  }
};

const handleTabClick = (section, tabKey) => {
  setSectionData(prev => ({
    ...prev,
    [section]: { ...prev[section], activeTab: tabKey }
  }));
};

const handleTabClick2 = (section, tabKey) => {
  setTabbedSectionData(prev => ({
    ...prev,
    [section]: { ...prev[section], activeTab: tabKey }
  }));
};

const toFiniteNumber = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

const lineupPriorityKeys = [
  "total",
  "selection",
  "joined",
  "joining",
  "onboarded",
  "onboard",
  "processing",
  "verification",
  "bankverified",
  "payroll",
];

const getRowActivityScore = (row = {}) => {
  let score = 0;
  let hasPriorityMetric = false;

  lineupPriorityKeys.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(row, key)) {
      hasPriorityMetric = true;
      score += toFiniteNumber(row[key]);
    }
  });

  if (hasPriorityMetric) return score;

  return Object.entries(row).reduce((sum, [key, value]) => {
    if (/(_name|name|label|id|date|time)$/i.test(key)) return sum;
    return sum + toFiniteNumber(value);
  }, 0);
};

const sortRowsByActivity = (rows = []) =>
  [...rows].sort((a, b) => {
    const scoreA = getRowActivityScore(a);
    const scoreB = getRowActivityScore(b);

    const hasDataA = scoreA > 0;
    const hasDataB = scoreB > 0;

    if (hasDataA !== hasDataB) return hasDataA ? -1 : 1;
    return scoreB - scoreA;
  });

const lineupDetailRows = useMemo(
  () => sortRowsByActivity(sectionData.lineup.data?.[sectionData.lineup.activeTab] || []),
  [sectionData.lineup.data, sectionData.lineup.activeTab]
);

const lineupRequirementRows = useMemo(
  () => sortRowsByActivity(tabbedSectionData.lineup.data?.[tabbedSectionData.lineup.activeTab] || []),
  [tabbedSectionData.lineup.data, tabbedSectionData.lineup.activeTab]
);

const campaignDetailRows = useMemo(
  () => sortRowsByActivity(sectionData.campaign.data?.[sectionData.campaign.activeTab] || []),
  [sectionData.campaign.data, sectionData.campaign.activeTab]
);

const campaignRequirementRows = useMemo(
  () => sortRowsByActivity(tabbedSectionData.campaign.data?.[tabbedSectionData.campaign.activeTab] || []),
  [tabbedSectionData.campaign.data, tabbedSectionData.campaign.activeTab]
);

const onboardDetailRows = useMemo(
  () => sortRowsByActivity(sectionData.onboard.data?.[sectionData.onboard.activeTab] || []),
  [sectionData.onboard.data, sectionData.onboard.activeTab]
);

const onboardRequirementRows = useMemo(
  () => sortRowsByActivity(tabbedSectionData.onboardreq.data?.[tabbedSectionData.onboardreq.activeTab] || []),
  [tabbedSectionData.onboardreq.data, tabbedSectionData.onboardreq.activeTab]
);


const colors = [
    'bg-purple-100 text-purple-600',
    'bg-blue-100 text-blue-600',
    'bg-red-100 text-red-600',
    'bg-green-100 text-green-600',
    'bg-yellow-100 text-yellow-600',
    'bg-pink-100 text-pink-600',
];
const getRandomColor = (id) => colors[id % colors.length];
const viewDetailsButtonClass =
  "inline-flex items-center justify-center rounded-xl bg-slate-100 px-4 py-2 text-sm font-semibold text-blue-700 transition duration-150 hover:bg-slate-200";

const shouldShowAdvancePaymentDashboardCard = shouldShowTatSummaryCard && showAdvancePaymentCard;

const renderAdvancePaymentDashboardCard = () => (
  <div className="my-4">
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_24px_54px_rgba(15,23,42,0.14)]">
      <div className="px-4 py-4 sm:px-5">
        <div className="flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
          <div className="max-w-3xl">
            <div className="flex flex-wrap items-center gap-2">
              <h2 className="text-xl font-bold text-gray-800 mb-0">Advance Payment</h2>
            </div>
            <p className="text-sm text-slate-500 mb-0 mt-1">
              Approval funnel, accounts completion, and request visibility snapshot.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center rounded-full bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-700">
              Awaiting Me: {normalizedAdvancePaymentSummary.awaitingMe}
            </span>
            {advancePaymentLoading ? (
              <span className="inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
                Refreshing...
              </span>
            ) : null}
            <button
              type="button"
              onClick={handleAdvancePaymentDetailsToggle}
              className={viewDetailsButtonClass}
              disabled={advancePaymentLoading || advancePaymentDetailLoading}
            >
              {advancePaymentDetailLoading ? "Loading..." : showAdvancePaymentDetails ? "Hide Details" : "View Details"}
            </button>
          </div>
        </div>
      </div>

      <div className="px-4 pb-3 sm:px-5">
        <div className="grid grid-cols-1 gap-3 xl:grid-cols-[minmax(0,1.35fr)_minmax(320px,0.9fr)]">
          <div className="space-y-3">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 2xl:grid-cols-3">
              {advancePaymentSummaryCards.map((item) => (
                <div
                  key={`advance-payment-summary-${item.key}`}
                  className="relative min-w-0 overflow-hidden rounded-xl border border-slate-200 bg-white px-3 py-3 shadow-[0_4px_14px_rgba(15,23,42,0.05)]"
                  style={{
                    background: `linear-gradient(180deg, ${item.bg} 0%, #ffffff 100%)`,
                    borderColor: `${item.color}33`,
                  }}
                >
                  <div className="relative z-10 flex items-center gap-3">
                    <div
                      className="flex h-10 w-10 items-center justify-center rounded-full flex-shrink-0"
                      style={{ background: item.color }}
                    >
                      <i className={`${item.icon} text-lg text-white`} />
                    </div>
                    <div className="min-w-0 flex-1 text-right">
                      <p className="text-[10px] uppercase tracking-[0.12em] text-slate-400">
                        {item.key === "mine"
                          ? "Created By You"
                          : item.key === "awaiting"
                            ? "Pending Action"
                            : item.key === "progress"
                              ? "Open Workflow"
                              : item.key === "paid"
                                ? "Accounts Closed"
                                : "Final Outcome"}
                      </p>
                      <p className="mt-0.5 text-lg font-bold leading-none text-slate-900">{item.label}</p>
                      <p className="mt-1 text-2xl font-extrabold leading-none" style={{ color: item.color }}>
                        {item.value}
                      </p>
                      <p className="mt-1 text-[11px] text-slate-500">
                        {item.key === "awaiting"
                          ? "Requests waiting on your action"
                          : item.key === "progress"
                            ? "Open requests in workflow"
                            : item.key === "paid"
                              ? "Completed by Accounts"
                              : item.key === "rejected"
                                ? "Closed as rejected"
                                : "Requests created from your profile"}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {advancePaymentError ? (
              <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-medium text-rose-700">
                {advancePaymentError}
              </div>
            ) : null}
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white/95 p-3.5 shadow-[0_10px_25px_rgba(15,23,42,0.05)]">
            <div className="mb-3 flex items-start justify-between gap-3">
              <div>
                <h3 className="mb-1 text-lg font-bold text-slate-900">Outcome Mix</h3>
                <p className="mb-0 text-xs text-slate-500">
                  Current request mix.
                </p>
              </div>
              <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">
                My Requests: {normalizedAdvancePaymentSummary.myRequests}
              </span>
            </div>

            <div className="space-y-3">
              {advancePaymentProgressMetrics.map((metric) => (
                <div key={`advance-payment-metric-${metric.key}`}>
                  <div className="mb-1.5 flex items-center justify-between gap-3">
                    <span className={`text-sm font-semibold ${metric.text}`}>{metric.label}</span>
                    <span className="text-sm font-bold text-slate-800">
                      {metric.value} <span className="text-xs font-medium text-slate-500">({metric.percent}%)</span>
                    </span>
                  </div>
                  <div className={`h-2.5 overflow-hidden rounded-full ${metric.track}`}>
                    <div
                      className={`h-full rounded-full bg-gradient-to-r ${metric.bar}`}
                      style={{ width: `${metric.percent}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>

        {showAdvancePaymentDetails ? (
          <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.4)]">
            {advancePaymentDetailLoading ? (
              <div className="flex min-h-[180px] flex-col items-center justify-center gap-3 text-sm text-slate-500">
                <div className="h-9 w-9 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600" />
                <span>Loading advance payment details...</span>
              </div>
            ) : (
              <DataTable
                columns={advancePaymentDetailColumns}
                data={advancePaymentRows}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                highlightOnHover
                dense
                striped
                responsive
                noDataComponent={<div className="py-4 text-sm text-slate-500">No advance payment rows found for this login.</div>}
              />
            )}
          </div>
        ) : null}
      </div>
    </div>
  </div>
);

const ClientReportTable = ({ clientWise }) => {
  
  // 1. Helper to format keys (e.g., 'clientName' becomes 'Client Name')
  const formatHeader = (key) => {
    const result = key.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  };

  // 2. Generate Columns Dynamically
  // We check if data exists, then map the keys of the first object to column definitions
  const columns = clientWise && clientWise.length > 0 
    ? Object.keys(clientWise[0]).map((key) => {
        return {
          name: formatHeader(key),
          selector: row => row[key],
          sortable: true,
          grow: key === 'clientName' ? 3 : 1, // Give more space to Client Name
          wrap: true, // Allow long names to wrap
          style: {
            fontWeight: key === 'clientName' ? 'bold' : 'normal',
          }
        };
      })
    : [];


  return (
     <DataTable
        columns={columns}
        data={clientWise}
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        highlightOnHover
        dense
        striped
      />
  );
};

const ClientRequirementChart = ({ data = [] }) => {
  const [sort, setSort] = useState('desc');

  const normalized = useMemo(() => {
    const source = Array.isArray(data) ? data : [];
    return source.map((item) => ({
      ...item,
      client: (
        item?.client ??
        item?.clientName ??
        item?.client_name ??
        item?.name ??
        item?.label ??
        item?.pname ??
        ""
      ).toString(),
      total: Number(
        item?.total ??
        item?.count ??
        item?.requirements ??
        item?.total_requirements ??
        ((Number(item?.pending ?? 0) + Number(item?.onhold ?? 0) + Number(item?.closed ?? 0)) || 0)
      ),
    }))
    .filter((row) => row.client.trim().length > 0);
  }, [data]);

  const sorted = useMemo(() => {
    const arr = [...normalized];
    if (sort === 'desc')  return arr.sort((a, b) => b.total - a.total);
    if (sort === 'asc')   return arr.sort((a, b) => a.total - b.total);
    if (sort === 'alpha') return arr.sort((a, b) => a.client.localeCompare(b.client));
    return arr;
  }, [normalized, sort]);

  const chartData = sorted.map(d => ({
    name:   d.client.length > 10 ? d.client.slice(0, 10) + '...' : d.client,
    full:   d.client,
    total:  d.total,
  }));

  const chartMinWidth = Math.max(chartData.length * 58, 420);

  return (
    <div style={{ width: '100%', height: '100%' }}>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <select
          value={sort}
          onChange={e => setSort(e.target.value)}
          style={{
            fontSize: 13,
            padding: '4px 10px',
            borderRadius: 8,
            border: '1px solid #e5e7eb',
            background: '#fff',
            color: '#374151',
            minWidth: 160,
          }}
        >
          <option value="desc">Highest first</option>
          <option value="asc">Lowest first</option>
          <option value="alpha">A → Z</option>
        </select>
        <span style={{ fontSize: 12, color: '#9ca3af' }}>sort by</span>
      </div>

      <div className="w-full overflow-x-auto overflow-y-hidden pb-1">
        <div style={{ width: `${chartMinWidth}px`, height: 230 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={chartData}
              margin={{ top: 16, right: 8, left: 0, bottom: 40 }}
              barCategoryGap="48%"
              barGap={8}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />

              <XAxis
                dataKey="name"
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: '#6b7280' }}
                angle={-35}
                textAnchor="end"
                interval={0}
              />

              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: '#6b7280' }}
                allowDecimals={false}
              />

              <Tooltip
                cursor={{ fill: 'rgba(0,0,0,0.04)' }}
                contentStyle={{ borderRadius: 8, fontSize: 12, border: '1px solid #e5e7eb' }}
                formatter={(value) => [Number(value || 0).toLocaleString(), 'Requirements']}
                labelFormatter={(_, payload) => payload?.[0]?.payload?.full ?? ''}
              />

              <Bar dataKey="total" radius={[5, 5, 0, 0]} barSize={18} label={{ position: 'top', fontSize: 11, fill: '#6b7280' }}>
                {chartData.map((_, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>

            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

    </div>
  );
};

const formatReportDisplayDate = (value) => {
  if (!value) return "-";
  const text = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    const [year, month, day] = text.split("-");
    return `${day}-${month}-${year}`;
  }
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return text;
  return `${String(dt.getDate()).padStart(2, "0")}-${String(dt.getMonth() + 1).padStart(2, "0")}-${dt.getFullYear()}`;
};

const filterReportRowsBySearch = (rows, query) => {
  const search = String(query || "").trim().toLowerCase();
  if (!search) return Array.isArray(rows) ? rows : [];

  return (rows || []).filter((row) =>
    [
      row?.report_date,
      row?.requirement_id,
      row?.client_demands,
      row?.client_name,
      row?.open_campaign,
      row?.paid_campaign,
      row?.self_candidate,
      row?.campaign_candidate,
      row?.total_selection,
      row?.total_joining,
      row?.total_onboarding,
      row?.total_payroll,
      row?.requirement_status,
    ].some((value) => String(value ?? "").toLowerCase().includes(search))
  );
};

const calculateReportMetrics = (rows = []) =>
  (rows || []).reduce(
    (acc, row) => ({
      total_requirements: acc.total_requirements + 1,
      open_campaign: acc.open_campaign + Number(row?.open_campaign || 0),
      paid_campaign: acc.paid_campaign + Number(row?.paid_campaign || 0),
      self_candidate: acc.self_candidate + Number(row?.self_candidate || 0),
      campaign_candidate: acc.campaign_candidate + Number(row?.campaign_candidate || 0),
      total_selection: acc.total_selection + Number(row?.total_selection || 0),
      total_joining: acc.total_joining + Number(row?.total_joining || 0),
      total_onboarding: acc.total_onboarding + Number(row?.total_onboarding || 0),
      total_payroll: acc.total_payroll + Number(row?.total_payroll || 0),
    }),
    { ...emptyReportMetrics }
  );

const buildReportExcelSection = (title, rows) => {
  const headers = [
    "Date",
    "Requirement ID",
    "Client Demands",
    "Client Name",
    "Open Campaign",
    "Paid Campaign",
    "Self Candidate",
    "Campaign Candidate",
    "Total Selection",
    "Total Joining",
    "Total Onboarding",
    "Total Payroll",
    "Requirement Status",
  ];

  const tableHead = `<tr>${headers.map((header) => `<th>${escapeExcelCell(header)}</th>`).join("")}</tr>`;
  const tableBody = (rows || [])
    .map(
      (row) => `
        <tr>
          <td>${escapeExcelCell(formatReportDisplayDate(row.report_date || "-"))}</td>
          <td>${escapeExcelCell(row.requirement_id || "-")}</td>
          <td>${escapeExcelCell(row.client_demands ?? 0)}</td>
          <td>${escapeExcelCell(row.client_name || "-")}</td>
          <td>${escapeExcelCell(row.open_campaign ?? 0)}</td>
          <td>${escapeExcelCell(row.paid_campaign ?? 0)}</td>
          <td>${escapeExcelCell(row.self_candidate ?? 0)}</td>
          <td>${escapeExcelCell(row.campaign_candidate ?? 0)}</td>
          <td>${escapeExcelCell(row.total_selection ?? 0)}</td>
          <td>${escapeExcelCell(row.total_joining ?? 0)}</td>
          <td>${escapeExcelCell(row.total_onboarding ?? 0)}</td>
          <td>${escapeExcelCell(row.total_payroll ?? 0)}</td>
          <td>${escapeExcelCell(row.requirement_status || "-")}</td>
        </tr>
      `
    )
    .join("");

  return `
    <div style="margin-bottom: 24px;">
      <div style="font-weight: 700; font-size: 16px; margin-bottom: 8px;">${escapeExcelCell(title)}</div>
      <table border="1">
        <thead>${tableHead}</thead>
        <tbody>${tableBody}</tbody>
      </table>
    </div>
  `;
};

const reportManagerOptions = useMemo(
  () => (reportManagers || []).map((item) => ({ value: item.id, label: item.name })),
  [reportManagers]
);

const filteredReportData = useMemo(
  () => filterReportRowsBySearch(reportData, reportSearch),
  [reportData, reportSearch]
);

const filteredReportSelfData = useMemo(
  () => filterReportRowsBySearch(reportSelfData, reportSearch),
  [reportSelfData, reportSearch]
);

const filteredReportRecruiterTables = useMemo(
  () =>
    (reportRecruiterTables || [])
      .map((table) => ({
        ...table,
        rows: filterReportRowsBySearch(table.rows || [], reportSearch),
      }))
      .filter((table) => table.rows.length > 0),
  [reportRecruiterTables, reportSearch]
);

const reportMetrics = calculateReportMetrics(filteredReportData);
const reportOwnerName = (selectedReportManager?.label || reportMeta.scopeName || "User").trim();
const reportOwnerPossessive = reportOwnerName.toLowerCase().endsWith("s")
  ? `${reportOwnerName}'`
  : `${reportOwnerName}'s`;
const isRecruiterViewActive = Boolean(selectedReportManager && showRecruiterTables);
const getPossessiveLabel = (name) => {
  const trimmed = String(name || "").trim();
  if (!trimmed) return "Recruiter's";
  return trimmed.toLowerCase().endsWith("s") ? `${trimmed}'` : `${trimmed}'s`;
};

const reportStatCards = [
  { label: "Requirements", value: reportMetrics.total_requirements, tone: "bg-blue-50 text-blue-700 border-blue-100" },
  { label: "Campaign Data", value: reportMetrics.open_campaign + reportMetrics.paid_campaign, tone: "bg-amber-50 text-amber-700 border-amber-100" },
  { label: "Selection", value: reportMetrics.total_selection, tone: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  { label: "Onboarding", value: reportMetrics.total_onboarding, tone: "bg-teal-50 text-teal-700 border-teal-100" },
  { label: "Payroll", value: reportMetrics.total_payroll, tone: "bg-violet-50 text-violet-700 border-violet-100" },
];

const downloadReportExcel = () => {
  const recruiterExportTables = isRecruiterViewActive ? filteredReportRecruiterTables : [];
  const shouldExportMainTables = !isRecruiterViewActive;

  if (
    (shouldExportMainTables && !filteredReportData.length && !filteredReportSelfData.length) ||
    (!shouldExportMainTables && recruiterExportTables.length === 0)
  ) {
    Swal.fire({
      icon: "info",
      title: "No data found",
      text: "Download ke liye report data available nahi hai.",
    });
    return;
  }

  const sections = [];
  if (shouldExportMainTables && filteredReportData.length > 0) {
    sections.push(buildReportExcelSection(`Overall ${reportOwnerPossessive} Team Data`, filteredReportData));
  }

  if (shouldExportMainTables && filteredReportSelfData.length > 0) {
    sections.push(buildReportExcelSection(`${reportOwnerPossessive} Data`, filteredReportSelfData));
  }

  recruiterExportTables.forEach((table) => {
    sections.push(buildReportExcelSection(`${getPossessiveLabel(table.recruiter_name)} Report`, table.rows || []));
  });

  const workbookHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
      </head>
      <body>
        <div style="margin-bottom: 14px;">
          <div style="font-size: 18px; font-weight: 700;">Requirement Activity Report</div>
          <div style="margin-top: 4px;">${escapeExcelCell(`${formatReportDisplayDate(reportMeta.fromDate || reportDateFrom)} to ${formatReportDisplayDate(reportMeta.toDate || reportDateTo)}`)}</div>
        </div>
        ${sections.join("")}
      </body>
    </html>
  `;

  const blob = new Blob([`\ufeff${workbookHtml}`], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `detailed_report_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const fetchReportSummary = async (smId = "", fromDate = reportDateFrom, toDate = reportDateTo) => {
  setReportLoading(true);
  try {
    const res = await axios.get(`${apiurl}report_summary.php`, {
      params: {
        subdomain: "react",
        sm_id: smId || "",
        from_date: fromDate || "",
        to_date: toDate || "",
      },
    });

    const payload = res?.data || {};
    const data = payload.data || {};
    const filters = payload.filters || {};
    const meta = payload.meta || {};

    if (payload.status === false) {
      setReportData([]);
      setReportSelfData([]);
      setReportManagers(filters.sourcing_managers || []);
      setReportRecruiters(filters.recruiters || []);
      setReportRecruiterTables([]);
      setReportMeta({
        scopeType: "",
        scopeLabel: "",
        scopeName: "",
        fromDate: meta.from_date || fromDate || "",
        toDate: meta.to_date || toDate || "",
      });
      return;
    }

    setReportData(data.report || []);
    setReportSelfData(data.self_report || []);
    setReportManagers(filters.sourcing_managers || []);
    setReportRecruiters(filters.recruiters || []);
    setReportRecruiterTables(
      (data.recruiter_tables || []).map((table) => ({
        recruiter_id: table.recruiter_id,
        recruiter_name: table.recruiter_name,
        rows: table.report || [],
      }))
    );
    setReportMeta({
      scopeType: data.scope_type || "",
      scopeLabel: data.scope_label || "Detailed Report",
      scopeName: data.scope_name || "",
      fromDate: meta.from_date || fromDate || "",
      toDate: meta.to_date || toDate || "",
    });
  } catch (err) {
    setReportData([]);
    setReportSelfData([]);
    setReportManagers([]);
    setReportRecruiters([]);
    setReportRecruiterTables([]);
    setReportMeta({
      scopeType: "",
      scopeLabel: "",
      scopeName: "",
      fromDate: fromDate || "",
      toDate: toDate || "",
    });
  } finally {
    setReportLoading(false);
  }
};

const handleApplyReportFilters = async () => {
  if (!reportDateFrom || !reportDateTo) {
    Swal.fire({
      icon: "warning",
      title: "Date range missing",
      text: "Please select both start date and end date.",
    });
    return;
  }

  if (reportDateFrom > reportDateTo) {
    Swal.fire({
      icon: "warning",
      title: "Invalid date range",
      text: "Start date end date se chhoti ya equal honi chahiye.",
    });
    return;
  }

  setShowRecruiterTables(false);
  await fetchReportSummary(selectedReportManager?.value || "", reportDateFrom, reportDateTo);
};

const handleResetReportFilters = async () => {
  const range = getCurrentMonthReportRange();
  setSelectedReportManager(null);
  setReportDateFrom(range.from);
  setReportDateTo(range.to);
  setReportSearch("");
  setShowRecruiterTables(false);
  await fetchReportSummary("", range.from, range.to);
};

const renderReportDetailTable = (rows, emptyMessage = "No report data found") => (
  <div className="report-table-wrap">
    <table className="table table-bordered report-table report-detail-table mb-0">
      <thead>
        <tr className="group-row">
          <th rowSpan="2" className="report-date-col">Date</th>
          <th rowSpan="2">Requirement ID</th>
          <th rowSpan="2">Client Demands</th>
          <th rowSpan="2" className="report-client-col">Client Name</th>
          <th colSpan="2">Campaign</th>
          <th colSpan="2">Lineup Done</th>
          <th rowSpan="2">Total Selection</th>
          <th rowSpan="2">Total Joining</th>
          <th rowSpan="2">Total Onboarding</th>
          <th rowSpan="2">Total Payroll</th>
          <th rowSpan="2">Requirement Status</th>
        </tr>
        <tr className="header-row">
          <th>Open Campaign</th>
          <th>Paid Campaign</th>
          <th>Self Candidate</th>
          <th>Campaign Candidate</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? (
          rows.map((row, idx) => (
            <tr key={`${row.requirement_id || "report"}-${idx}`}>
              <td className="report-date-col">{formatReportDisplayDate(row.report_date || "-")}</td>
              <td>{row.requirement_id || "-"}</td>
              <td>{row.client_demands ?? 0}</td>
              <td className="report-client-col">{row.client_name || "-"}</td>
              <td>{row.open_campaign ?? 0}</td>
              <td>{row.paid_campaign ?? 0}</td>
              <td>{row.self_candidate ?? 0}</td>
              <td>{row.campaign_candidate ?? 0}</td>
              <td>{row.total_selection ?? 0}</td>
              <td>{row.total_joining ?? 0}</td>
              <td>{row.total_onboarding ?? 0}</td>
              <td>{row.total_payroll ?? 0}</td>
              <td>{row.requirement_status || "-"}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="13" className="text-center text-muted py-4">{emptyMessage}</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

return(
    <>
        {showReportModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-2xl shadow-2xl w-[96%] max-w-[1300px] max-h-[90vh] overflow-hidden mt-5">
              <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom bg-light rounded-top-2" style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <div>
                  <h5 className="mb-0 fw-semibold">Requirement Activity Report</h5>
                  <div className="text-muted small">Requirement-wise activity report with recruiter breakdown</div>
                </div>
                <div className="d-flex align-items-center gap-2 flex-shrink-0">
                  <button
                    type="button"
                    className="btn btn-sm btn-success"
                    onClick={downloadReportExcel}
                  >
                    <i className="bi bi-download me-1" aria-hidden="true"></i>
                    Download Excel
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-light"
                    onClick={() => setShowReportModal(false)}
                    aria-label="Close"
                  >
                    <span aria-hidden="true" style={{ fontSize: "20px", lineHeight: 1 }}>&times;</span>
                  </button>
                </div>
              </div>
              <div className="p-4" style={{ maxHeight: "calc(90vh - 56px)", overflowY: "auto" }}>
                <style>{`
                  .report-control-card {
                    border: 1px solid #e2e8f0;
                    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
                    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
                  }
                  .report-summary-card {
                    border: 1px solid #e2e8f0;
                    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
                    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
                  }
                  .report-table {
                    margin-bottom: 0;
                  }
                  .report-table thead tr.group-row th,
                  .report-table thead tr.header-row th {
                    background: #1e3a8a;
                    color: #fff;
                    font-weight: 700;
                    font-size: 13px;
                    text-align: center;
                  }
                  .report-table thead tr.group-row th {
                    text-transform: uppercase;
                    letter-spacing: 0.04em;
                  }
                  .report-table td, .report-table th {
                    vertical-align: middle;
                    padding: 8px 10px;
                    font-size: 12px;
                  }
                  .report-table th.report-date-col,
                  .report-table td.report-date-col {
                    min-width: 120px;
                    width: 120px;
                  }
                  .report-table th.report-client-col,
                  .report-table td.report-client-col {
                    min-width: 240px;
                    width: 240px;
                  }
                  .report-table-wrap {
                    border-radius: 8px;
                    overflow-x: auto;
                    border: 1px solid #dbe4f0;
                    box-shadow: inset 0 1px 0 rgba(255,255,255,0.65);
                  }
                  .report-table tbody tr:nth-child(even) td {
                    background: #f8fafc;
                  }
                  .report-metric-box {
                    min-height: 94px;
                    border-width: 1px;
                    box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);
                  }
                  .report-recruiter-card {
                    border: 1px solid #dbe4f0;
                    border-radius: 18px;
                    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
                    box-shadow: 0 18px 30px rgba(15, 23, 42, 0.08);
                    padding: 18px;
                  }
                  .report-recruiter-highlight {
                    display: inline-flex;
                    align-items: center;
                    border-radius: 999px;
                    padding: 6px 12px;
                    background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);
                    color: #ffffff;
                    font-weight: 700;
                    font-size: 14px;
                    letter-spacing: 0.01em;
                    box-shadow: 0 8px 18px rgba(30, 58, 138, 0.28);
                  }
                  .report-chip {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    border-radius: 999px;
                    padding: 6px 10px;
                    background: #eff6ff;
                    color: #1d4ed8;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.04em;
                    text-transform: uppercase;
                  }
                  .report-note-card {
                    border: 1px dashed #cbd5e1;
                    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
                  }
                `}</style>
                <div className="mb-4 p-4 rounded-4 report-control-card">
                  <div className="row g-3 align-items-end mb-1">
                    <div className="col-12 col-lg-5 col-xl-4">
                      <label className="form-label small text-muted">Sourcing Manager</label>
                      <Select
                        value={selectedReportManager}
                        onChange={async (option) => {
                          const value = option?.value || "";
                          setSelectedReportManager(option || null);
                          setShowRecruiterTables(false);
                          await fetchReportSummary(value, reportDateFrom, reportDateTo);
                        }}
                        options={reportManagerOptions}
                        isClearable
                        placeholder="All Sourcing Managers"
                        classNamePrefix="react-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: '#d1d5db',
                            minHeight: '32px',
                            fontSize: '0.875rem',
                          }),
                          placeholder: (base) => ({
                            ...base,
                            fontSize: '0.875rem',
                            color: '#6b7280',
                          }),
                          singleValue: (base) => ({
                            ...base,
                            fontSize: '0.875rem',
                          }),
                        }}
                      />
                    </div>
                    {selectedReportManager && (
                      <div className="col-12 col-lg-4 col-xl-3">
                        <label className="form-label small text-muted">Recruiters View</label>
                        <button
                          type="button"
                          className={`btn w-100 ${showRecruiterTables ? "btn-outline-primary" : "btn-primary"}`}
                          onClick={() => setShowRecruiterTables((prev) => !prev)}
                          disabled={reportRecruiters.length === 0}
                          title={
                            reportRecruiters.length > 0
                              ? `Click To See Recruiters Data (${reportRecruiters.length})`
                              : "No recruiters mapped to this sourcing manager."
                          }
                        >
                          {showRecruiterTables ? "Hide Recruiters Data" : "Show Recruiters Data"}
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="row g-3 align-items-end">
                    <div className="col-12 col-lg-2 col-md-6">
                      <label className="form-label small text-muted">Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={reportDateFrom}
                        onChange={(e) => setReportDateFrom(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-lg-2 col-md-6">
                      <label className="form-label small text-muted">End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={reportDateTo}
                        onChange={(e) => setReportDateTo(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-lg-2 col-md-4">
                      <label className="form-label small text-muted d-block">&nbsp;</label>
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-primary flex-fill"
                          onClick={handleApplyReportFilters}
                          disabled={reportLoading}
                        >
                          Apply
                        </button>
                        <button
                          type="button"
                          className="btn btn-light border flex-fill"
                          onClick={handleResetReportFilters}
                          disabled={reportLoading}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 col-md-8">
                      <label className="form-label small text-muted">Search</label>
                      <input
                        type="text"
                        className="form-control"
                        value={reportSearch}
                        onChange={(e) => setReportSearch(e.target.value)}
                        placeholder="Search name / Req id / status"
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="mb-4 p-4 rounded-4 report-summary-card">
                  <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-3">
                    <div>
                      <div className="text-uppercase text-xs fw-semibold text-primary mb-1">Current Scope</div>
                      <h6 className="mb-1 fw-bold text-dark">
                        {selectedReportManager?.label || reportMeta.scopeName || "Your Data"}
                      </h6>
                      <div className="small text-muted">
                        {formatReportDisplayDate(reportMeta.fromDate || reportDateFrom)} to {formatReportDisplayDate(reportMeta.toDate || reportDateTo)}
                      </div>
                    </div>
                    <div className="small text-muted">
                      {filteredReportData.length} requirement row{filteredReportData.length === 1 ? "" : "s"} shown
                    </div>
                  </div>
                  <div className="row g-3">
                    {reportStatCards.map((card) => (
                      <div className="col-12 col-sm-6 col-xl" key={card.label}>
                        <div className={`rounded-4 border p-3 report-metric-box ${card.tone}`}>
                          <div className="text-uppercase small fw-semibold opacity-75">{card.label}</div>
                          <div className="fs-3 fw-bold mt-2">{card.value}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div> */}

                {reportLoading ? (
                  <div className="py-5 text-center text-muted">Loading report...</div>
                ) : (
                  <>
                    {!(selectedReportManager && showRecruiterTables) && (
                      <div className="mt-2">
                        <div className="report-recruiter-card mb-4">
                          <div className="mb-3">
                            <div className="mb-1">
                              <span className="report-recruiter-highlight">{`Overall ${reportOwnerPossessive} Team Data`}</span>
                            </div>
                            <div className="small text-muted">
                              Team-wise requirement activity data for current selection.
                            </div>
                          </div>
                          {renderReportDetailTable(filteredReportData, "No overall team data found for this selection")}
                        </div>

                        <div className="report-recruiter-card mb-2">
                          <div className="mb-3">
                            <div className="mb-1">
                              <span className="report-recruiter-highlight">{`${reportOwnerPossessive} Data`}</span>
                            </div>
                            <div className="small text-muted">
                              Only your own requirement activity data (without downline).
                            </div>
                          </div>
                          {renderReportDetailTable(filteredReportSelfData, "No self data found for this selection")}
                        </div>
                      </div>
                    )}

                    {selectedReportManager && showRecruiterTables && (
                      <div className="mt-4">
                        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-2 mb-3">
                          <div>
                            <h6 className="mb-1 fw-bold text-dark">Recruiter Wise Tables</h6>
                            <div className="small text-muted">
                              {showRecruiterTables
                                ? "Detailed recruiter-wise report for the selected sourcing manager."
                                : "Recruiter-wise tables will open when you click the Show Recruiters Data button."}
                            </div>
                          </div>
                          {showRecruiterTables && (
                            <div className="small text-muted">
                              {filteredReportRecruiterTables.length} recruiter table{filteredReportRecruiterTables.length === 1 ? "" : "s"} with data
                            </div>
                          )}
                        </div>

                        {filteredReportRecruiterTables.length > 0 ? (
                          <div className="space-y-4">
                            {filteredReportRecruiterTables.map((table) => {
                              return (
                                <div className="report-recruiter-card mb-4" key={table.recruiter_id || table.recruiter_name}>
                                  <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-3">
                                    <div>
                                      <div className="mb-1">
                                        <span className="report-recruiter-highlight">{`${getPossessiveLabel(table.recruiter_name)} Report`}</span>
                                      </div>
                                      <div className="small text-muted">
                                        {table.rows.length} requirement row{table.rows.length === 1 ? "" : "s"}
                                      </div>
                                    </div>
                                  </div>
                                  {renderReportDetailTable(table.rows || [], "No recruiter data found")}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="rounded-4 report-note-card px-4 py-5 text-center text-muted">
                            No recruiter report data found for the selected sourcing manager.
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {loading && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
            <div className="rounded-xl bg-white px-6 py-5 shadow-lg border border-gray-100 text-center min-w-[220px]">
              <div className="mx-auto mb-3 h-10 w-10 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
              <p className="text-sm font-medium text-gray-700">Loading dashboard...</p>
            </div>
          </div>
        )}
        {/* MAIN-CONTENT */}
        <div className="main-content app-content" style={{marginBlockStart:'0rem !important'}}>
            <div className="container-fluid mb-4">
              {showTopTabsForPost ? (
                <section className="mt-3 mb-2">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <div className="max-w-[560px] w-full flex-shrink-0">
                      <div className="rounded-2xl border border-primary/20 bg-primary-transparent p-1 shadow-sm">
                        <div className="relative flex">
                          <span
                            aria-hidden="true"
                            className="pointer-events-none absolute left-1 top-0 bottom-0 rounded-lg bg-white shadow-sm transition-transform duration-300 ease-out"
                            style={{
                              width: "calc(50% - 6px)",
                              transform:
                                topDashboardTab === "mtd"
                                  ? "translateX(100%)"
                                  : "translateX(0%)",
                            }}
                          />
                          <button
                            type="button"
                            onClick={() => setTopDashboardTab("dashboard")}
                            className={`relative z-10 w-1/2 rounded-xl px-3 py-1.5 text-sm font-semibold whitespace-nowrap transition-colors duration-200 ${
                              topDashboardTab === "dashboard"
                                ? "text-primary"
                                : "text-slate-600 hover:text-primary"
                            }`}
                          >
                            Dashboard
                          </button>
                          <button
                            type="button"
                            onClick={() => setTopDashboardTab("mtd")}
                            className={`relative z-10 w-1/2 rounded-xl px-3 py-1.5 text-sm font-semibold whitespace-nowrap transition-colors duration-200 ${
                              topDashboardTab === "mtd"
                                ? "text-primary"
                                : "text-slate-600 hover:text-primary"
                            }`}
                          >
                            MTD Dashboard
                          </button>
                        </div>
                      </div>
                    </div>
                    {post?.toLowerCase() === "sourcing_head" && (
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={reportLoading}
                        onClick={async () => {
                          const range = getCurrentMonthReportRange();
                          setShowReportModal(true);
                          setSelectedReportManager(null);
                          setReportDateFrom(range.from);
                          setReportDateTo(range.to);
                          setReportSearch("");
                          setShowRecruiterTables(false);
                          await fetchReportSummary("", range.from, range.to);
                        }}
                      >
                        {reportLoading ? "Generating..." : "Generate Report"}
                      </button>
                    )}
                  </div>
                </section>
              ) : null}

              {isMtdDashboardTab ? (
                <section className="mt-2 mb-4 transition-all duration-300 ease-out">
                  <div className="bg-white rounded-2xl shadow-md border border-primary/20 mt-4 p-0 md:p-3">
                    <MtdDashboard />
                  </div>
                </section>
              ) : (
                <>
                 
              <section className="mt-4 mb-3 p-4 bg-card-bg rounded-xl border border-gray-100 bg-white shadow-[0_12px_28px_rgba(15,23,42,0.14)]">
    <h2 className="text-xl font-bold text-gray-800 mb-2">Data Filters</h2>
    
 <div className="flex flex-col md:flex-row md:items-center gap-3 sm:gap-4 flex-wrap">
        
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="w-full sm:w-auto flex flex-col sm:flex-row gap-3 sm:gap-2 sm:items-center">
                <label className="text-sm text-gray-600 font-medium whitespace-nowrap">Start Date:</label>
                <DatePicker
                    value={filterStartDate ? dayjs(filterStartDate) : null}
                    format="DD MM YYYY"
                    onChange={(value) => {
                        setFilterStartDate(value && value.isValid() ? value.format("YYYY-MM-DD") : "");
                        setFilterDateError("");
                    }}
                    slotProps={{
                        textField: {
                            size: "small",
                            className: "w-full sm:w-[180px]",
                            inputProps: { placeholder: "DD MM YYYY" },
                        },
                        popper: {
                            placement: "bottom-start",
                        },
                    }}
                />
            </div>

            <div className="w-full sm:w-auto flex flex-col sm:flex-row gap-3 sm:gap-2 sm:items-center">
                <label className="text-sm text-gray-600 font-medium whitespace-nowrap">End Date:</label>
                <DatePicker
                    value={filterEndDate ? dayjs(filterEndDate) : null}
                    format="DD MM YYYY"
                    minDate={filterStartDate ? dayjs(filterStartDate) : undefined}
                    onChange={(value) => {
                        setFilterEndDate(value && value.isValid() ? value.format("YYYY-MM-DD") : "");
                        setFilterDateError("");
                    }}
                    slotProps={{
                        textField: {
                            size: "small",
                            className: "w-full sm:w-[180px]",
                            inputProps: { placeholder: "DD MM YYYY" },
                        },
                        popper: {
                            placement: "bottom-start",
                        },
                    }}
                />
            </div>
        </LocalizationProvider>

        {/* Filter 2: Requirement Selector (React-Select) */}
        <div className="w-full sm:w-auto min-w-[180px]">
            <Select
                options={requirementOptions}
                onChange={setSelectedRequirement}
                value={selectedRequirement}
                placeholder="Select Requirement"
                isClearable={true}
                classNamePrefix="react-select"
                styles={{
                    control: (base) => ({
                        ...base,
                        borderColor: '#d1d5db', // gray-300
                        '&:hover': {
                            borderColor: '#93c5fd', // primary-blue on hover (approx)
                        },
                        minHeight: '36px', // Match height of native input
                    }),
                    placeholder: (base) => ({
                        ...base,
                        fontSize: '0.875rem', // text-sm
                        color: '#6b7280' // gray-500
                    })
                }}
            />
        </div>
       
        
        <div
            onClick={() => {
                if (!filterStartDate || !filterEndDate) {
                    setFilterDateError("First select start date and end date.");
                }
            }}
            className="w-full sm:w-auto"
        >
            <button 
                onClick={handleApplyFilters}
                disabled={!filterStartDate || !filterEndDate}
                className={`px-4 py-2 text-sm font-semibold rounded-lg text-white transition duration-150 shadow-md w-full sm:w-auto ${
                    !filterStartDate || !filterEndDate
                        ? "bg-emerald-700/55 cursor-not-allowed"
                        : "bg-emerald-600 hover:bg-emerald-700"
                }`}
            >
                Apply Filters
            </button>
        </div>

        <button
            type="button"
            onClick={handleClearFilters}
            className="px-4 py-2 text-sm font-semibold rounded-lg text-slate-700 bg-slate-100 transition duration-150 shadow-sm hover:bg-slate-200"
        >
            Clear Filters
        </button>
</div>
{filterDateError && (
    <p className="mt-3 text-sm font-medium text-red-600">{filterDateError}</p>
)}
              </section>

 {divy_accounts===0 && (          
    <main className="flex flex-col lg:flex-row gap-6 mb-2 "> 
<div className="flex w-full flex-col">

<section className={`${headingData.viewShow===0 || headingData.viewShow===1 || headingData.viewShow===2 ? 'w-full' : 'w-full lg:w-[70%] lg:flex-shrink'} space-y-4`}>
                        
 {headingData.viewShow!==0 && (
 <div className="relative overflow-hidden rounded-3xl border border-gray-100 bg-white p-6 shadow-[0_16px_36px_rgba(15,23,42,0.12)]">
                            <div className={`w-full ${shouldShowRequirementsStatsGraph ? "xl:flex xl:items-start xl:gap-6" : ""}`}>
                              <div className={`w-full ${shouldShowRequirementsStatsGraph ? "xl:w-[70%]" : ""}`}>
                                <div className="rounded-2xl bg-white">
                                  <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                                    <div>
                                      <h3 className="text-xl font-bold text-gray-800 mb-0">Requirements Stats</h3>
                                      <p className="text-sm text-slate-500 mb-0">Status-wise requirement summary.</p>
                                    </div>
                                    {((dashboardData.viewShow==='1' || isVendorDashboard) && ( <button onClick={() => handleViewClick("stats")} className={viewDetailsButtonClass}>{sectionData.stats.show ? "Hide Details" : "View Details"}</button>
                                     ))}
                                  </div>
                                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 w-full">
                                    {dashboardData.stats.map((stat, index) => {
                                      const requirementPalette = [
                                        { start: "#2563eb", end: "#7da7f7" }, // blue
                                        { start: "#f59e0b", end: "#f9c75f" }, // yellow
                                        { start: "#ef4444", end: "#f27b7b" }, // red
                                        { start: "#14b8a6", end: "#61dbcf" }, // teal
                                        { start: "#64748b", end: "#9aa7bb" }, // slate
                                      ];
                                      const theme = requirementPalette[index % requirementPalette.length];
                                      const baseColor = theme.start;
                                      return (
                                        <div
                                          key={index}
                                          className="w-full min-h-[122px] p-3 rounded-2xl text-white relative overflow-hidden min-w-0 flex flex-col justify-center"
                                          style={{
                                            border: `1px solid ${baseColor}88`,
                                            background: `linear-gradient(145deg, ${theme.start} 0%, ${theme.end} 100%)`,
                                          }}
                                        >
                                          <div
                                            className="pointer-events-none absolute inset-x-0 top-0 h-20"
                                            style={{
                                              background: `linear-gradient(180deg, rgba(255,255,255,0.08) 0%, transparent 100%)`,
                                            }}
                                          />
                                          <div
                                            className="pointer-events-none absolute inset-0 opacity-100"
                                            style={{
                                              background: `radial-gradient(circle at top right, rgba(255,255,255,0.08) 0%, transparent 30%), linear-gradient(135deg, rgba(255,255,255,0.05) 0%, transparent 48%)`,
                                            }}
                                          />
                                          <div
                                            className="pointer-events-none absolute inset-x-6 top-0 h-[1px]"
                                            style={{ background: `linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.95) 50%, transparent 100%)` }}
                                          />
                                          <span className="relative z-10 text-xs opacity-80 font-medium uppercase text-white">{stat.label}</span>
                                          <div className="relative z-10 flex items-center justify-between">
                                            <p className="text-xl font-bold mt-1 text-white">{stat.count}</p>
                                            <div
                                              className="flex h-11 w-11 items-center justify-center rounded-2xl"
                                              style={{
                                                background: `linear-gradient(180deg, rgba(255,255,255,0.12) 0%, rgba(15,23,42,0.14) 100%)`,
                                                border: `1px solid rgba(255,255,255,0.12)`,
                                                boxShadow: `inset 0 1px 0 rgba(255,255,255,0.12), 0 8px 18px rgba(15,23,42,0.24)`,
                                              }}
                                            >
                                              <i className={`${stat.icon} text-2xl text-white opacity-90`}></i>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>

                              {shouldShowRequirementsStatsGraph && (
                                <div className="mt-0 w-full rounded-2xl border border-slate-100 bg-white p-4 shadow-sm xl:mt-0 xl:w-[30%] xl:pl-2">
                                  <div className="mb-2">
                                    <h3 className="text-lg font-bold text-gray-800 mb-0">Requirements Stats (Graph)</h3>
                                    
                                  </div>
                                  <RequirementsStatsMiniChart data={dashboardData.stats} />
                                </div>
                              )}
                            </div>
          
 {sectionData.stats.show && (
   <div className="mt-4">
    {isVendorDashboard ? (
      <DataTable
        data={sectionData.stats.data || []}
        columns={vendorRequirementColumns}
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50]}
        highlightOnHover
        dense
        responsive
        noDataComponent={<div className="py-3 text-sm text-slate-500">No uploaded candidate details found.</div>}
      />
    ) : (
    <>
    
    {/* Tabs */}
    {tabsByPost[post]?.length > 0 && (
      <div className="flex gap-3 border-b pb-2 mb-3">
        {tabsByPost[post].map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTabClick('stats',tab.key)}
            className={`px-3 pb-1 text-sm font-medium ${
              sectionData.stats.activeTab === tab.key
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    )}

    {/* Loader */}
    {sectionData.stats.loading ? (
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
        <span>Loading details...</span>
      </div>
    ) : (
      <DataTable
       data={sectionData.stats.data[sectionData.stats.activeTab] || []}
          columns={
            sectionData.stats.data[sectionData.stats.activeTab]?.length > 0
              ? Object.keys(
                  sectionData.stats.data[sectionData.stats.activeTab][0]
                ).map((key) => ({
                  name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                  selector: (row) => row[key],
                  sortable: true,
                }))
              : []
          }
        pagination
        highlightOnHover
        dense
      />
    )}
    </>
    )}
  </div>
)}
</div>
)}

{headingData.provendor===1 && (
  <>
                          
 <div className="bg-card-bg rounded-xl shadow-md border border-gray-100 p-3 bg-white mb-4">
                            <div className='flex justify-content-between align-items-start mb-2'>
                            <h2 className="text-xl font-bold text-gray-800 mb-0">{headingData.stats2}</h2>
                           </div>
                            <div className="flex flex-col md:flex-row md:items-start gap-4">
                                
                    {dashboardData.stats2.map((stat, index) => (
                        <div
                            key={index}
                            className={`w-full md:w-1/3 p-3 rounded-lg text-white ${stat.color === '#4e73df' ? 'bg-primary-blue' : stat.color === '#f6c23e' ? 'bg-yellow-500' : stat.color === '#e74a3b' ? 'bg-red-500' : 'bg-gray-500'}`}
                            style={{ backgroundColor: stat.color }} // Use inline style as the color is a hex code from the API
                        >
                            <span className={`text-xs opacity-80 font-medium uppercase text-white`}>{stat.label}</span>
                            <div className="flex items-center justify-between">
                                <p className="text-xl font-bold mt-1">{stat.count}</p>
                                <i className={`${stat.icon} text-2xl opacity-75`}></i>
                            </div>
                        </div>
                    ))}
                            </div>
    </div>
  </>
)}

{!isVendorDashboard && (
<main className="mt-4 mb-3 w-full" style={{ order: getDashboardCardOrder("requirements") }}>
  <section className="w-full space-y-4">
    <div className="relative overflow-hidden rounded-3xl border border-gray-100 bg-white p-6 shadow-[0_16px_36px_rgba(15,23,42,0.12)]">
      <div className="relative flex flex-col lg:flex-row gap-6">
        <div className="w-full lg:w-[70%]">
          <div className='flex justify-content-between align-items-start mb-2'>
            <h2 className="text-xl font-bold text-gray-800 mb-0">Requirements</h2>
            {(dashboardData.viewShow==='1' && ( <button onClick={() => handleViewClick("require")} className={viewDetailsButtonClass}>{sectionData.require.show ? "Hide Details" : "View Details"}</button>  ))}  
          </div>

          <p className="text-sm text-slate-500 mb-3">Status-wise requirement summary.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
            {dashboardData.require.map((config, index) => (
              <div key={`${config.key || config.label || "require"}-${index}`}
                style={{
                  border: `1px solid ${config.hexcolor}88`,
                  background: `linear-gradient(155deg, ${config.hexcolor}ff 0%, ${config.hexcolor}eb 52%, ${config.hexcolor}88 100%)`,
                  boxShadow: `0 18px 36px ${config.hexcolor}3a`,
                }}
                className={`w-full p-3 rounded-2xl text-white relative overflow-hidden min-w-0 transition duration-300 transform hover:-translate-y-1 hover:shadow-xl cursor-pointer ${config.border}`}
              >
                <div
                  className="pointer-events-none absolute inset-x-0 top-0 h-20"
                  style={{
                    background: `linear-gradient(180deg, rgba(255,255,255,0.08) 0%, transparent 100%)`,
                  }}
                />
                <div
                  className="pointer-events-none absolute inset-0 opacity-100"
                  style={{
                    background: `radial-gradient(circle at top right, rgba(255,255,255,0.08) 0%, transparent 30%), linear-gradient(135deg, rgba(255,255,255,0.05) 0%, transparent 48%)`,
                  }}
                />
                <div
                  className="pointer-events-none absolute inset-x-6 top-0 h-[1px]"
                  style={{ background: `linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.95) 50%, transparent 100%)` }}
                />
                <span className="relative z-10 text-xs opacity-80 font-medium uppercase text-white">{config.label}</span>
                <div className="relative z-10 flex items-center justify-between">
                  <p className="text-xl font-bold mt-1 text-white">{config.count}</p>
                  <div
                    className="flex h-11 w-11 items-center justify-center rounded-2xl"
                    style={{
                      background: `linear-gradient(180deg, rgba(255,255,255,0.12) 0%, rgba(15,23,42,0.14) 100%)`,
                      border: `1px solid rgba(255,255,255,0.12)`,
                      boxShadow: `inset 0 1px 0 rgba(255,255,255,0.12), 0 8px 18px rgba(15,23,42,0.24)`,
                    }}
                  >
                    <i className={`${config.icon} text-2xl text-white opacity-90`} />
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>

        <div className="w-full lg:w-[28%] lg:pl-2 self-start space-y-4">
          <div className="rounded-xl bg-white p-0">
            {shouldKeepClientWiseChartForRequirements ? (
              <>
                <div className="mb-2 flex items-start justify-between gap-3">
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 mb-0">Requirements (Client Wise)</h3>
                    <p className="text-xs text-slate-500 mb-0">Top clients by requirements.</p>
                  </div>
                </div>
                <ClientRequirementChart data={requirementClientChartData} />
              </>
            ) : (
              <div className="mx-auto w-full max-w-[340px] space-y-1.5">
                {requirementSummaryRows.map((row) => (
                  <div
                    key={row.label}
                    className="rounded-lg border border-slate-200/80 bg-slate-50/70 px-2.5 py-1.5"
                  >
                    <div className="mb-1.5 flex items-center justify-between text-xs">
                      <div className="flex items-center gap-2 font-semibold text-slate-700">
                        <span
                          className="inline-block h-2 w-2 rounded-full"
                          style={{ backgroundColor: row.tone }}
                        />
                        <span>{row.label}</span>
                      </div>
                      <span className="text-sm font-bold text-slate-800">{row.value}</span>
                    </div>
                    <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-200">
                      <div
                        className="h-full rounded-full transition-all duration-300"
                        style={{ width: `${row.percent}%`, backgroundColor: row.tone }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {sectionData.require.show && (
        <div className="mt-4">
          <div className="rounded-lg border border-gray-200 bg-white p-3 mb-2 shadow-[0_10px_24px_rgba(15,23,42,0.08)]">
            <div className="mb-4">
              <div className="overflow-x-auto">
              <div className="relative grid grid-cols-2 rounded-full border border-slate-300 bg-gradient-to-r from-slate-100 via-slate-50 to-slate-100 p-1 text-sm shadow-[inset_0_1px_2px_rgba(15,23,42,0.12)] min-w-[420px]">
                <span
                  className="absolute top-1 bottom-1 left-1 w-[calc((100%-0.5rem)/2)] rounded-full bg-white shadow-[0_6px_16px_rgba(15,23,42,0.12)] ring-1 ring-blue-100 transition-transform duration-300 ease-out"
                  style={{
                    transform: requirementDetailTab === "creation" ? "translateX(0%)" : "translateX(100%)",
                  }}
                />
                {[
                  { key: "creation", label: "Requirement creation details" },
                  { key: "assigned", label: "Requirement assigned details" },
                ].map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setRequirementDetailTab(tab.key)}
                    className={`relative z-10 w-full px-4 py-2 rounded-full font-semibold transition-colors duration-200 text-center ${
                      requirementDetailTab === tab.key
                        ? "text-blue-700"
                        : "text-slate-600 hover:text-slate-800"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
              </div>
            </div>

                {requirementDetailTab === "creation" && (
                  <>
                    {sectionData.requireCreation.loading ? (
                      <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
                        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
                        <span>Loading details...</span>
                      </div>
                    ) : (
                      <DataTable
                        data={sectionData.requireCreation.data || []}
                        columns={requirementCreationColumns}
                        pagination
                        paginationPerPage={5}
                        paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                        highlightOnHover
                        dense
                        responsive
                        customStyles={requirementCreationTableStyles}
                        noDataComponent={<div className="py-3 text-sm text-slate-500">No requirement creation details found.</div>}
                      />
                    )}
                  </>
                )}

                {requirementDetailTab === "assigned" && (
                  <>
                    {sectionData.require.loading ? (
                      <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
                        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
                        <span>Loading details...</span>
                      </div>
                    ) : (
                      <DataTable
                        data={sectionData.require.data || []}
                        columns={requirementAssignedColumns}
                        pagination
                        paginationPerPage={5}
                        paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                        highlightOnHover
                        dense
                        responsive
                        customStyles={requirementAssignedTableStyles}
                        noDataComponent={<div className="py-3 text-sm text-slate-500">No requirement assigned details found.</div>}
                      />
                    )}
                  </>
                )}
          </div>
        </div>
      )}
    </div>
  </section>
</main>
)}

{headingData.viewShow===0 && (
<div>
{/* <div className="bg-white rounded-lg border border-gray-100 p-3 mb-3">
  <div className="flex justify-between items-center pb-2">
    <h3 className="text-lg font-semibold text-gray-700 mb-0">Daily/Weekly Track</h3>
  </div>
  <div className="space-y-3">
    {jobData && jobData.length > 0 ? (
      jobData.map((job) => (
        <div
          key={job.id}
          className="flex items-center justify-between p-3 rounded-lg border border-gray-200 hover:bg-indigo-50 transition duration-150 cursor-pointer"
        >
          <div className="flex items-center min-w-0 flex-1">
            <div className={`flex items-center justify-center h-7 w-7 rounded-full font-bold text-sm mr-4 flex-shrink-0 ${getRandomColor(job.id)}`}>
              {job.short_name}
            </div>
            <div className="min-w-0">
              <p className="text-md font-bold text-gray-900 leading-tight">{job.name}</p>
              <p className="text-sm text-gray-500">{job.post}</p>
            </div>
          </div>
          <div className="flex items-center flex-shrink-0" style={{ width: '58%' }}>
            <div className="text-center w-20">
              <p className="text-xs font-semibold text-gray-500 uppercase">Today</p>
              <p className="text-sm font-extrabold text-blue-600 mt-0.5">{job.today}</p>
            </div>
            <div className="border-l border-gray-200 h-10 mx-2"></div>
            <div className="text-center w-20">
              <p className="text-xs font-semibold text-gray-500 uppercase">Week</p>
              <p className="text-sm font-extrabold text-green-600 mt-0.5">{job.week}</p>
            </div>
            <div className="border-l border-gray-200 h-10 mx-2"></div>
            <div className="text-center w-20">
              <p className="text-xs font-semibold text-gray-500 uppercase">Month</p>
              <p className="text-sm font-extrabold text-red-600 mt-0.5">{job.month}</p>
            </div>
          </div>
        </div>
      ))
    ) : (
      <p className="text-center text-gray-500 py-4">No team members found.</p>
    )}
  </div>
</div> */}

{headingData.viewShow===1 &&(
  <>
  <div className="bg-white rounded-xl border border-gray-100 p-6">
      <h2 className="text-xl font-bold text-gray-800 mb-2">{activeTab === "client" ? "Requirements (Client Wise)" : "Requirements (Location Wise)"}</h2>
      <p className="text-sm text-slate-500 mb-3">Requirements breakdown across clients and locations.</p>
    <div className="flex gap-3 mb-4">
    <button 
        onClick={() => setActiveTab("client")}
        className={`px-4 py-2 rounded-lg font-semibold 
            ${activeTab === "client" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"}
        `}
    >
        Client Wise
    </button>

    <button 
        onClick={() => setActiveTab("location")}
        className={`px-4 py-2 rounded-lg font-semibold 
            ${activeTab === "location" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"}
        `}
    >
        Location Wise
    </button>
</div>

        
         <DataTable
          columns={columns}
          data={tableData}
          progressPending={loadings}
          pagination
          paginationPerPage={50}
          paginationRowsPerPageOptions={[50, 100, 200, 300]}
          fixedHeader
          striped
        />
        </div>
 
  </>
)}

{headingData.viewShow===2 && (
  <>

<div className="bg-white rounded-xl  border border-gray-100 p-6">
    {/* Tabs */}
    {tabsByPost[post]?.length > 0 && (
      <div className="flex gap-3 border-b pb-2 mb-3">
        {tabsByPost[post].map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTabClick2('campaign',tab.key)}
            className={`px-3 pb-1 text-sm font-medium ${
              tabbedSectionData.campaign.activeTab === tab.key
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    )}

    {/* Loader */}
    {loading ? (
      <div className="w-full text-center py-6 text-sm text-gray-500">
        Loading data...
      </div>
    ) : (
      <DataTable
      data={campaignRequirementRows}
          columns={
            campaignRequirementRows?.length > 0
              ? Object.keys(
                  campaignRequirementRows[0]
                ).map((key) => ({
                  name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                  selector: (row) => row[key],
                  sortable: true,
                }))
              : []
          }
        pagination
        highlightOnHover
        dense
      />
    )}
 
</div>
<div  className="bg-white rounded-xl  border border-gray-100 p-6">
  <ClientReportTable clientWise={clientWise}/>
</div>
<div  className="bg-white rounded-xl  border border-gray-100 p-6">
  <ClientReportTable clientWise={campaginWise}/>
</div>
  </>
)}

</div>
)}
</section>

{headingData.viewShow!==0 && !(dashboardData.viewShow==='1' || headingData.viewShow===2) && !shouldShowRequirementsStatsGraph && (
 <section className="grid w-full grid-cols-1 gap-4 lg:grid-cols-2">
   <div className="bg-card-bg p-3 rounded-xl bg-white shadow-md border border-gray-100">
     <p className="text-sm font-semibold text-gray-700">{headingData.stats} (Graph)</p>
     <div className="chart-container-large">
       <DashboardChartTwo data={dashboardData.stats} keyLabel="label" keyCount="count" statName="Candidate ( Graph )" />
     </div>
   </div>
   <div className="bg-card-bg p-4 rounded-xl bg-white shadow-md border border-gray-100">
     {headingData.viewShow===1 ? (
       <ClientLeadStacked data={dashboardData.clientlead}/>
     ) : (
       <ProfilePieChart  data={dashboardData.profile} keyLabel="pname" keyValue="count"/>
     )}
   </div>
 </section>
)}

</div>
</main>
)}
{headingData.viewShow!==0 && shouldShowTatSummaryCard && (
  <div className="mb-3">
    <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-[0_14px_30px_rgba(15,23,42,0.08)]">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between mb-3">
        <div>
          <h2 className="text-xl font-bold text-gray-800 mb-0">TAT Summary</h2>
          <p className="text-sm text-slate-500 mb-0">
            Candidate and campaign approval turnaround analytics.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">
            Total Candidates: {normalizedTatSummary.totalCandidates}
          </span>
          <span className="inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
            Overall Avg: {normalizedTatSummary.overallAvgDays.toFixed(1)} days
          </span>
          <button
            type="button"
            onClick={() => setShowTatDetails((prev) => !prev)}
            className={viewDetailsButtonClass}
          >
            {showTatDetails ? "Hide Details" : "View Details"}
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-5">
        {tatStagesForCard.map((stage, index) => {
          const theme = getAdvancePaymentTatTheme(index);
          return (
            <div
              key={`tat-stage-inline-${stage.key}`}
              className="relative min-w-0 overflow-hidden rounded-xl border border-slate-200 bg-white px-3 py-3 shadow-[0_4px_14px_rgba(15,23,42,0.05)]"
              style={{
                background: `linear-gradient(180deg, ${theme.soft} 0%, #ffffff 100%)`,
                borderColor: `${theme.accent}26`,
              }}
            >
              <div className="relative z-10 flex items-center gap-3">
                <div
                  className="flex h-10 w-10 items-center justify-center rounded-full flex-shrink-0"
                  style={{ background: theme.accent }}
                >
                  <i className={`${stage.icon} text-lg text-white`} />
                </div>
                <div className="min-w-0 flex-1 text-right">
                  <p className="text-[10px] uppercase tracking-[0.12em] text-slate-400">Turnaround</p>
                  <p className="mt-0.5 text-base font-bold leading-none text-slate-900">{stage.label}</p>
                  <p className="mt-1 text-xl font-bold leading-none" style={{ color: theme.accent }}>
                    {Number(stage.avgDays || 0).toFixed(1)} days
                  </p>
                  <p className="mt-1 text-[11px] text-slate-500">{Number(stage.count || 0)} candidates</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="my-4 border-t border-slate-200" />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {campaignTatStagesForCard.map((stage, index) => {
          const theme = getAdvancePaymentTatTheme(index);
          return (
            <div
              key={`campaign-tat-inline-${stage.key}`}
              className="relative min-w-0 overflow-hidden rounded-xl border border-slate-200 bg-white px-3 py-3 shadow-[0_4px_14px_rgba(15,23,42,0.05)]"
              style={{
                background: `linear-gradient(180deg, ${theme.soft} 0%, #ffffff 100%)`,
                borderColor: `${theme.accent}26`,
              }}
            >
              <div className="relative z-10 flex items-center gap-3">
                <div
                  className="flex h-10 w-10 items-center justify-center rounded-full flex-shrink-0"
                  style={{ background: theme.accent }}
                >
                  <i className={`${stage.icon} text-lg text-white`} />
                </div>
                <div className="min-w-0 flex-1 text-right">
                  <p className="text-[10px] uppercase tracking-[0.12em] text-slate-400">Approval TAT</p>
                  <p className="mt-0.5 text-base font-bold leading-none text-slate-900">{stage.label}</p>
                  <p className="mt-1 text-xl font-bold leading-none" style={{ color: theme.accent }}>
                    {Number(stage.avgHours || 0).toFixed(2)} hours
                  </p>
                  <p className={`mt-1 text-[11px] ${Number(stage.exceeded || 0) > 0 ? "text-red-600" : "text-slate-500"}`}>
                    {Number(stage.exceeded || 0) > 0 ? `Exceeded: ${Number(stage.exceeded || 0)}` : `${Number(stage.samples || 0)} samples`}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {showTatDetails && (
        <div className="mt-4 rounded-xl border border-slate-200 bg-white p-2">
          <DataTable
            columns={campaignTatDetailColumns}
            data={normalizedCampaignTat.requestRows}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            highlightOnHover
            dense
            striped
            noDataComponent={<div className="py-3 text-sm text-slate-500">No campaign approval requests found for selected filters.</div>}
          />
        </div>
      )}
    </div>
  </div>
)}
{headingData.viewShow===0 && (
<>
 <main className="mt-0 mb-1 flex flex-col lg:flex-row gap-6" style={{paddingBottom: '0px', order: getDashboardCardOrder("campaignPerformance")}}>
  <div className="bg-white rounded-xl border border-gray-100 p-6 w-full shadow-[0_12px_28px_rgba(15,23,42,0.14)]">
    <div className="flex flex-col lg:flex-row gap-6">
        <section className="w-full lg:w-[70%] lg:flex-shrink space-y-4">

<div className="rounded-xl">
          <div className='flex justify-content-between align-items-start mb-2'>
              <h2 className="text-xl font-bold text-gray-800 mb-0">Campaign Performance</h2>
             {(dashboardData.viewShow==='1' && ( <button onClick={() => handleViewClick("campaign")} className={viewDetailsButtonClass}>{sectionData.campaign.show ? "Hide Details" : "View Details"}</button>  ))}  
      </div>
      <p className="text-sm text-slate-500 mb-3">
        Snapshot of campaign activity by status.
      </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                {dashboardData.stats2.map((stat, index) => (
                    <div key={index} className="flex flex-col rounded-xl shadow-lg overflow-hidden transition duration-300 transform hover:scale-[1.02]">
                        <div  className={`${stat.color} flex items-center justify-center p-3 h-14`}>
                            <i 
                                className={`${stat.icon} text-3xl text-white`}
                                title={stat.label}
                            ></i>
                        </div>
                        
                        {/* 2. White Content Section */}
                        <div className="p-3 bg-white flex flex-col justify-between flex-grow">
                            {/* Count */}
                            <p className="text-2xl font-bold text-gray-900 leading-none">
                                {stat.count}
                            </p>
                            {/* Label */}
                            <span className="text-xs font-semibold uppercase text-gray-500 mt-1">
                                {stat.label}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
    {sectionData.campaign.show && (
  <div className="mt-4">
    
    {/* Tabs */}
    {tabsByPost[post]?.length > 0 && (
      <div className="mb-3 flex items-center justify-between gap-3 border-b pb-2">
        <div className="flex flex-wrap gap-3">
          {tabsByPost[post].map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleTabClick('campaign',tab.key)}
              className={`px-3 pb-1 text-sm font-medium ${
                sectionData.campaign.activeTab === tab.key
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={downloadCampaignExcel}
          className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
        >
          Download Excel
        </button>
      </div>
    )}

    {/* Loader */}
    {sectionData.campaign.loading ? (
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
        <span>Loading details...</span>
      </div>
    ) : (
      <DataTable
      data={campaignDetailRows}
          columns={
            campaignDetailRows?.length > 0
              ? Object.keys(
                  campaignDetailRows[0]
                ).map((key) => ({
                  name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                  selector: (row) => row[key],
                  sortable: true,
                }))
              : []
          }
        pagination
        highlightOnHover
        dense
      />
    )}
  </div>
)}

</div>
        </section>
          <section className="w-full lg:w-[30%] space-y-4 lg:flex-shrink-0">
<div className="max-w-lg mx-auto">
  {(() => {
    const colorMap = {
      "bg-teal-500": "#14b8a6",
      "bg-emerald-500": "#10b981",
      "bg-green-500": "#22c55e",
      "bg-blue-500": "#3b82f6",
      "bg-primary-blue": "#2563eb",
      "bg-yellow-500": "#f59e0b",
      "bg-amber-500": "#f59e0b",
      "bg-orange-500": "#f97316",
      "bg-red-500": "#ef4444",
      "bg-rose-500": "#f43f5e",
      "bg-purple-500": "#8b5cf6",
      "bg-indigo-500": "#6366f1",
      "bg-gray-500": "#6b7280",
      "bg-secondary": "#64748b",
    };
    const fallbackPalette = ["#0ea5e9", "#f97316", "#22c55e"];
    const normalizeColor = (raw, idx, label) => {
      const labelText = String(label || "").toLowerCase();
      if (labelText.includes("open")) {
        return "#0ea5e9";
      }
      if (!raw) return fallbackPalette[idx % fallbackPalette.length];
      if (raw.startsWith("#")) return raw;
      return colorMap[raw] || fallbackPalette[idx % fallbackPalette.length];
    };
    const stats2 = dashboardData.stats2 || [];
    const pickByLabel = (labels) =>
      stats2.find((item) => labels.includes(String(item.label || "").toLowerCase())) || null;
    const paidItem = pickByLabel(["paid campaign", "paid"]);
    const openItem = pickByLabel(["open campaign", "open"]);
    const pieSource = [paidItem, openItem].filter(Boolean);
    const pieData = pieSource.map((item, idx) => ({
      name: item.label,
      value: Number(item.count || 0),
      color: normalizeColor(item.color, idx, item.label),
    }));
    const total = pieData.reduce((sum, item) => sum + item.value, 0);
    const formatPct = (value) => (total ? ((value / total) * 100).toFixed(1) : "0.0");

    const renderLabel = ({ cx, cy }) => (
      <text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle">
        <tspan x={cx} className="fill-slate-900 text-xl font-extrabold">
          {total}
        </tspan>
        <tspan x={cx} dy="1.2em" className="fill-slate-500 text-xs">
          Total
        </tspan>
      </text>
    );

    return (
      <div className="bg-slate-50/70 rounded-2xl p-4 border border-slate-100 shadow-sm">
        <div className="flex items-center gap-4">
          <div className="h-40 w-40 min-w-[160px]">
            <ResponsiveContainer width={160} height={160} minWidth={160} minHeight={160}>
              <PieChart>
                <Pie
                  data={pieData}
                  dataKey="value"
                  nameKey="name"
                  innerRadius={52}
                  outerRadius={70}
                  paddingAngle={4}
                  stroke="white"
                  strokeWidth={2}
                  labelLine={false}
                  label={renderLabel}
                >
                  {pieData.map((entry, idx) => (
                    <Cell key={`slice-${idx}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex-1 space-y-3">
            {pieData.map((item, idx) => (
              <div key={`${item.name || "campaign"}-${idx}`} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="h-3 w-3 rounded-full" style={{ backgroundColor: item.color }} />
                  <span className="text-sm font-medium text-slate-700">{item.name}</span>
                </div>
                <div className="text-right">
                  <div className="text-sm font-semibold text-slate-800">{item.value}</div>
                  <div className="text-xs text-slate-500">{formatPct(item.value)}%</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  })()}
</div>

    </section>
    </div>
  </div>
</main>


{/* generate report jaisa vala card kabhi use karna ho toh uske liye yaad rakhna */}
{/* <section className="w-full lg:flex-shrink space-y-4 mb-4 mt-4">
  <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100">
    <div className="mb-3">
      <h2 className="text-xl font-bold text-gray-800 mb-2">Requirements (Client Wise)</h2>
      <p className="text-sm text-slate-500 mb-0">Client-wise requirement details with graph view.</p>
    </div>

    {tabsByPost[post]?.length > 0 && (
      <div className="flex gap-3 border-b pb-2 mb-3">
        {tabsByPost[post].map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTabClick2('reqclient', tab.key)}
            className={`px-3 pb-1 text-sm font-medium ${
              tabbedSectionData.reqclient.activeTab === tab.key // Note the section key: 'onboardreq'
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    )}

    {loading ? (
      <div className="w-full text-center py-6 text-sm text-gray-500">
        Loading data...
      </div>
    ) : (
      <DataTable
        data={tabbedSectionData.reqclient.data[tabbedSectionData.reqclient.activeTab] || []} // Note the section key: 'onboardreq'
        columns={
          tabbedSectionData.reqclient.data[tabbedSectionData.reqclient.activeTab]?.length > 0
            ? Object.keys(
                tabbedSectionData.reqclient.data[tabbedSectionData.reqclient.activeTab][0]
              ).map((key) => ({
                name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                selector: (row) => row[key],
                sortable: true,
              }))
            : []
        }
        pagination
        highlightOnHover
        dense
      />
    )}

    <div className="mt-4 pt-4">
      <h3 className="text-lg font-bold text-gray-800 mb-2">Requirements (Graph)</h3>
      <p className="text-sm text-slate-500 mb-3">Visual client-wise requirement breakdown.</p>
      <div className="bg-card-bg p-4 rounded-xl bg-white" style={{ maxHeight: '315px' }}>
        <ClientRequirementChart data={dashboardData.clientRequirements} />
      </div>
    </div>
  </div>
</section>
////////////////////////////////////////////////////////////        */}

 <main className="mt-4 mb-0" style={{paddingBottom: '0px', order: getDashboardCardOrder("lineUp")}}>
      <div className="bg-white rounded-xl shadow-[0_18px_40px_rgba(15,23,42,0.16)] border border-gray-100 p-4">
      <div className="flex flex-col lg:flex-row gap-6">
      <section className="w-full lg:w-[70%] lg:flex-shrink space-y-4">
           <div className="bg-card-bg rounded-xl p-2 bg-white">
              <div className='flex justify-content-between align-items-start mb-2'>
              <h2 className="text-xl font-bold text-gray-800 mb-0">Line up</h2>
                             {(dashboardData.viewShow==='1' && ( <button onClick={() => handleViewClick("lineup")} className={viewDetailsButtonClass}>{sectionData.lineup.show ? "Hide Details" : "View Details"}</button>  ))}  
      </div>
                            <p className="text-sm text-slate-500 mb-3">Lineup progress by stage.</p>
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4">
                                
                    {dashboardData.linestat.map((stat, index) => (
                        (() => {
                          const cardColor = resolveDashboardStatColor(stat.color, index);
                          const lineupGlyph = resolveLineupGlyph(stat.label);
                          return (
                        <div
                            key={index}
                            className="w-full p-3 rounded-2xl text-white relative overflow-hidden min-w-0"
                            style={{
                              border: `1px solid ${cardColor}88`,
                              background: `linear-gradient(155deg, ${cardColor}ff 0%, ${cardColor}eb 52%, ${cardColor}88 100%)`,
                              boxShadow: `0 18px 36px ${cardColor}3a`,
                            }}
                        >
                            <div
                              className="pointer-events-none absolute inset-x-0 top-0 h-20"
                              style={{
                                background: `linear-gradient(180deg, rgba(255,255,255,0.08) 0%, transparent 100%)`,
                              }}
                            />
                            <div
                              className="pointer-events-none absolute inset-0 opacity-100"
                              style={{
                                background: `radial-gradient(circle at top right, rgba(255,255,255,0.08) 0%, transparent 30%), linear-gradient(135deg, rgba(255,255,255,0.05) 0%, transparent 48%)`,
                              }}
                            />
                            <div
                              className="pointer-events-none absolute inset-x-6 top-0 h-[1px]"
                              style={{ background: `linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.95) 50%, transparent 100%)` }}
                            />
                            <span className="relative z-10 text-xs opacity-80 font-medium uppercase text-white">{stat.label}</span>
                            <div className="relative z-10 flex items-center justify-between">
                                <p className="text-xl font-bold mt-1">{stat.count}</p>
                                <div
                                  className="flex h-11 w-11 items-center justify-center rounded-2xl"
                                  style={{
                                    background: `linear-gradient(180deg, rgba(255,255,255,0.12) 0%, rgba(15,23,42,0.14) 100%)`,
                                    border: `1px solid rgba(255,255,255,0.12)`,
                                    boxShadow: `inset 0 1px 0 rgba(255,255,255,0.12), 0 8px 18px rgba(15,23,42,0.24)`,
                                  }}
                                >
                                  <DashboardStatGlyph type={lineupGlyph} className="h-6 w-6 text-white opacity-90" />
                                </div>
                            </div>
                        </div>
                          );
                        })()
                    ))}
                            </div>
        {sectionData.lineup.show && (
  <div className="mt-4">
    
    {/* Tabs */}
    {tabsByPost[post]?.length > 0 && (
      <div className="mb-3 flex items-center justify-between gap-3 border-b pb-2">
        <div className="flex flex-wrap gap-3">
          {tabsByPost[post].map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleTabClick('lineup',tab.key)}
              className={`px-3 pb-1 text-sm font-medium ${
                sectionData.lineup.activeTab === tab.key
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={downloadLineupExcel}
          className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
        >
          Download Excel
        </button>
      </div>
    )}

    {/* Loader */}
    {sectionData.lineup.loading ? (
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
        <span>Loading details...</span>
      </div>
    ) : (
      <DataTable
      data={lineupDetailRows}
          columns={
            lineupDetailRows?.length > 0
              ? Object.keys(
                  lineupDetailRows[0]
                ).map((key) => ({
                  name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                  selector: (row) => row[key],
                  sortable: true,
                }))
              : []
          }
        pagination
        highlightOnHover
        dense
      />
    )}
  </div>
)}

                        </div>
            </section>

        <section className="w-full lg:w-[30%] space-y-4 lg:flex-shrink-0">
           <div className="rounded-2xl border border-gray-200 bg-slate-50 px-4 pt-0 pb-0 shadow-[0_10px_24px_rgba(15,23,42,0.08)]">
    <ClientLeadPieChart 
        data={dashboardData.linestat} 
        title="Line Up (Graph)" 
    />
            </div>

        </section>
        </div>

{String(post).toLowerCase() !== "sourcing_head" && (
<div className="mt-0 pt-0 px-2">
    <button
      type="button"
      onClick={() => setShowLineupRequirementWise((prev) => !prev)}
      className="mb-3 flex w-full max-w-[760px] items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3 text-left shadow-[0_10px_24px_rgba(15,23,42,0.06)]"
    >
      <div>
        <h3 className="text-lg font-bold text-gray-800 mb-1">Requirement Wise</h3>
        <p className="text-sm text-slate-500 mb-0">Requirement-level lineup performance breakdown.</p>
      </div>
      <span className={`inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-600 transition-transform duration-200 ${showLineupRequirementWise ? "rotate-90" : ""}`}>
        <i className="ri-arrow-right-s-line text-xl"></i>
      </span>
    </button>
    {showLineupRequirementWise && (
      <div className="rounded-2xl border border-slate-200 bg-[linear-gradient(180deg,#ffffff_0%,#f8fafc_100%)] p-3 shadow-[0_10px_24px_rgba(15,23,42,0.06)]">
        {tabsByPost[post]?.length > 0 && (
          <div className="mb-3 flex items-center justify-between gap-3 border-b border-slate-200 pb-2">
            <div className="flex flex-wrap gap-3">
              {tabsByPost[post].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => handleTabClick2('lineup', tab.key)}
                  className={`px-3 pb-1 text-sm font-medium ${
                    tabbedSectionData.lineup.activeTab === tab.key
                      ? "border-b-2 border-blue-600 text-blue-600"
                      : "text-gray-500"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <button
              type="button"
              onClick={downloadLineupRequirementWiseExcel}
              className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
            >
              Download Excel
            </button>
          </div>
        )}

        {loading ? (
          <div className="w-full text-center py-6 text-sm text-gray-500">
            Loading data...
          </div>
        ) : (
          <div className="overflow-hidden rounded-xl border border-slate-100 bg-white">
            <DataTable
              data={lineupRequirementRows}
              columns={
                lineupRequirementRows?.length > 0
                  ? Object.keys(
                      lineupRequirementRows[0]
                    ).map((key) => ({
                      name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                      selector: (row) => row[key],
                      sortable: true,
                    }))
                  : []
              }
              pagination
              highlightOnHover
              dense
            />
          </div>
        )}
      </div>
    )}
     </div>
)}
      </div>
</main>

 <main className="mt-4 mb-4 space-y-4" style={{paddingBottom: '0px', order: getDashboardCardOrder("onboarding")}}>

        <section className="w-full space-y-4">
           <div className="bg-white rounded-xl shadow-[0_18px_40px_rgba(15,23,42,0.16)] border border-gray-100 p-2">
             <div className="flex flex-col lg:flex-row gap-6">
               <div className="w-full lg:w-[70%]">
                 <div className="bg-card-bg rounded-xl p-3 bg-white">
                     <div className='flex justify-content-between align-items-start mb-2'>
              <h2 className="text-xl font-bold text-gray-800 mb-0">Onboarding</h2>
                             {(dashboardData.viewShow==='1' && ( <button onClick={() => handleViewClick("onboard")} className={viewDetailsButtonClass}>{sectionData.onboard.show ? "Hide Details" : "View Details"}</button>  ))}  
      </div>
                            <p className="text-sm text-slate-500 mb-3">Onboarding status overview.</p>
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4">
                                
                    {dashboardData.onboard.map((stat, index) => (
                        (() => {
                          const cardColor = resolveDashboardStatColor(stat.color, index);
                          const onboardingGlyph = resolveOnboardingGlyph(stat.label);
                          return (
                        <div
                            key={index}
                            className="w-full p-3 rounded-2xl text-white relative overflow-hidden min-w-0"
                            style={{
                              border: `1px solid ${cardColor}88`,
                              background: `linear-gradient(155deg, ${cardColor}ff 0%, ${cardColor}eb 52%, ${cardColor}88 100%)`,
                              boxShadow: `0 18px 36px ${cardColor}3a`,
                            }}
                        >
                            <div
                              className="pointer-events-none absolute inset-x-0 top-0 h-20"
                              style={{
                                background: `linear-gradient(180deg, rgba(255,255,255,0.08) 0%, transparent 100%)`,
                              }}
                            />
                            <div
                              className="pointer-events-none absolute inset-0 opacity-100"
                              style={{
                                background: `radial-gradient(circle at top right, rgba(255,255,255,0.08) 0%, transparent 30%), linear-gradient(135deg, rgba(255,255,255,0.05) 0%, transparent 48%)`,
                              }}
                            />
                            <div
                              className="pointer-events-none absolute inset-x-6 top-0 h-[1px]"
                              style={{ background: `linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.95) 50%, transparent 100%)` }}
                            />
                            <span className="relative z-10 text-xs opacity-80 font-medium uppercase text-white">{stat.label}</span>
                            <div className="relative z-10 flex items-center justify-between">
                                <p className="text-xl font-bold mt-1">{stat.count}</p>
                                <div
                                  className="flex h-11 w-11 items-center justify-center rounded-2xl"
                                  style={{
                                    background: `linear-gradient(180deg, rgba(255,255,255,0.12) 0%, rgba(15,23,42,0.14) 100%)`,
                                    border: `1px solid rgba(255,255,255,0.12)`,
                                    boxShadow: `inset 0 1px 0 rgba(255,255,255,0.12), 0 8px 18px rgba(15,23,42,0.24)`,
                                  }}
                                >
                                  <DashboardStatGlyph type={onboardingGlyph} className="h-6 w-6 text-white opacity-90" />
                                </div>
                            </div>
                        </div>
                          );
                        })()
                    ))}
                            </div>
            {sectionData.onboard.show && (
  <div className="mt-4">
    
    {/* Tabs */}
    {tabsByPost[post]?.length > 0 && (
      <div className="mb-3 flex items-center justify-between gap-3 border-b pb-2">
        <div className="flex flex-wrap gap-3">
          {tabsByPost[post].map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleTabClick('onboard',tab.key)}
              className={`px-3 pb-1 text-sm font-medium ${
                sectionData.onboard.activeTab === tab.key
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={downloadOnboardingExcel}
          className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
        >
          Download Excel
        </button>
      </div>
    )}

    {/* Loader */}
    {sectionData.onboard.loading ? (
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
        <span>Loading details...</span>
      </div>
    ) : (
      <DataTable
      data={onboardDetailRows}
          columns={
            onboardDetailRows?.length > 0
              ? Object.keys(
                  onboardDetailRows[0]
                ).map((key) => ({
                  name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                  selector: (row) => row[key],
                  sortable: true,
                }))
              : []
          }
        pagination
        highlightOnHover
        dense
      />
    )}
  </div>
)}
                 </div>
               </div>

               <div className="w-full lg:w-[30%] lg:flex-shrink-0">
                  <div className="rounded-2xl border border-gray-200 bg-slate-50 px-4 pt-0 pb-0 shadow-[0_10px_24px_rgba(15,23,42,0.08)]">
                  {dashboardData.viewShow === '1' ? (
                       <StackedAreaLeadChart   data={chartData}  title="Onboarding" />
                  ) : (
                       <ClientLeadAreaChart data={dashboardData.onboard} xKey="label" yKey="count" title="Onboarding ( Graph )" />
                   )}
                  </div>
               </div>
             </div>

              {String(post).toLowerCase() !== "sourcing_head" && (
              <div className="mt-0 pt-0 px-2 ml-2">
                <button
                  type="button"
                  onClick={() => setShowOnboardingRequirementWise((prev) => !prev)}
                  className="mb-3 flex w-full max-w-[760px] items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3 text-left shadow-[0_10px_24px_rgba(15,23,42,0.06)]"
                >
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 mb-1">Requirement Wise</h3>
                    <p className="text-sm text-slate-500 mb-0">Requirement-level onboarding performance breakdown.</p>
                  </div>
                  <span className={`inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-600 transition-transform duration-200 ${showOnboardingRequirementWise ? "rotate-90" : ""}`}>
                    <i className="ri-arrow-right-s-line text-xl"></i>
                  </span>
                </button>
                {showOnboardingRequirementWise && (
                  <div className="rounded-2xl border border-slate-200 bg-[linear-gradient(180deg,#ffffff_0%,#f8fafc_100%)] p-3 shadow-[0_10px_24px_rgba(15,23,42,0.06)]">
                    {dashboardData.viewShow === '1' ? (
                    <>
                      {tabsByPost[post]?.length > 0 && (
                        <div className="mb-3 flex items-center justify-between gap-3 border-b border-slate-200 pb-2">
                          <div className="flex flex-wrap gap-3">
                            {tabsByPost[post].map((tab) => (
                              <button
                                key={tab.key}
                                onClick={() => handleTabClick2('onboardreq', tab.key)}
                                className={`px-3 pb-1 text-sm font-medium ${
                                  tabbedSectionData.onboardreq.activeTab === tab.key
                                    ? "border-b-2 border-blue-600 text-blue-600"
                                    : "text-gray-500"
                                }`}
                              >
                                {tab.label}
                              </button>
                            ))}
                          </div>
                          <button
                            type="button"
                            onClick={downloadOnboardingRequirementWiseExcel}
                            className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
                          >
                            Download Excel
                          </button>
                        </div>
                      )}

                      {loading ? (
                        <div className="w-full text-center py-6 text-sm text-gray-500">
                          Loading data...
                        </div>
                      ) : (
                          <div className="overflow-hidden rounded-xl border border-slate-100 bg-white">
                          <DataTable
                            data={onboardRequirementRows}
                            columns={
                              onboardRequirementRows?.length > 0
                                ? Object.keys(
                                    onboardRequirementRows[0]
                                  ).map((key) => ({
                                    name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                                    selector: (row) => row[key],
                                    sortable: true,
                                  }))
                                : []
                            }
                            pagination
                            highlightOnHover
                            dense
                          />
                        </div>
                      )}
                    </>

                  ) : (
                    <div className="overflow-hidden rounded-xl border border-slate-100 bg-white">
                      <DataTable
                        columns={columns3}
                        data={dashboardData.onboardreq} 
                        progressPending={loadings}
                        pagination
                        paginationPerPage={50}
                        paginationRowsPerPageOptions={[50, 100, 200, 300]}
                        fixedHeader
                        striped
                      />
                    </div>
                  )}
                  </div>
                )}
              </div>
              )}
           </div>

         <div className="bg-card-bg rounded-xl shadow-[0_18px_40px_rgba(15,23,42,0.16)] border border-gray-100 p-3 bg-white mt-4">
      
         <div className='flex justify-content-between align-items-start mb-2'>
             <h2 className="text-xl font-bold text-gray-800 mb-0">Vendor Onboarding</h2>
             {(dashboardData.viewShow==='1' && ( <button onClick={() => handleViewClick("vendor")} className={viewDetailsButtonClass}>{sectionData.vendor.show ? "Hide Details" : "View Details"}</button>  ))}  
      </div>

        <p className="text-sm text-slate-500 mb-3">Vendor onboarding status summary.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">         
            {dashboardData.vendor.map((stat, index) => (
                (() => {
                  const cardColor = resolveDashboardStatColor(stat.color, index);
                  const vendorGlyph = resolveVendorGlyph(stat.label);
                  return (
                <div
                    className="w-full p-3 rounded-2xl text-white relative overflow-hidden min-w-0"
                    key={index}
                    style={{
                      border: `1px solid ${cardColor}88`,
                      background: `linear-gradient(155deg, ${cardColor}ff 0%, ${cardColor}eb 52%, ${cardColor}88 100%)`,
                      boxShadow: `0 18px 36px ${cardColor}3a`,
                    }}
                >
                    <div
                      className="pointer-events-none absolute inset-x-0 top-0 h-20"
                      style={{
                        background: `linear-gradient(180deg, rgba(255,255,255,0.08) 0%, transparent 100%)`,
                      }}
                    />
                    <div
                      className="pointer-events-none absolute inset-0 opacity-100"
                      style={{
                        background: `radial-gradient(circle at top right, rgba(255,255,255,0.08) 0%, transparent 30%), linear-gradient(135deg, rgba(255,255,255,0.05) 0%, transparent 48%)`,
                      }}
                    />
                    <div
                      className="pointer-events-none absolute inset-x-6 top-0 h-[1px]"
                      style={{ background: `linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.95) 50%, transparent 100%)` }}
                    />
                    <span className="relative z-10 text-xs opacity-80 font-medium uppercase text-white">{stat.label}</span>
                    <div className="relative z-10 flex items-center justify-between">
                      <p className="text-2xl font-bold mt-1 text-white">{stat.count}</p>
                      <div
                        className="flex h-11 w-11 items-center justify-center rounded-2xl"
                        style={{
                          background: `linear-gradient(180deg, rgba(255,255,255,0.12) 0%, rgba(15,23,42,0.14) 100%)`,
                          border: `1px solid rgba(255,255,255,0.12)`,
                          boxShadow: `inset 0 1px 0 rgba(255,255,255,0.12), 0 8px 18px rgba(15,23,42,0.24)`,
                        }}
                      >
                        <DashboardStatGlyph type={vendorGlyph} className="h-6 w-6 text-white opacity-90" />
                      </div>
                    </div>
                </div>
                  );
                })()
              ))}
        </div>
        
{sectionData.vendor.show && (
  <div className="mt-4">
    
    {/* Tabs */}
    {tabsByPost[post]?.length > 0 && (
      <div className="mb-3 flex items-center justify-between gap-3 border-b pb-2">
        <div className="flex flex-wrap gap-3">
          {tabsByPost[post].map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleTabClick('vendor',tab.key)}
              className={`px-3 pb-1 text-sm font-medium ${
                sectionData.vendor.activeTab === tab.key
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={downloadVendorOnboardingExcel}
          className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
        >
          Download Excel
        </button>
      </div>
    )}

    {/* Loader */}
    {sectionData.vendor.loading ? (
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
        <span>Loading details...</span>
      </div>
    ) : (
      <DataTable
      data={sectionData.vendor.data[sectionData.vendor.activeTab] || []}
          columns={
            sectionData.vendor.data[sectionData.vendor.activeTab]?.length > 0
              ? Object.keys(
                  sectionData.vendor.data[sectionData.vendor.activeTab][0]
                ).map((key) => ({
                  name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                  selector: (row) => row[key],
                  sortable: true,
                }))
              : []
          }
        pagination
        highlightOnHover
        dense
      />
    )}
  </div>
)}
         </div>

    </section>
</main>

<div className="space-y-3">
{headingData.viewShow===0 && (
  <div className="bg-card-bg rounded-xl shadow-[0_18px_40px_rgba(15,23,42,0.16)] border border-gray-100 p-3 bg-white mb-3">
<div className="d-flex align-items-center justify-content-between mb-2 mt-2 ml-2">
  <h2 className="text-xl font-bold text-gray-800 mb-0">Candidates Register</h2>
  {dashboardData.viewShow === '1' && (
    <button
      onClick={() => handleViewClick("stats")}
      className={viewDetailsButtonClass}
    >
      {sectionData.stats.show ? "Hide Details" : "View Details"}
    </button>
  )}
</div>
<p className="text-sm text-slate-500 mb-3 ml-2">
  Overview of candidates who registered via portal (from the Candidate tab).
</p>

<div className="mb-3 ml-2 grid grid-cols-1 md:grid-cols-3 gap-3">
  <div className="contents">
    {dashboardData.stats.map((stat, index) => {
      const label = String(stat.label || "").toLowerCase();
      const solidStyles =
        label === "today"
          ? {
              accent: "#3157d7",
              soft: "#eff6ff",
            }
          : label === "week"
          ? {
              accent: "#d99211",
              soft: "#fff7ed",
            }
          : label === "month"
          ? {
              accent: "#dc4c4c",
              soft: "#fef2f2",
            }
          : {
              accent: "#64748b",
              soft: "#f8fafc",
            };
      return (
        <div
          key={`candidate-register-stat-${index}`}
          className="relative min-w-0 overflow-hidden rounded-xl border border-slate-200 bg-white px-3 py-3 shadow-[0_4px_14px_rgba(15,23,42,0.05)]"
          style={{
            background: `linear-gradient(180deg, ${solidStyles.soft} 0%, #ffffff 100%)`,
          }}
        >
          <div
            className="absolute right-3 top-3 text-slate-300"
            style={{ letterSpacing: "2px" }}
          />
          <div className="relative z-10 flex items-center gap-3">
            <div
              className="flex h-10 w-10 items-center justify-center rounded-full flex-shrink-0"
              style={{ background: solidStyles.accent }}
            >
              <i className={`${stat.icon} text-lg text-white`}></i>
            </div>
            <div className="min-w-0 flex-1 text-right">
              <p className="text-[10px] uppercase tracking-[0.12em] text-slate-400">{label === "today" ? "Current Window" : label === "week" ? "This Week" : label === "month" ? "This Month" : "Timeline"}</p>
              <p className="mt-0.5 text-lg font-bold leading-none text-slate-900">{String(stat.label || "").charAt(0).toUpperCase() + String(stat.label || "").slice(1)}</p>
              <p className="mt-1 text-2xl font-extrabold leading-none" style={{ color: solidStyles.accent }}>{stat.count}</p>
              <p className="mt-1 text-[11px] text-slate-500">Registered candidates</p>
            </div>
          </div>
        </div>
      );
    })}
  </div>
</div>

{sectionData.stats.show && (
  <div className="mt-4">
    {tabsByPost[post]?.length > 0 && (
      <div className="mb-3 flex items-center justify-between gap-3 border-b pb-2">
        <div className="flex flex-wrap gap-3">
          {tabsByPost[post].map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleTabClick('stats',tab.key)}
              className={`px-3 pb-1 text-sm font-medium ${
                sectionData.stats.activeTab === tab.key
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={downloadCandidateRegisterExcel}
          className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
        >
          Download Excel
        </button>
      </div>
    )}

    {sectionData.stats.loading ? (
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
        <span>Loading details...</span>
      </div>
    ) : (
      <DataTable
        data={sectionData.stats.data[sectionData.stats.activeTab] || []}
        columns={
          sectionData.stats.data[sectionData.stats.activeTab]?.length > 0
            ? Object.keys(
                sectionData.stats.data[sectionData.stats.activeTab][0]
              ).map((key) => ({
                name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                selector: (row) => row[key],
                sortable: true,
              }))
            : []
        }
        pagination
        highlightOnHover
        dense
      />
    )}
  </div>
)}
<div className="rounded-lg border border-gray-200 bg-white p-3 mb-3 shadow-[0_10px_24px_rgba(15,23,42,0.08)]">
  <div className="flex items-center justify-between mb-4">
    <div className="relative grid grid-cols-3 rounded-full border border-slate-300 bg-gradient-to-r from-slate-100 via-slate-50 to-slate-100 p-1 text-sm shadow-[inset_0_1px_2px_rgba(15,23,42,0.12)] min-w-[420px]">
      <span
        className="absolute top-1 bottom-1 left-1 w-[calc((100%-0.5rem)/3)] rounded-full bg-white shadow-[0_6px_16px_rgba(15,23,42,0.12)] ring-1 ring-blue-100 transition-transform duration-300 ease-out"
        style={{
          transform:
            insightTab === "profile"
              ? "translateX(0%)"
              : insightTab === "experience"
              ? "translateX(100%)"
              : "translateX(200%)",
        }}
      />
      {[
        { key: "profile", label: "Profile Wise" },
        { key: "experience", label: "Experience Wise" },
        { key: "location", label: "Location Wise" },
      ].map((tab) => (
        <button
          key={tab.key}
          onClick={() => setInsightTab(tab.key)}
          className={`relative z-10 w-full px-4 py-2 rounded-full font-semibold transition-colors duration-200 text-center ${
            insightTab === tab.key
              ? "text-blue-700"
              : "text-slate-600 hover:text-slate-800"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  </div>

  {insightTab === "profile" && (
    <div>
      <div className='flex justify-content-between align-items-start mb-2'>
        <h2 className="text-xl font-bold text-gray-800 mb-0 ml-4">Profile</h2>
        {(dashboardData.viewShow==='1' && (
          <button onClick={() => handleViewClick("profile")} className={viewDetailsButtonClass}>
            {sectionData.profile.show ? "Hide Details" : "View Details"}
          </button>
        ))}
      </div>

      <p className="text-sm text-slate-500 mb-3 ml-4">Candidate distribution by profile.</p>
      <div className="grid gap-4" style={{
        gridAutoFlow: 'column',
        gridAutoColumns: 'minmax(150px, 1fr)',
        overflowX: 'auto',  paddingLeft:'10px',paddingBottom:'14px'
      }}>
        {dashboardData.profile.map((profileItem, index) => {
          const { borderColor } = profileColorMap(index);
          const softBgPalette = [
            "bg-gradient-to-br from-white via-slate-50 to-blue-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-emerald-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-amber-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-rose-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-indigo-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-teal-100/70",
          ];
          const bgTone = softBgPalette[index % softBgPalette.length];
          return (
            <div
              key={profileItem.pname}
              className={`profile-card min-w-[180px] h-[92px] p-3 ${bgTone} rounded-xl border ${borderColor} shadow-[0_4px_14px_rgba(15,23,42,0.08)] transition duration-200 hover:shadow-[0_8px_22px_rgba(15,23,42,0.12)] hover:-translate-y-0.5 flex flex-col justify-between`}
            >
              <span className="text-[11px] tracking-wide text-slate-500 font-semibold uppercase line-clamp-2">
                {profileItem.pname}
              </span>
              <p className="text-2xl font-extrabold text-slate-900 leading-none">{profileItem.count}</p>
            </div>
          );
        })}

        {dashboardData.profile.length === 0 && (
          <div className="text-gray-500 col-span-full">No profile data available.</div>
        )}
      </div>

      {sectionData.profile.show && (
        <div className="mt-4">
          {tabsByPost[post]?.length > 0 && (
            <div className="mb-3 flex items-center justify-between gap-3 border-b pb-2">
              <div className="flex flex-wrap gap-3">
                {tabsByPost[post].map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => handleTabClick('profile',tab.key)}
                    className={`px-3 pb-1 text-sm font-medium ${
                      sectionData.profile.activeTab === tab.key
                        ? "border-b-2 border-blue-600 text-blue-600"
                        : "text-gray-500"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
              <button
                type="button"
                onClick={downloadCandidateProfileExcel}
                className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
              >
                Download Excel
              </button>
            </div>
          )}

          {sectionData.profile.loading ? (
            <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
              <span>Loading details...</span>
            </div>
          ) : (
            <DataTable
              data={sectionData.profile.data[sectionData.profile.activeTab] || []}
              columns={
                sectionData.profile.data[sectionData.profile.activeTab]?.length > 0
                  ? Object.keys(
                      sectionData.profile.data[sectionData.profile.activeTab][0]
                    ).map((key) => ({
                      name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                      selector: (row) => row[key],
                      sortable: true,
                    }))
                  : []
              }
              pagination
              highlightOnHover
              dense
            />
          )}
        </div>
      )}
    </div>
  )}

  {insightTab === "experience" && (
    <div>
      <div className='flex justify-content-between align-items-start mb-2'>
        <h2 className="text-xl font-bold text-gray-800 mb-0 ml-4">Experience</h2>
        {(dashboardData.viewShow==='1' && (
          <button onClick={() => handleViewClick("experience")} className={viewDetailsButtonClass}>
            {sectionData.experience.show ? "Hide Details" : "View Details"}
          </button>
        ))}
      </div>

      <p className="text-sm text-slate-500 mb-3 ml-4">Candidate distribution by experience.</p>
      <div className="grid gap-4" style={{gridAutoFlow: 'column',gridAutoColumns: 'minmax(150px, 1fr)',overflowX: 'auto', paddingLeft:'10px',paddingBottom:'14px'}}> 
        {dashboardData.expe.map((expItem, index) => {
          const borderColor = getRandomBorderColor();
          const softBgPalette = [
            "bg-gradient-to-br from-white via-slate-50 to-blue-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-emerald-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-amber-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-rose-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-indigo-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-teal-100/70",
          ];
          const bgTone = softBgPalette[index % softBgPalette.length];
          return (
            <div
              key={expItem.ename}
              className={`profile-card min-w-[180px] h-[92px] p-3 ${bgTone} rounded-xl border ${borderColor} shadow-[0_4px_14px_rgba(15,23,42,0.08)] transition duration-200 hover:shadow-[0_8px_22px_rgba(15,23,42,0.12)] hover:-translate-y-0.5 flex flex-col justify-between`}
            >
              <span className="text-[11px] tracking-wide text-slate-500 font-semibold uppercase line-clamp-2">
                {expItem.ename.trim() || 'N/A'}
              </span>
              <p className="text-2xl font-extrabold text-slate-900 leading-none">{expItem.count}</p>
            </div>
          );
        })}
        {dashboardData.expe.length === 0 && (
          <div className="text-gray-500">No experience data available.</div>
        )}
      </div>

      {sectionData.experience.show  && (
        <div className="mt-4">
          {tabsByPost[post]?.length > 0 && (
            <div className="mb-3 flex items-center justify-between gap-3 border-b pb-2">
              <div className="flex flex-wrap gap-3">
                {tabsByPost[post].map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => handleTabClick('experience',tab.key)}
                    className={`px-3 pb-1 text-sm font-medium ${
                      sectionData.experience.activeTab === tab.key
                        ? "border-b-2 border-blue-600 text-blue-600"
                        : "text-gray-500"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
              <button
                type="button"
                onClick={downloadCandidateExperienceExcel}
                className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
              >
                Download Excel
              </button>
            </div>
          )}

          {sectionData.experience.loading ? (
            <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
              <span>Loading details...</span>
            </div>
          ) : (
            <DataTable
              data={sectionData.experience.data[sectionData.experience.activeTab] || []}
              columns={
                sectionData.experience.data[sectionData.experience.activeTab]?.length > 0
                  ? Object.keys(
                      sectionData.experience.data[sectionData.experience.activeTab][0]
                    ).map((key) => ({
                      name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                      selector: (row) => row[key],
                      sortable: true,
                    }))
                  : []
              }
              pagination
              highlightOnHover
              dense
            />
          )}
        </div>
      )}
    </div>
  )}

  {insightTab === "location" && (
    <div>
      <div className='flex justify-content-between align-items-start mb-2'>
        <h2 className="text-xl font-bold text-gray-800 mb-0 ml-4">Location</h2>
        {(dashboardData.viewShow==='1' && (
          <button onClick={() => handleViewClick("location")} className={viewDetailsButtonClass}>
            {sectionData.location.show ? "Hide Details" : "View Details"}
          </button>
        ))}
      </div>

      <p className="text-sm text-slate-500 mb-3 ml-4">Candidate distribution by location.</p>
      <div className="grid gap-4" style={{
        gridAutoFlow: 'column',
        gridAutoColumns: 'minmax(150px, 1fr)',
        overflowX: 'auto',
        paddingLeft: '10px',
        paddingRight: '16px',
        paddingBottom: '14px',
        scrollPaddingRight: '16px'
      }}>  
        {dashboardData.location.map((locationItem, index) => {
          const iconClass = locationIconMap(locationItem.lname);
          const accentColor = getRandomTextColor();
          const bgColor = getRandomBgColor();
          const borderColor = getRandomBorderColor();
          const softBgPalette = [
            "bg-gradient-to-br from-white via-slate-50 to-blue-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-emerald-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-amber-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-rose-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-indigo-100/70",
            "bg-gradient-to-br from-white via-slate-50 to-teal-100/70",
          ];
          const bgTone = softBgPalette[index % softBgPalette.length];
          return (
            <div
              key={locationItem.lname}
              className={`profile-card min-w-[180px] h-[92px] p-3 ${bgTone} rounded-xl border ${borderColor} shadow-[0_4px_14px_rgba(15,23,42,0.08)] transition duration-200 hover:shadow-[0_8px_22px_rgba(15,23,42,0.12)] hover:-translate-y-0.5 flex items-center gap-3`}
            >
              <div
                className={`flex items-center justify-center ${bgColor}/70 rounded-full border ${borderColor}`}
                style={{ width: '2.5rem', height: '2.5rem' }}
              >
                <i className={`${iconClass} ${accentColor} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <p className="text-2xl font-extrabold text-slate-900 leading-none">{locationItem.count}</p>
                <p className="text-[11px] tracking-wide text-slate-500 font-semibold uppercase truncate">{locationItem.lname}</p>
              </div>
            </div>
          );
        })}
        {dashboardData.location.length === 0 && (
          <div className="text-gray-500">No location data available.</div>
        )}
        <div aria-hidden="true" className="min-w-[24px] h-[1px]" />
      </div>

      {sectionData.location.show && (
        <div className="mt-4">
          {tabsByPost[post]?.length > 0 && (
            <div className="mb-3 flex items-center justify-between gap-3 border-b pb-2">
              <div className="flex flex-wrap gap-3">
                {tabsByPost[post].map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => handleTabClick('location',tab.key)}
                    className={`px-3 pb-1 text-sm font-medium ${
                      sectionData.location.activeTab === tab.key
                        ? "border-b-2 border-blue-600 text-blue-600"
                        : "text-gray-500"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
              <button
                type="button"
                onClick={downloadCandidateLocationExcel}
                className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
              >
                Download Excel
              </button>
            </div>
          )}

          {sectionData.location.loading ? (
            <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
              <span>Loading details...</span>
            </div>
          ) : (
            <DataTable
              data={sectionData.location.data[sectionData.location.activeTab] || []}
              columns={
                sectionData.location.data[sectionData.location.activeTab]?.length > 0
                  ? Object.keys(
                      sectionData.location.data[sectionData.location.activeTab][0]
                    ).map((key) => ({
                      name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                      selector: (row) => row[key],
                      sortable: true,
                    }))
                  : []
              }
              pagination
              highlightOnHover
              dense
            />
          )}
        </div>
      )}
    </div>
  )}
</div>
  </div>
)}

{shouldShowAdvancePaymentDashboardCard && renderAdvancePaymentDashboardCard()}
{shouldShowTatSummaryCard && (
  <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-[0_14px_30px_rgba(15,23,42,0.08)]">
    <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between mb-3">
      <div>
        <h2 className="text-xl font-bold text-gray-800 mb-0">TAT Summary</h2>
        <p className="text-sm text-slate-500 mb-0">
          Candidate pipeline turnaround time across lineup, selection, joining, onboarding and payroll.
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">
          Total Candidates: {normalizedTatSummary.totalCandidates}
        </span>
        <span className="inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
          Overall Avg: {normalizedTatSummary.overallAvgDays.toFixed(1)} days
        </span>
        <button
          type="button"
          onClick={() => setShowTatDetails((prev) => !prev)}
          className={viewDetailsButtonClass}
        >
          {showTatDetails ? "Hide Details" : "View Details"}
        </button>
      </div>
    </div>

    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-5">
      {tatStagesForCard.map((stage, index) => {
        const theme = getAdvancePaymentTatTheme(index);
        return (
          <div
            key={`tat-stage-${stage.key}`}
            className="relative min-w-0 overflow-hidden rounded-xl border border-slate-200 bg-white px-3 py-3 shadow-[0_4px_14px_rgba(15,23,42,0.05)]"
            style={{
              background: `linear-gradient(180deg, ${theme.soft} 0%, #ffffff 100%)`,
              borderColor: `${theme.accent}26`,
            }}
          >
            <div className="relative z-10 flex items-center gap-3">
              <div
                className="flex h-10 w-10 items-center justify-center rounded-full flex-shrink-0"
                style={{ background: theme.accent }}
              >
                <i className={`${stage.icon} text-lg text-white`} />
              </div>
              <div className="min-w-0 flex-1 text-right">
                <p className="text-[10px] uppercase tracking-[0.12em] text-slate-400">Turnaround</p>
                <p className="mt-0.5 text-base font-bold leading-none text-slate-900">{stage.label}</p>
                <p className="mt-1 text-xl font-bold leading-none" style={{ color: theme.accent }}>
                  {Number(stage.avgDays || 0).toFixed(1)} days
                </p>
                <p className="mt-1 text-[11px] text-slate-500">{Number(stage.count || 0)} candidates</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>

    <div className="my-4 border-t border-slate-200" />

    <div className="mb-2 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
      <div>
        <h3 className="text-lg font-bold text-gray-800 mb-0">Campaign Approval TAT</h3>
        <p className="text-xs text-slate-500 mb-0">
          Approval ladder TAT across Recruiter, SM, SH and DST Team.
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">
          Requests: {normalizedCampaignTat.totalRequests}
        </span>
        <span className="inline-flex items-center rounded-full bg-red-50 px-3 py-1 text-xs font-semibold text-red-700">
          Exceeded &gt;{normalizedCampaignTat.thresholdHours} hours: {normalizedCampaignTat.exceededCount}
        </span>
      </div>
    </div>

    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {campaignTatStagesForCard.map((stage, index) => {
        const theme = getAdvancePaymentTatTheme(index);
        return (
          <div
            key={`campaign-tat-stage-${stage.key}`}
            className="relative min-w-0 overflow-hidden rounded-xl border border-slate-200 bg-white px-3 py-3 shadow-[0_4px_14px_rgba(15,23,42,0.05)]"
            style={{
              background: `linear-gradient(180deg, ${theme.soft} 0%, #ffffff 100%)`,
              borderColor: `${theme.accent}26`,
            }}
          >
            <div className="relative z-10 flex items-center gap-3">
              <div
                className="flex h-10 w-10 items-center justify-center rounded-full flex-shrink-0"
                style={{ background: theme.accent }}
              >
                <i className={`${stage.icon} text-lg text-white`} />
              </div>
              <div className="min-w-0 flex-1 text-right">
                <p className="text-[10px] uppercase tracking-[0.12em] text-slate-400">Approval TAT</p>
                <p className="mt-0.5 text-base font-bold leading-none text-slate-900">{stage.label}</p>
                <p className="mt-1 text-xl font-bold leading-none" style={{ color: theme.accent }}>
                  {Number(stage.avgHours || 0).toFixed(2)} hours
                </p>
                <p className={`mt-1 text-[11px] ${Number(stage.exceeded || 0) > 0 ? "text-red-600" : "text-slate-500"}`}>
                  {Number(stage.exceeded || 0) > 0 ? `Exceeded: ${Number(stage.exceeded || 0)}` : `${Number(stage.samples || 0)} samples`}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>

    {normalizedCampaignTat.exceededRequests.length > 0 && (
      <div className="mt-3 rounded-lg border border-red-100 bg-red-50/60 p-3">
        <p className="text-xs font-semibold text-red-700 mb-2">
          Highlighted Requests (exceeding {normalizedCampaignTat.thresholdHours} hours)
        </p>
        <div className="space-y-1.5">
          {normalizedCampaignTat.exceededRequests.slice(0, 6).map((item, idx) => (
            <div key={`tat-exceeded-${item.requestId}-${idx}`} className="flex flex-wrap items-center justify-between gap-2 text-xs">
              <span className="font-semibold text-slate-700">
                {item.campaignId || `Req #${item.requestId}`} - {item.pendingStage}
              </span>
              <span className="font-bold text-red-700">{Number(item.pendingHours || 0).toFixed(1)} hours</span>
            </div>
          ))}
        </div>
      </div>
    )}

    {showTatDetails && (
      <div className="mt-4 rounded-xl border border-slate-200 bg-white p-2">
        <DataTable
          columns={campaignTatDetailColumns}
          data={normalizedCampaignTat.requestRows}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 25, 50, 100]}
          highlightOnHover
          dense
          striped
          noDataComponent={<div className="py-3 text-sm text-slate-500">No campaign approval requests found for selected filters.</div>}
        />
      </div>
    )}
  </div>
)}

{/* <section className="w-full lg:flex-shrink space-y-4 mb-3">
  <div className="bg-white rounded-xl border border-gray-100 p-4 pb-1 shadow-[0_18px_40px_rgba(15,23,42,0.16)]">
  <h2 className="text-xl font-bold text-gray-800 mb-2">Lead Data (Client Wise)</h2>
  <p className="text-sm text-slate-500 mb-3">Lead distribution by client across roles.</p>
   
    {tabsByPost[post]?.length > 0 && (
      <div className="mb-3 flex items-center justify-between gap-3 border-b pb-2">
        <div className="flex flex-wrap gap-3">
          {tabsByPost[post].map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleTabClick2('clientlead', tab.key)}
              className={`px-3 pb-1 text-sm font-medium ${
                tabbedSectionData.clientlead.activeTab === tab.key
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={downloadLeadDataExcel}
          className="inline-flex shrink-0 items-center rounded-md bg-green-600 px-3 py-2 text-sm font-medium text-white shadow-sm transition duration-150 hover:bg-green-700"
        >
          Download Excel
        </button>
      </div>
    )}

    {sectionData.require.loading ? (
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-sm text-gray-500">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600"></div>
        <span>Loading details...</span>
      </div>
    ) : (
      <DataTable
        data={tabbedSectionData.clientlead.data[tabbedSectionData.clientlead.activeTab] || []}
        columns={
          tabbedSectionData.clientlead.data[tabbedSectionData.clientlead.activeTab]?.length > 0
            ? Object.keys(
                tabbedSectionData.clientlead.data[tabbedSectionData.clientlead.activeTab][0]
              ).map((key) => ({
                name: columnHeaderMap[key] || key.replace(/_/g, ' ').toUpperCase(),
                selector: (row) => row[key],
                sortable: true,
              }))
            : []
        }
        pagination
        highlightOnHover
        dense
      />
    )}

    <div className="mt-0 pt-0">
      <h3 className="text-lg font-bold text-gray-800 mb-2">Lead Data (Graph)</h3>
      <p className="text-sm text-slate-500 mb-3">Visual view of client-wise lead distribution.</p>
      <div className="bg-card-bg p-3 rounded-xl bg-white" style={{maxHeight:'315px'}}>
        <RechartsStackedBarChart data={dashboardData.clientgraph} />
      </div>
    </div>

</div>
</section> */}
</div>
</> 
)}


{(userType?.toUpperCase() === "ADMIN" || post?.toLowerCase() === "compliance_manager") && (
<section className="mt-4 mb-4">
  <div className="row g-3">
    {userType?.toUpperCase() === "ADMIN" && (
    <div className="col-12 col-xl-6">
      <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100 h-100">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="text-xl font-bold text-gray-800 mb-0">Client Contracts</h2>
          <span className="badge bg-primary-transparent text-primary px-3 py-2">Admin</span>
        </div>

        {licenseTrackerLoading ? (
          <div className="text-center text-muted py-4">Loading contracts tracker...</div>
        ) : (
          <>
            <div className="row g-2">
              <div className="col-12 col-md-4">
                <div className="rounded border p-3 bg-primary-transparent text-primary">
                  <div className="text-xs fw-semibold mb-1">Total Contracts</div>
                  <div className="fs-4 fw-bold">{Number(licenseTracker?.summary?.total_contracts || 0)}</div>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="rounded border p-3 bg-warning-transparent text-warning">
                  <div className="text-xs fw-semibold mb-1">Upcoming Expiry</div>
                  <div className="fs-4 fw-bold">{Number(licenseTracker?.summary?.upcoming_contracts || 0)}</div>
                  <small>(Next 2 months)</small>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="rounded border p-3 bg-danger-transparent text-danger">
                  <div className="text-xs fw-semibold mb-1">Expired Contracts</div>
                  <div className="fs-4 fw-bold">{Number(licenseTracker?.summary?.expired_contracts || 0)}</div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="rounded border p-3 bg-success-transparent text-success">
                  <div className="text-xs fw-semibold mb-1">Active Contracts</div>
                  <div className="fs-4 fw-bold">
                    {Math.max(
                      0,
                      Number(licenseTracker?.summary?.total_contracts || 0) -
                      Number(licenseTracker?.summary?.expired_contracts || 0)
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="rounded border p-3 bg-dark-transparent text-dark">
                  <div className="text-xs fw-semibold mb-1">High Risk (Due + Expired)</div>
                  <div className="fs-4 fw-bold">
                    {Number(licenseTracker?.summary?.upcoming_contracts || 0) +
                      Number(licenseTracker?.summary?.expired_contracts || 0)}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
    )}

    <div className={`col-12 ${userType?.toUpperCase() === "ADMIN" ? "col-xl-6" : ""}`}>
      <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100 h-100">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="text-xl font-bold text-gray-800 mb-0">Compliance Licenses</h2>
          <span className="badge bg-success-transparent text-success px-3 py-2">
            {post?.toLowerCase() === "compliance_manager" ? "Compliance Manager" : "Admin"}
          </span>
        </div>

        {licenseTrackerLoading ? (
          <div className="text-center text-muted py-4">Loading compliance tracker...</div>
        ) : (
          <>
            <div className="row g-2">
              <div className="col-12 col-md-4">
                <div className="rounded border p-3 bg-primary-transparent text-primary">
                  <div className="text-xs fw-semibold mb-1">Total Licenses</div>
                  <div className="fs-4 fw-bold">{Number(licenseTracker?.summary?.total_licenses || 0)}</div>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="rounded border p-3 bg-warning-transparent text-warning">
                  <div className="text-xs fw-semibold mb-1">Upcoming Expiry</div>
                  <div className="fs-4 fw-bold">{Number(licenseTracker?.summary?.upcoming_licenses || 0)}</div>
                  <small>(Next 2 months)</small>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="rounded border p-3 bg-danger-transparent text-danger">
                  <div className="text-xs fw-semibold mb-1">Expired Licenses</div>
                  <div className="fs-4 fw-bold">{Number(licenseTracker?.summary?.expired_licenses || 0)}</div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="rounded border p-3 bg-success-transparent text-success">
                  <div className="text-xs fw-semibold mb-1">Renewed</div>
                  <div className="fs-4 fw-bold">{Number(licenseTracker?.summary?.renewed_licenses || 0)}</div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="rounded border p-3 bg-dark-transparent text-dark">
                  <div className="text-xs fw-semibold mb-1">Not Renewed</div>
                  <div className="fs-4 fw-bold">{Number(licenseTracker?.summary?.not_renewed_licenses || 0)}</div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
</section>
)}

{(
  false &&
  (["business_associate", "business_manager", "accounts", "accounts_head", "admin"].includes(
    (post || "").toLowerCase()
  ) ||
  (userType || "").toUpperCase() === "ADMIN")
) && (
<section className="mt-4 mb-8">
  <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h2 className="text-xl font-bold text-gray-800 mb-0">Invoice Summary</h2>
      <span className="badge bg-primary-transparent text-primary px-3 py-2">
        Role: {(invoiceSummaryMeta.role || "-").toString().replace(/_/g, " ").toUpperCase()}
      </span>
    </div>

    <div className="d-flex flex-wrap gap-2 mb-3">
      <span className="badge bg-primary-transparent text-primary p-2">Total: {invoiceSummaryMeta.total}</span>
      <span className="badge bg-success-transparent text-success p-2">Paid: {invoiceSummaryMeta.paid}</span>
      <span className="badge bg-warning-transparent text-warning p-2">Pending: {invoiceSummaryMeta.pending}</span>
      <span className="badge bg-info-transparent text-info p-2">In Process: {invoiceSummaryMeta.in_process}</span>
      <span className="badge bg-danger-transparent text-danger p-2">Rejected: {invoiceSummaryMeta.rejected}</span>
    </div>

    <div className="table-responsive" style={{ maxHeight: "320px", overflowY: "auto" }}>
      <table className="table table-bordered mb-0 align-middle">
        <thead className="table-head-sky">
          <tr>
            <th style={{ width: "60px" }}>Sr no.</th>
            <th>Invoice No</th>
            <th>Client</th>
            <th>Amount</th>
            <th>Stage</th>
            <th>Created At</th>
            <th>Settled At</th>
            <th>Total TAT</th>
            <th>BA</th>
            <th>Manager</th>
          </tr>
        </thead>
        <tbody>
          {invoiceSummaryLoading ? (
            <tr>
              <td colSpan="10" className="text-center text-muted py-4">Loading...</td>
            </tr>
          ) : invoiceSummaryRows.length > 0 ? (
            invoiceSummaryRows.map((item, idx) => {
              const stageLabel = item.stage_label || "Processing";
              const isPaid = (item.decision || "").toLowerCase() === "paid";
              return (
                <tr key={item.id || idx}>
                  <td>{idx + 1}</td>
                  <td className="fw-semibold">{item.invoice_no || "-"}</td>
                  <td>{item.client_name || "-"}</td>
                  <td>{formatInvoiceAmount(item.invoice_amount)}</td>
                  <td>
                    <span className={`badge ${getInvoiceStageBadgeClass(stageLabel)} px-3 py-2`}>
                      {stageLabel}
                    </span>
                  </td>
                  <td>{formatInvoiceDateTime(item.created_at)}</td>
                  <td>{isPaid ? formatInvoiceDateTime(item.payment_updated_at) : "-"}</td>
                  <td>{isPaid ? formatInvoiceTat(item.created_at, item.payment_updated_at) : "Pending"}</td>
                  <td>{item.ba_name || "-"}</td>
                  <td>{item.manager_name || "-"}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="10" className="text-center text-muted py-4">No invoice records found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</section>
)}

{["accounts", "accounts_head", "business_manager"].includes(post?.toLowerCase()) && (
  <>
    <section className="w-full lg:flex-shrink space-y-4">
       
                <div className="bg-card-bg rounded-xl shadow-md border border-gray-100 p-3 bg-white">
      
         <div className='flex justify-content-between align-items-start mb-2'>
             <h2 className="text-xl font-bold text-gray-800 mb-0">Vendor Onboarding</h2>
      </div>

        <p className="text-sm text-slate-500 mb-3">Vendor onboarding status summary.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">         
            {dashboardData.vendor.map((stat, index) => (
                (() => {
                  const cardColor = resolveDashboardStatColor(stat.color, index);
                  const vendorGlyph = resolveVendorGlyph(stat.label);
                  return (
                <div
                    className="w-full p-3 rounded-2xl text-white relative overflow-hidden min-w-0"
                    key={index}
                    style={{
                      border: `1px solid ${cardColor}88`,
                      background: `linear-gradient(155deg, ${cardColor}ff 0%, ${cardColor}eb 52%, ${cardColor}88 100%)`,
                      boxShadow: `0 18px 36px ${cardColor}3a`,
                    }}
                >
                    <div
                      className="pointer-events-none absolute inset-x-0 top-0 h-20"
                      style={{
                        background: `linear-gradient(180deg, rgba(255,255,255,0.08) 0%, transparent 100%)`,
                      }}
                    />
                    <div
                      className="pointer-events-none absolute inset-0 opacity-100"
                      style={{
                        background: `radial-gradient(circle at top right, rgba(255,255,255,0.08) 0%, transparent 30%), linear-gradient(135deg, rgba(255,255,255,0.05) 0%, transparent 48%)`,
                      }}
                    />
                    <div
                      className="pointer-events-none absolute inset-x-6 top-0 h-[1px]"
                      style={{ background: `linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.95) 50%, transparent 100%)` }}
                    />
                    <span className="relative z-10 text-xs opacity-80 font-medium uppercase text-white">{stat.label}</span>
                    <div className="relative z-10 flex items-center justify-between">
                      <p className="text-2xl font-bold mt-1 text-white">{stat.count}</p>
                      <div
                        className="flex h-11 w-11 items-center justify-center rounded-2xl"
                        style={{
                          background: `linear-gradient(180deg, rgba(255,255,255,0.12) 0%, rgba(15,23,42,0.14) 100%)`,
                          border: `1px solid rgba(255,255,255,0.12)`,
                          boxShadow: `inset 0 1px 0 rgba(255,255,255,0.12), 0 8px 18px rgba(15,23,42,0.24)`,
                        }}
                      >
                        <DashboardStatGlyph type={vendorGlyph} className="h-6 w-6 text-white opacity-90" />
                      </div>
                    </div>
                </div>
                  );
                })()
              ))}
        </div>
      </div>
    </section>
 
  <section className="mt-4 mb-8">
    <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100">
      <h2 className="text-xl font-bold text-gray-800 mb-2">Meraqui Summary Dashboard</h2>
      <p className="text-sm text-slate-500 mb-3">External payroll and invoice summary.</p>
      <ExternalDashboard /* autoFetchOnMount */ />
    </div>
  </section>
   </>
)}

              </>
            )}

  </div>
        </div> 
        {/* END MAIN-CONTENT */}
    </>
);
}

export default Dashboard;
